var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 108,
    viewBox: "0 0 140 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 70.5336C55.1802 70.5336 55.1802 69.2701 55.1802 71.7742C55.1802 74.2783 58.5485 76.308 62.7027 76.308C66.857 76.308 70.2253 74.2783 70.2253 71.7742C70.2253 69.7927 70.2253 70.5336 70.2253 70.5336H55.1802Z",
    fill: "url(#paint0_linear_402_1371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 73.8493C65.0802 75.5437 60.3053 75.5358 57.3632 73.8382C54.4273 72.1438 54.4194 69.4017 57.3466 67.7072C60.2792 66.0096 65.0541 66.0017 68.0113 67.6962C70.9748 69.3938 70.9819 72.1517 68.0279 73.8493Z",
    fill: "url(#paint1_linear_402_1371)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 73.555C64.851 75.0881 60.5315 75.0818 57.8693 73.5463C55.2118 72.0131 55.2046 69.532 57.8542 67.9988C60.5078 66.4633 64.8273 66.457 67.5021 67.9901C70.1818 69.5257 70.1881 72.0203 67.5172 73.5558V73.555Z",
    fill: "#FFDB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 71.9615C63.8367 71.8168 63.8667 71.6682 63.8477 71.5195C63.8272 71.3614 63.7742 71.174 63.6912 70.9629L63.4121 70.2702L64.6574 69.5507C64.7072 69.5989 64.7412 69.648 64.757 69.6978C64.791 69.8006 64.7467 69.8907 64.6329 69.9563L64.4083 70.0939L65.7564 70.8672C66.166 70.5936 66.3423 70.3169 66.2822 70.0417C66.2245 69.7776 65.9233 69.4724 65.3848 69.1301L66.3178 68.5916L65.8355 68.3125L64.9009 68.8494C64.3925 68.5837 63.907 68.4279 63.4548 68.3876C62.9345 68.341 62.4672 68.439 62.0252 68.6881C61.6212 68.9158 61.5184 69.27 61.7129 69.7737L61.9722 70.4813C61.9778 70.4956 61.9825 70.5082 61.988 70.5225L60.2493 71.5211C60.1726 71.3922 60.1892 71.2301 60.485 71.0609L61.0448 70.7407L59.7204 69.988L59.3116 70.2188C58.7739 70.5217 58.5415 70.8332 58.6245 71.1424C58.6893 71.3883 58.9645 71.6713 59.442 71.986L58.4229 72.5711L58.9336 72.8581L59.9323 72.2809C60.5822 72.6407 61.1744 72.8265 61.6923 72.8328C62.2371 72.84 62.7771 72.6874 63.2966 72.3814C63.5259 72.2461 63.6809 72.1054 63.7592 71.9623L63.7584 71.9615ZM63.4453 69.3088C63.571 69.2368 63.7347 69.2083 63.9189 69.2265C63.998 69.2344 64.0778 69.251 64.1585 69.2763L63.2436 69.8021C63.2009 69.576 63.2682 69.4108 63.4453 69.3096V69.3088ZM61.157 71.9457C61.0076 71.9457 60.8518 71.9109 60.6905 71.8429L62.1493 71C62.1525 71.0135 62.1557 71.0261 62.1588 71.038C62.1857 71.1629 62.1683 71.2894 62.1059 71.4151C62.0426 71.5424 61.9058 71.6674 61.6979 71.7883C61.516 71.8935 61.3389 71.9457 61.157 71.9457Z",
    fill: "url(#paint2_linear_402_1371)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 69.2719C55.1802 69.2719 55.1802 68.0084 55.1802 70.5125C55.1802 73.0166 58.5485 75.0462 62.7027 75.0462C66.857 75.0462 70.2253 73.0166 70.2253 70.5125C70.2253 68.531 70.2253 69.2719 70.2253 69.2719H55.1802Z",
    fill: "url(#paint3_linear_402_1371)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 72.5895C65.0802 74.2839 60.3053 74.276 57.3632 72.5784C54.4273 70.884 54.4194 68.1419 57.3466 66.4475C60.2792 64.7499 65.0541 64.742 68.0113 66.4364C70.9748 68.134 70.9819 70.8919 68.0279 72.5895Z",
    fill: "url(#paint4_linear_402_1371)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 72.2952C64.851 73.8283 60.5315 73.822 57.8693 72.2865C55.2118 70.7534 55.2046 68.2722 57.8542 66.7391C60.5078 65.2036 64.8273 65.1972 67.5021 66.7304C70.1818 68.2659 70.1881 70.7597 67.5172 72.296V72.2952Z",
    fill: "#FFDB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 70.7017C63.8367 70.557 63.8667 70.4084 63.8477 70.2597C63.8272 70.1016 63.7742 69.9142 63.6912 69.7031L63.4121 69.0105L64.6574 68.2909C64.7072 68.3392 64.7412 68.3882 64.757 68.438C64.791 68.5408 64.7467 68.6309 64.6329 68.6966L64.4083 68.8341L65.7564 69.6074C66.166 69.3339 66.3423 69.0571 66.2822 68.782C66.2245 68.5179 65.9233 68.2127 65.3848 67.8703L66.3178 67.3318L65.8355 67.0527L64.9009 67.5896C64.3925 67.3239 63.907 67.1682 63.4548 67.1278C62.9345 67.0812 62.4672 67.1792 62.0252 67.4283C61.6212 67.656 61.5184 68.0102 61.7129 68.5139L61.9722 69.2216C61.9778 69.2358 61.9825 69.2485 61.988 69.2627L60.2493 70.2613C60.1726 70.1324 60.1892 69.9704 60.485 69.8011L61.0448 69.4809L59.7204 68.7282L59.3116 68.9591C58.7739 69.2619 58.5415 69.5734 58.6245 69.8826C58.6893 70.1285 58.9645 70.4116 59.442 70.7262L58.4229 71.3114L58.9336 71.5984L59.9323 71.0212C60.5822 71.3809 61.1744 71.5667 61.6923 71.5731C62.2371 71.5802 62.7771 71.4276 63.2966 71.1216C63.5259 70.9864 63.6809 70.8456 63.7592 70.7025L63.7584 70.7017ZM63.4453 68.049C63.571 67.977 63.7347 67.9486 63.9189 67.9668C63.998 67.9747 64.0778 67.9913 64.1585 68.0166L63.2436 68.5424C63.2009 68.317 63.2682 68.151 63.4453 68.0498V68.049ZM61.157 70.6859C61.0076 70.6859 60.8518 70.6511 60.6905 70.5831L62.1493 69.7403C62.1525 69.7537 62.1557 69.7664 62.1588 69.7782C62.1857 69.9031 62.1683 70.0304 62.1059 70.1554C62.0426 70.2827 61.9058 70.4076 61.6979 70.5286C61.516 70.6337 61.3389 70.6859 61.157 70.6859Z",
    fill: "url(#paint5_linear_402_1371)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 68.0102C55.1802 68.0102 55.1802 66.7467 55.1802 69.2508C55.1802 71.7548 58.5485 73.7845 62.7027 73.7845C66.857 73.7845 70.2253 71.7548 70.2253 69.2508C70.2253 67.2693 70.2253 68.0102 70.2253 68.0102H55.1802Z",
    fill: "url(#paint6_linear_402_1371)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 71.3278C65.0802 73.0222 60.3053 73.0143 57.3632 71.3167C54.4273 69.6223 54.4194 66.8802 57.3466 65.1858C60.2792 63.4882 65.0541 63.4803 68.0113 65.1747C70.9748 66.8723 70.9819 69.6302 68.0279 71.3278Z",
    fill: "url(#paint7_linear_402_1371)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 71.0335C64.851 72.5666 60.5315 72.5603 57.8693 71.0248C55.2118 69.4917 55.2046 67.0105 57.8542 65.4774C60.5078 63.9419 64.8273 63.9355 67.5021 65.4687C70.1818 67.0042 70.1881 69.4988 67.5172 71.0343V71.0335Z",
    fill: "#FFDB00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 69.44C63.8367 69.2953 63.8667 69.1467 63.8477 68.998C63.8272 68.8399 63.7742 68.6525 63.6912 68.4414L63.4121 67.7487L64.6574 67.0292C64.7072 67.0775 64.7412 67.1265 64.757 67.1763C64.791 67.2791 64.7467 67.3692 64.6329 67.4348L64.4083 67.5724L65.7564 68.3457C66.166 68.0721 66.3423 67.7954 66.2822 67.5202C66.2245 67.2562 65.9233 66.9509 65.3848 66.6086L66.3178 66.0701L65.8355 65.791L64.9009 66.3279C64.3925 66.0622 63.907 65.9065 63.4548 65.8661C62.9345 65.8195 62.4672 65.9175 62.0252 66.1666C61.6212 66.3943 61.5184 66.7485 61.7129 67.2522L61.9722 67.9599C61.9778 67.9741 61.9825 67.9867 61.988 68.001L60.2493 68.9996C60.1726 68.8707 60.1892 68.7086 60.485 68.5394L61.0448 68.2192L59.7204 67.4665L59.3116 67.6974C58.7739 68.0002 58.5415 68.3117 58.6245 68.6209C58.6893 68.8668 58.9645 69.1498 59.442 69.4645L58.4229 70.0496L58.9336 70.3367L59.9323 69.7595C60.5822 70.1192 61.1744 70.305 61.6923 70.3113C62.2371 70.3185 62.7771 70.1659 63.2966 69.8599C63.5259 69.7247 63.6809 69.5839 63.7592 69.4408L63.7584 69.44ZM63.4453 66.7873C63.571 66.7153 63.7347 66.6869 63.9189 66.705C63.998 66.713 64.0778 66.7296 64.1585 66.7549L63.2436 67.2807C63.2009 67.0553 63.2682 66.8893 63.4453 66.7881V66.7873ZM61.157 69.4242C61.0076 69.4242 60.8518 69.3894 60.6905 69.3214L62.1493 68.4785C62.1525 68.492 62.1557 68.5046 62.1588 68.5165C62.1857 68.6414 62.1683 68.7679 62.1059 68.8937C62.0426 69.021 61.9058 69.1459 61.6979 69.2669C61.516 69.372 61.3389 69.4242 61.157 69.4242Z",
    fill: "url(#paint8_linear_402_1371)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 66.7485C55.1802 66.7485 55.1802 65.4849 55.1802 67.989C55.1802 70.4931 58.5485 72.5228 62.7027 72.5228C66.857 72.5228 70.2253 70.4931 70.2253 67.989C70.2253 66.0076 70.2253 66.7485 70.2253 66.7485H55.1802Z",
    fill: "url(#paint9_linear_402_1371)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 70.068C65.0802 71.7625 60.3053 71.7545 57.3632 70.0569C54.4273 68.3625 54.4194 65.6204 57.3466 63.926C60.2792 62.2284 65.0541 62.2205 68.0113 63.9149C70.9748 65.6125 70.9819 68.3704 68.0279 70.068Z",
    fill: "url(#paint10_linear_402_1371)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 69.7737C64.851 71.3069 60.5315 71.3005 57.8693 69.765C55.2118 68.2319 55.2046 65.7507 57.8542 64.2176C60.5078 62.6821 64.8273 62.6758 67.5021 64.2089C70.1818 65.7444 70.1881 68.239 67.5172 69.7745V69.7737Z",
    fill: "#FFDB00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 68.1803C63.8367 68.0356 63.8667 67.8869 63.8477 67.7383C63.8272 67.5801 63.7742 67.3927 63.6912 67.1816L63.4121 66.489L64.6574 65.7695C64.7072 65.8177 64.7412 65.8667 64.757 65.9165C64.791 66.0193 64.7467 66.1095 64.6329 66.1751L64.4083 66.3127L65.7564 67.0859C66.166 66.8124 66.3423 66.5356 66.2822 66.2605C66.2245 65.9964 65.9233 65.6912 65.3848 65.3488L66.3178 64.8104L65.8355 64.5312L64.9009 65.0681C64.3925 64.8025 63.907 64.6467 63.4548 64.6064C62.9345 64.5597 62.4672 64.6578 62.0252 64.9068C61.6212 65.1345 61.5184 65.4888 61.7129 65.9924L61.9722 66.7001C61.9778 66.7143 61.9825 66.727 61.988 66.7412L60.2493 67.7398C60.1726 67.611 60.1892 67.4489 60.485 67.2797L61.0448 66.9594L59.7204 66.2067L59.3116 66.4376C58.7739 66.7404 58.5415 67.0519 58.6245 67.3611C58.6893 67.607 58.9645 67.8901 59.442 68.2048L58.4229 68.7899L58.9336 69.0769L59.9323 68.4997C60.5822 68.8594 61.1744 69.0453 61.6923 69.0516C62.2371 69.0587 62.7771 68.9061 63.2966 68.6001C63.5259 68.4649 63.6809 68.3242 63.7592 68.181L63.7584 68.1803ZM63.4453 65.5275C63.571 65.4556 63.7347 65.4271 63.9189 65.4453C63.998 65.4532 64.0778 65.4698 64.1585 65.4951L63.2436 66.0209C63.2009 65.7948 63.2682 65.6295 63.4453 65.5283V65.5275ZM61.157 68.1644C61.0076 68.1644 60.8518 68.1296 60.6905 68.0617L62.1493 67.2188C62.1525 67.2322 62.1557 67.2449 62.1588 67.2567C62.1857 67.3817 62.1683 67.5082 62.1059 67.6339C62.0426 67.7612 61.9058 67.8861 61.6979 68.0071C61.516 68.1123 61.3389 68.1644 61.157 68.1644Z",
    fill: "url(#paint11_linear_402_1371)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 65.4887C55.1802 65.4887 55.1802 64.2252 55.1802 66.7293C55.1802 69.2334 58.5485 71.263 62.7027 71.263C66.857 71.263 70.2253 69.2334 70.2253 66.7293C70.2253 64.7478 70.2253 65.4887 70.2253 65.4887H55.1802Z",
    fill: "url(#paint12_linear_402_1371)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 68.8043C65.0802 70.4988 60.3053 70.4909 57.3632 68.7933C54.4273 67.0988 54.4194 64.3568 57.3466 62.6623C60.2792 60.9647 65.0541 60.9568 68.0113 62.6513C70.9748 64.3488 70.9819 67.1068 68.0279 68.8043Z",
    fill: "url(#paint13_linear_402_1371)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 68.51C64.851 70.0432 60.5315 70.0369 57.8693 68.5014C55.2118 66.9682 55.2046 64.4871 57.8542 62.9539C60.5078 61.4184 64.8273 61.4121 67.5021 62.9452C70.1818 64.4807 70.1881 66.9753 67.5172 68.5108V68.51Z",
    fill: "#FFDB00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 66.9185C63.8367 66.7738 63.8667 66.6252 63.8477 66.4765C63.8272 66.3184 63.7742 66.131 63.6912 65.9199L63.4121 65.2273L64.6574 64.5077C64.7072 64.556 64.7412 64.605 64.757 64.6548C64.791 64.7576 64.7467 64.8477 64.6329 64.9134L64.4083 65.0509L65.7564 65.8242C66.166 65.5507 66.3423 65.2739 66.2822 64.9988C66.2245 64.7347 65.9233 64.4295 65.3848 64.0871L66.3178 63.5486L65.8355 63.2695L64.9009 63.8064C64.3925 63.5407 63.907 63.385 63.4548 63.3446C62.9345 63.298 62.4672 63.396 62.0252 63.6451C61.6212 63.8728 61.5184 64.2271 61.7129 64.7307L61.9722 65.4384C61.9778 65.4526 61.9825 65.4653 61.988 65.4795L60.2493 66.4781C60.1726 66.3492 60.1892 66.1872 60.485 66.0179L61.0448 65.6977L59.7204 64.945L59.3116 65.1759C58.7739 65.4787 58.5415 65.7902 58.6245 66.0994C58.6893 66.3453 58.9645 66.6284 59.442 66.943L58.4229 67.5282L58.9336 67.8152L59.9323 67.238C60.5822 67.5977 61.1744 67.7835 61.6923 67.7899C62.2371 67.797 62.7771 67.6444 63.2966 67.3384C63.5259 67.2032 63.6809 67.0624 63.7592 66.9193L63.7584 66.9185ZM63.4453 64.2658C63.571 64.1938 63.7347 64.1654 63.9189 64.1836C63.998 64.1915 64.0778 64.2081 64.1585 64.2334L63.2436 64.7592C63.2009 64.533 63.2682 64.3678 63.4453 64.2666V64.2658ZM61.157 66.9027C61.0076 66.9027 60.8518 66.8679 60.6905 66.7999L62.1493 65.9571C62.1525 65.9705 62.1557 65.9832 62.1588 65.995C62.1857 66.1199 62.1683 66.2465 62.1059 66.3722C62.0426 66.4995 61.9058 66.6244 61.6979 66.7454C61.516 66.8505 61.3389 66.9027 61.157 66.9027Z",
    fill: "url(#paint14_linear_402_1371)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 64.227C55.1802 64.227 55.1802 62.9635 55.1802 65.4675C55.1802 67.9716 58.5485 70.0013 62.7027 70.0013C66.857 70.0013 70.2253 67.9716 70.2253 65.4675C70.2253 63.4861 70.2253 64.227 70.2253 64.227H55.1802Z",
    fill: "url(#paint15_linear_402_1371)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 67.5446C65.0802 69.239 60.3053 69.2311 57.3632 67.5335C54.4273 65.8391 54.4194 63.097 57.3466 61.4026C60.2792 59.705 65.0541 59.6971 68.0113 61.3915C70.9748 63.0891 70.9819 65.847 68.0279 67.5446Z",
    fill: "url(#paint16_linear_402_1371)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 67.2503C64.851 68.7834 60.5315 68.7771 57.8693 67.2416C55.2118 65.7085 55.2046 63.2273 57.8542 61.6942C60.5078 60.1587 64.8273 60.1523 67.5021 61.6855C70.1818 63.221 70.1881 65.7156 67.5172 67.2511V67.2503Z",
    fill: "#FFDB00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 65.6588C63.8367 65.5141 63.8667 65.3654 63.8477 65.2168C63.8272 65.0586 63.7742 64.8712 63.6912 64.6601L63.4121 63.9675L64.6574 63.248C64.7072 63.2962 64.7412 63.3452 64.757 63.395C64.791 63.4978 64.7467 63.588 64.6329 63.6536L64.4083 63.7912L65.7564 64.5645C66.166 64.2909 66.3423 64.0142 66.2822 63.739C66.2245 63.4749 65.9233 63.1697 65.3848 62.8273L66.3178 62.2889L65.8355 62.0098L64.9009 62.5466C64.3925 62.281 63.907 62.1252 63.4548 62.0849C62.9345 62.0382 62.4672 62.1363 62.0252 62.3853C61.6212 62.6131 61.5184 62.9673 61.7129 63.471L61.9722 64.1786C61.9778 64.1928 61.9825 64.2055 61.988 64.2197L60.2493 65.2184C60.1726 65.0895 60.1892 64.9274 60.485 64.7582L61.0448 64.438L59.7204 63.6852L59.3116 63.9161C58.7739 64.2189 58.5415 64.5305 58.6245 64.8396C58.6893 65.0855 58.9645 65.3686 59.442 65.6833L58.4229 66.2684L58.9336 66.5554L59.9323 65.9782C60.5822 66.338 61.1744 66.5238 61.6923 66.5301C62.2371 66.5372 62.7771 66.3846 63.2966 66.0786C63.5259 65.9434 63.6809 65.8027 63.7592 65.6596L63.7584 65.6588ZM63.4453 63.006C63.571 62.9341 63.7347 62.9056 63.9189 62.9238C63.998 62.9317 64.0778 62.9483 64.1585 62.9736L63.2436 63.4994C63.2009 63.2733 63.2682 63.108 63.4453 63.0068V63.006ZM61.157 65.643C61.0076 65.643 60.8518 65.6082 60.6905 65.5402L62.1493 64.6973C62.1525 64.7107 62.1557 64.7234 62.1588 64.7353C62.1857 64.8602 62.1683 64.9875 62.1059 65.1124C62.0426 65.2397 61.9058 65.3646 61.6979 65.4856C61.516 65.5908 61.3389 65.643 61.157 65.643Z",
    fill: "url(#paint17_linear_402_1371)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 62.9672C55.1802 62.9672 55.1802 61.7037 55.1802 64.2078C55.1802 66.7119 58.5485 68.7416 62.7027 68.7416C66.857 68.7416 70.2253 66.7119 70.2253 64.2078C70.2253 62.2263 70.2253 62.9672 70.2253 62.9672H55.1802Z",
    fill: "url(#paint18_linear_402_1371)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 66.2848C65.0802 67.9793 60.3053 67.9713 57.3632 66.2737C54.4273 64.5793 54.4194 61.8372 57.3466 60.1428C60.2792 58.4452 65.0541 58.4373 68.0113 60.1317C70.9748 61.8293 70.9819 64.5872 68.0279 66.2848Z",
    fill: "url(#paint19_linear_402_1371)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 65.9905C64.851 67.5237 60.5315 67.5173 57.8693 65.9818C55.2118 64.4487 55.2046 61.9675 57.8542 60.4344C60.5078 58.8989 64.8273 58.8926 67.5021 60.4257C70.1818 61.9612 70.1881 64.4558 67.5172 65.9913V65.9905Z",
    fill: "#FFDB00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 64.397C63.8367 64.2524 63.8667 64.1037 63.8477 63.9551C63.8272 63.7969 63.7742 63.6095 63.6912 63.3984L63.4121 62.7058L64.6574 61.9863C64.7072 62.0345 64.7412 62.0835 64.757 62.1333C64.791 62.2361 64.7467 62.3262 64.6329 62.3919L64.4083 62.5295L65.7564 63.3027C66.166 63.0292 66.3423 62.7524 66.2822 62.4773C66.2245 62.2132 65.9233 61.908 65.3848 61.5656L66.3178 61.0272L65.8355 60.748L64.9009 61.2849C64.3925 61.0192 63.907 60.8635 63.4548 60.8232C62.9345 60.7765 62.4672 60.8746 62.0252 61.1236C61.6212 61.3513 61.5184 61.7056 61.7129 62.2092L61.9722 62.9169C61.9778 62.9311 61.9825 62.9438 61.988 62.958L60.2493 63.9566C60.1726 63.8278 60.1892 63.6657 60.485 63.4965L61.0448 63.1762L59.7204 62.4235L59.3116 62.6544C58.7739 62.9572 58.5415 63.2687 58.6245 63.5779C58.6893 63.8238 58.9645 64.1069 59.442 64.4216L58.4229 65.0067L58.9336 65.2937L59.9323 64.7165C60.5822 65.0762 61.1744 65.2621 61.6923 65.2684C62.2371 65.2755 62.7771 65.1229 63.2966 64.8169C63.5259 64.6817 63.6809 64.541 63.7592 64.3978L63.7584 64.397ZM63.4453 61.7443C63.571 61.6724 63.7347 61.6439 63.9189 61.6621C63.998 61.67 64.0778 61.6866 64.1585 61.7119L63.2436 62.2377C63.2009 62.0116 63.2682 61.8463 63.4453 61.7451V61.7443ZM61.157 64.3812C61.0076 64.3812 60.8518 64.3464 60.6905 64.2784L62.1493 63.4356C62.1525 63.449 62.1557 63.4617 62.1588 63.4735C62.1857 63.5985 62.1683 63.7258 62.1059 63.8507C62.0426 63.978 61.9058 64.1029 61.6979 64.2239C61.516 64.329 61.3389 64.3812 61.157 64.3812Z",
    fill: "url(#paint20_linear_402_1371)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 61.7074C55.1802 61.7074 55.1802 60.4439 55.1802 62.948C55.1802 65.4521 58.5485 67.4818 62.7027 67.4818C66.857 67.4818 70.2253 65.4521 70.2253 62.948C70.2253 60.9666 70.2253 61.7074 70.2253 61.7074H55.1802Z",
    fill: "url(#paint21_linear_402_1371)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 65.025C65.0802 66.7195 60.3053 66.7116 57.3632 65.014C54.4273 63.3195 54.4194 60.5775 57.3466 58.883C60.2792 57.1854 65.0541 57.1775 68.0113 58.872C70.9748 60.5696 70.9819 63.3275 68.0279 65.025Z",
    fill: "url(#paint22_linear_402_1371)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 64.7308C64.851 66.2639 60.5315 66.2576 57.8693 64.7221C55.2118 63.1889 55.2046 60.7078 57.8542 59.1746C60.5078 57.6391 64.8273 57.6328 67.5021 59.1659C70.1818 60.7014 70.1881 63.1952 67.5172 64.7315V64.7308Z",
    fill: "#FFDB00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 63.1373C63.8367 62.9926 63.8667 62.8439 63.8477 62.6953C63.8272 62.5372 63.7742 62.3498 63.6912 62.1387L63.4121 61.446L64.6574 60.7265C64.7072 60.7747 64.7412 60.8237 64.757 60.8736C64.791 60.9763 64.7467 61.0665 64.6329 61.1321L64.4083 61.2697L65.7564 62.043C66.166 61.7694 66.3423 61.4927 66.2822 61.2175C66.2245 60.9534 65.9233 60.6482 65.3848 60.3058L66.3178 59.7674L65.8355 59.4883L64.9009 60.0252C64.3925 59.7595 63.907 59.6037 63.4548 59.5634C62.9345 59.5167 62.4672 59.6148 62.0252 59.8639C61.6212 60.0916 61.5184 60.4458 61.7129 60.9495L61.9722 61.6571C61.9778 61.6714 61.9825 61.684 61.988 61.6982L60.2493 62.6969C60.1726 62.568 60.1892 62.4059 60.485 62.2367L61.0448 61.9165L59.7204 61.1637L59.3116 61.3946C58.7739 61.6974 58.5415 62.009 58.6245 62.3181C58.6893 62.564 58.9645 62.8471 59.442 63.1618L58.4229 63.7469L58.9336 64.0339L59.9323 63.4567C60.5822 63.8165 61.1744 64.0023 61.6923 64.0086C62.2371 64.0157 62.7771 63.8631 63.2966 63.5571C63.5259 63.4219 63.6809 63.2812 63.7592 63.1381L63.7584 63.1373ZM63.4453 60.4845C63.571 60.4126 63.7347 60.3841 63.9189 60.4023C63.998 60.4102 64.0778 60.4268 64.1585 60.4521L63.2436 60.9779C63.2009 60.7526 63.2682 60.5865 63.4453 60.4853V60.4845ZM61.157 63.1215C61.0076 63.1215 60.8518 63.0867 60.6905 63.0187L62.1493 62.1758C62.1525 62.1893 62.1557 62.2019 62.1588 62.2138C62.1857 62.3387 62.1683 62.466 62.1059 62.5909C62.0426 62.7182 61.9058 62.8432 61.6979 62.9641C61.516 63.0693 61.3389 63.1215 61.157 63.1215Z",
    fill: "url(#paint23_linear_402_1371)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 60.4418C55.1802 60.4418 55.1802 59.1783 55.1802 61.6824C55.1802 64.1865 58.5485 66.2162 62.7027 66.2162C66.857 66.2162 70.2253 64.1865 70.2253 61.6824C70.2253 59.7009 70.2253 60.4418 70.2253 60.4418H55.1802Z",
    fill: "url(#paint24_linear_402_1371)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 63.7594C65.0802 65.4539 60.3053 65.4459 57.3632 63.7484C54.4273 62.0539 54.4194 59.3118 57.3466 57.6174C60.2792 55.9198 65.0541 55.9119 68.0113 57.6063C70.9748 59.3039 70.9819 62.0618 68.0279 63.7594Z",
    fill: "url(#paint25_linear_402_1371)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 63.4651C64.851 64.9983 60.5315 64.9919 57.8693 63.4564C55.2118 61.9233 55.2046 59.4421 57.8542 57.909C60.5078 56.3735 64.8273 56.3672 67.5021 57.9003C70.1818 59.4358 70.1881 61.9304 67.5172 63.4659V63.4651Z",
    fill: "#FFDB00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 61.8717C63.8367 61.727 63.8667 61.5783 63.8477 61.4297C63.8272 61.2715 63.7742 61.0841 63.6912 60.873L63.4121 60.1804L64.6574 59.4609C64.7072 59.5091 64.7412 59.5581 64.757 59.6079C64.791 59.7107 64.7467 59.8009 64.6329 59.8665L64.4083 60.0041L65.7564 60.7774C66.166 60.5038 66.3423 60.227 66.2822 59.9519C66.2245 59.6878 65.9233 59.3826 65.3848 59.0402L66.3178 58.5018L65.8355 58.2227L64.9009 58.7595C64.3925 58.4939 63.907 58.3381 63.4548 58.2978C62.9345 58.2511 62.4672 58.3492 62.0252 58.5982C61.6212 58.8259 61.5184 59.1802 61.7129 59.6838L61.9722 60.3915C61.9778 60.4057 61.9825 60.4184 61.988 60.4326L60.2493 61.4312C60.1726 61.3024 60.1892 61.1403 60.485 60.9711L61.0448 60.6508L59.7204 59.8981L59.3116 60.129C58.7739 60.4318 58.5415 60.7434 58.6245 61.0525C58.6893 61.2984 58.9645 61.5815 59.442 61.8962L58.4229 62.4813L58.9336 62.7683L59.9323 62.1911C60.5822 62.5509 61.1744 62.7367 61.6923 62.743C62.2371 62.7501 62.7771 62.5975 63.2966 62.2915C63.5259 62.1563 63.6809 62.0156 63.7592 61.8725L63.7584 61.8717ZM63.4453 59.2189C63.571 59.147 63.7347 59.1185 63.9189 59.1367C63.998 59.1446 64.0778 59.1612 64.1585 59.1865L63.2436 59.7123C63.2009 59.487 63.2682 59.3209 63.4453 59.2197V59.2189ZM61.157 61.8558C61.0076 61.8558 60.8518 61.8211 60.6905 61.7531L62.1493 60.9102C62.1525 60.9236 62.1557 60.9363 62.1588 60.9481C62.1857 61.0731 62.1683 61.2004 62.1059 61.3253C62.0426 61.4526 61.9058 61.5775 61.6979 61.6985C61.516 61.8037 61.3389 61.8558 61.157 61.8558Z",
    fill: "url(#paint26_linear_402_1371)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 59.182C55.1802 59.182 55.1802 57.9185 55.1802 60.4226C55.1802 62.9267 58.5485 64.9564 62.7027 64.9564C66.857 64.9564 70.2253 62.9267 70.2253 60.4226C70.2253 58.4412 70.2253 59.182 70.2253 59.182H55.1802Z",
    fill: "url(#paint27_linear_402_1371)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 62.4997C65.0802 64.1941 60.3053 64.1862 57.3632 62.4886C54.4273 60.7942 54.4194 58.0521 57.3466 56.3576C60.2792 54.66 65.0541 54.6521 68.0113 56.3466C70.9748 58.0442 70.9819 60.8021 68.0279 62.4997Z",
    fill: "url(#paint28_linear_402_1371)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 62.2054C64.851 63.7385 60.5315 63.7322 57.8693 62.1967C55.2118 60.6635 55.2046 58.1824 57.8542 56.6492C60.5078 55.1137 64.8273 55.1074 67.5021 56.6405C70.1818 58.176 70.1881 60.6706 67.5172 62.2062V62.2054Z",
    fill: "#FFDB00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 60.6119C63.8367 60.4672 63.8667 60.3185 63.8477 60.1699C63.8272 60.0118 63.7742 59.8244 63.6912 59.6133L63.4121 58.9206L64.6574 58.2011C64.7072 58.2493 64.7412 58.2984 64.757 58.3482C64.791 58.451 64.7467 58.5411 64.6329 58.6067L64.4083 58.7443L65.7564 59.5176C66.166 59.244 66.3423 58.9673 66.2822 58.6921C66.2245 58.428 65.9233 58.1228 65.3848 57.7805L66.3178 57.242L65.8355 56.9629L64.9009 57.4998C64.3925 57.2341 63.907 57.0783 63.4548 57.038C62.9345 56.9914 62.4672 57.0894 62.0252 57.3385C61.6212 57.5662 61.5184 57.9204 61.7129 58.4241L61.9722 59.1317C61.9778 59.146 61.9825 59.1586 61.988 59.1729L60.2493 60.1715C60.1726 60.0426 60.1892 59.8805 60.485 59.7113L61.0448 59.3911L59.7204 58.6383L59.3116 58.8692C58.7739 59.1721 58.5415 59.4836 58.6245 59.7927C58.6893 60.0387 58.9645 60.3217 59.442 60.6364L58.4229 61.2215L58.9336 61.5085L59.9323 60.9313C60.5822 61.2911 61.1744 61.4769 61.6923 61.4832C62.2371 61.4903 62.7771 61.3377 63.2966 61.0317C63.5259 60.8965 63.6809 60.7558 63.7592 60.6127L63.7584 60.6119ZM63.4453 57.9592C63.571 57.8872 63.7347 57.8587 63.9189 57.8769C63.998 57.8848 64.0778 57.9014 64.1585 57.9267L63.2436 58.4525C63.2009 58.2272 63.2682 58.0612 63.4453 57.9599V57.9592ZM61.157 60.5961C61.0076 60.5961 60.8518 60.5613 60.6905 60.4933L62.1493 59.6504C62.1525 59.6639 62.1557 59.6765 62.1588 59.6884C62.1857 59.8133 62.1683 59.9406 62.1059 60.0655C62.0426 60.1928 61.9058 60.3178 61.6979 60.4387C61.516 60.5439 61.3389 60.5961 61.157 60.5961Z",
    fill: "url(#paint29_linear_402_1371)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 57.9203C55.1802 57.9203 55.1802 56.6568 55.1802 59.1609C55.1802 61.665 58.5485 63.6947 62.7027 63.6947C66.857 63.6947 70.2253 61.665 70.2253 59.1609C70.2253 57.1795 70.2253 57.9203 70.2253 57.9203H55.1802Z",
    fill: "url(#paint30_linear_402_1371)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 61.236C65.0802 62.9304 60.3053 62.9225 57.3632 61.2249C54.4273 59.5305 54.4194 56.7884 57.3466 55.094C60.2792 53.3964 65.0541 53.3885 68.0113 55.0829C70.9748 56.7805 70.9819 59.5384 68.0279 61.236Z",
    fill: "url(#paint31_linear_402_1371)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 60.9417C64.851 62.4748 60.5315 62.4685 57.8693 60.933C55.2118 59.3999 55.2046 56.9187 57.8542 55.3856C60.5078 53.8501 64.8273 53.8437 67.5021 55.3769C70.1818 56.9124 70.1881 59.407 67.5172 60.9425V60.9417Z",
    fill: "#FFDB00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 59.3502C63.8367 59.2055 63.8667 59.0568 63.8477 58.9082C63.8272 58.75 63.7742 58.5626 63.6912 58.3515L63.4121 57.6589L64.6574 56.9394C64.7072 56.9876 64.7412 57.0366 64.757 57.0864C64.791 57.1892 64.7467 57.2794 64.6329 57.345L64.4083 57.4826L65.7564 58.2559C66.166 57.9823 66.3423 57.7056 66.2822 57.4304C66.2245 57.1663 65.9233 56.8611 65.3848 56.5187L66.3178 55.9803L65.8355 55.7012L64.9009 56.238C64.3925 55.9724 63.907 55.8166 63.4548 55.7763C62.9345 55.7296 62.4672 55.8277 62.0252 56.0767C61.6212 56.3045 61.5184 56.6587 61.7129 57.1624L61.9722 57.87C61.9778 57.8842 61.9825 57.8969 61.988 57.9111L60.2493 58.9098C60.1726 58.7809 60.1892 58.6188 60.485 58.4496L61.0448 58.1294L59.7204 57.3766L59.3116 57.6075C58.7739 57.9103 58.5415 58.2219 58.6245 58.531C58.6893 58.7769 58.9645 59.06 59.442 59.3747L58.4229 59.9598L58.9336 60.2468L59.9323 59.6696C60.5822 60.0294 61.1744 60.2152 61.6923 60.2215C62.2371 60.2286 62.7771 60.076 63.2966 59.77C63.5259 59.6348 63.6809 59.4941 63.7592 59.351L63.7584 59.3502ZM63.4453 56.6974C63.571 56.6255 63.7347 56.597 63.9189 56.6152C63.998 56.6231 64.0778 56.6397 64.1585 56.665L63.2436 57.1908C63.2009 56.9647 63.2682 56.7994 63.4453 56.6982V56.6974ZM61.157 59.3344C61.0076 59.3344 60.8518 59.2996 60.6905 59.2316L62.1493 58.3887C62.1525 58.4021 62.1557 58.4148 62.1588 58.4267C62.1857 58.5516 62.1683 58.6781 62.1059 58.8038C62.0426 58.9311 61.9058 59.056 61.6979 59.177C61.516 59.2822 61.3389 59.3344 61.157 59.3344Z",
    fill: "url(#paint32_linear_402_1371)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 56.6586C55.1802 56.6586 55.1802 55.3951 55.1802 57.8992C55.1802 60.4033 58.5485 62.433 62.7027 62.433C66.857 62.433 70.2253 60.4033 70.2253 57.8992C70.2253 55.9177 70.2253 56.6586 70.2253 56.6586H55.1802Z",
    fill: "url(#paint33_linear_402_1371)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 59.9762C65.0802 61.6707 60.3053 61.6627 57.3632 59.9652C54.4273 58.2707 54.4194 55.5286 57.3466 53.8342C60.2792 52.1366 65.0541 52.1287 68.0113 53.8231C70.9748 55.5207 70.9819 58.2786 68.0279 59.9762Z",
    fill: "url(#paint34_linear_402_1371)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 59.6819C64.851 61.2151 60.5315 61.2087 57.8693 59.6732C55.2118 58.1401 55.2046 55.6589 57.8542 54.1258C60.5078 52.5903 64.8273 52.584 67.5021 54.1171C70.1818 55.6526 70.1881 58.1472 67.5172 59.6827V59.6819Z",
    fill: "#FFDB00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 58.0904C63.8367 57.9457 63.8667 57.7971 63.8477 57.6484C63.8272 57.4903 63.7742 57.3029 63.6912 57.0918L63.4121 56.3991L64.6574 55.6796C64.7072 55.7278 64.7412 55.7769 64.757 55.8267C64.791 55.9295 64.7467 56.0196 64.6329 56.0852L64.4083 56.2228L65.7564 56.9961C66.166 56.7225 66.3423 56.4458 66.2822 56.1706C66.2245 55.9065 65.9233 55.6013 65.3848 55.259L66.3178 54.7205L65.8355 54.4414L64.9009 54.9783C64.3925 54.7126 63.907 54.5568 63.4548 54.5165C62.9345 54.4699 62.4672 54.5679 62.0252 54.817C61.6212 55.0447 61.5184 55.3989 61.7129 55.9026L61.9722 56.6102C61.9778 56.6245 61.9825 56.6371 61.988 56.6514L60.2493 57.65C60.1726 57.5211 60.1892 57.359 60.485 57.1898L61.0448 56.8696L59.7204 56.1169L59.3116 56.3477C58.7739 56.6506 58.5415 56.9621 58.6245 57.2713C58.6893 57.5172 58.9645 57.8002 59.442 58.1149L58.4229 58.7L58.9336 58.987L59.9323 58.4098C60.5822 58.7696 61.1744 58.9554 61.6923 58.9617C62.2371 58.9689 62.7771 58.8163 63.2966 58.5103C63.5259 58.3751 63.6809 58.2343 63.7592 58.0912L63.7584 58.0904ZM63.4453 55.4377C63.571 55.3657 63.7347 55.3372 63.9189 55.3554C63.998 55.3633 64.0778 55.3799 64.1585 55.4052L63.2436 55.9311C63.2009 55.7049 63.2682 55.5397 63.4453 55.4385V55.4377ZM61.157 58.0746C61.0076 58.0746 60.8518 58.0398 60.6905 57.9718L62.1493 57.1289C62.1525 57.1424 62.1557 57.155 62.1588 57.1669C62.1857 57.2918 62.1683 57.4183 62.1059 57.544C62.0426 57.6713 61.9058 57.7963 61.6979 57.9172C61.516 58.0224 61.3389 58.0746 61.157 58.0746Z",
    fill: "url(#paint35_linear_402_1371)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 55.3969C55.1802 55.3969 55.1802 54.1334 55.1802 56.6375C55.1802 59.1416 58.5485 61.1712 62.7027 61.1712C66.857 61.1712 70.2253 59.1416 70.2253 56.6375C70.2253 54.656 70.2253 55.3969 70.2253 55.3969H55.1802Z",
    fill: "url(#paint36_linear_402_1371)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 58.7145C65.0802 60.4089 60.3053 60.401 57.3632 58.7034C54.4273 57.009 54.4194 54.2669 57.3466 52.5725C60.2792 50.8749 65.0541 50.867 68.0113 52.5614C70.9748 54.259 70.9819 57.0169 68.0279 58.7145Z",
    fill: "url(#paint37_linear_402_1371)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 58.4202C64.851 59.9533 60.5315 59.947 57.8693 58.4115C55.2118 56.8784 55.2046 54.3972 57.8542 52.8641C60.5078 51.3286 64.8273 51.3222 67.5021 52.8554C70.1818 54.3909 70.1881 56.8855 67.5172 58.421V58.4202Z",
    fill: "#FFDB00"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 56.8267C63.8367 56.682 63.8667 56.5334 63.8477 56.3847C63.8272 56.2266 63.7742 56.0392 63.6912 55.8281L63.4121 55.1355L64.6574 54.4159C64.7072 54.4642 64.7412 54.5132 64.757 54.563C64.791 54.6658 64.7467 54.7559 64.6329 54.8216L64.4083 54.9591L65.7564 55.7324C66.166 55.4589 66.3423 55.1821 66.2822 54.907C66.2245 54.6429 65.9233 54.3377 65.3848 53.9953L66.3178 53.4568L65.8355 53.1777L64.9009 53.7146C64.3925 53.4489 63.907 53.2932 63.4548 53.2529C62.9345 53.2062 62.4672 53.3042 62.0252 53.5533C61.6212 53.781 61.5184 54.1353 61.7129 54.6389L61.9722 55.3466C61.9778 55.3608 61.9825 55.3735 61.988 55.3877L60.2493 56.3863C60.1726 56.2574 60.1892 56.0954 60.485 55.9261L61.0448 55.6059L59.7204 54.8532L59.3116 55.0841C58.7739 55.3869 58.5415 55.6984 58.6245 56.0076C58.6893 56.2535 58.9645 56.5366 59.442 56.8512L58.4229 57.4364L58.9336 57.7234L59.9323 57.1462C60.5822 57.5059 61.1744 57.6917 61.6923 57.6981C62.2371 57.7052 62.7771 57.5526 63.2966 57.2466C63.5259 57.1114 63.6809 56.9706 63.7592 56.8275L63.7584 56.8267ZM63.4453 54.174C63.571 54.102 63.7347 54.0736 63.9189 54.0918C63.998 54.0997 64.0778 54.1163 64.1585 54.1416L63.2436 54.6674C63.2009 54.4412 63.2682 54.276 63.4453 54.1748V54.174ZM61.157 56.8109C61.0076 56.8109 60.8518 56.7761 60.6905 56.7081L62.1493 55.8653C62.1525 55.8787 62.1557 55.8914 62.1588 55.9032C62.1857 56.0281 62.1683 56.1554 62.1059 56.2804C62.0426 56.4077 61.9058 56.5326 61.6979 56.6536C61.516 56.7587 61.3389 56.8109 61.157 56.8109Z",
    fill: "url(#paint38_linear_402_1371)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 54.1156C55.1802 54.1156 55.1802 52.8521 55.1802 55.3562C55.1802 57.8603 58.5485 59.89 62.7027 59.89C66.857 59.89 70.2253 57.8603 70.2253 55.3562C70.2253 53.3748 70.2253 54.1156 70.2253 54.1156H55.1802Z",
    fill: "url(#paint39_linear_402_1371)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 57.4333C65.0802 59.1277 60.3053 59.1198 57.3632 57.4222C54.4273 55.7277 54.4194 52.9857 57.3466 51.2912C60.2792 49.5936 65.0541 49.5857 68.0113 51.2802C70.9748 52.9778 70.9819 55.7357 68.0279 57.4333Z",
    fill: "url(#paint40_linear_402_1371)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 57.139C64.851 58.6721 60.5315 58.6658 57.8693 57.1303C55.2118 55.5971 55.2046 53.116 57.8542 51.5828C60.5078 50.0473 64.8273 50.041 67.5021 51.5741C70.1818 53.1096 70.1881 55.6042 67.5172 57.1397V57.139Z",
    fill: "#FFDB00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 55.5474C63.8367 55.4027 63.8667 55.2541 63.8477 55.1054C63.8272 54.9473 63.7742 54.7599 63.6912 54.5488L63.4121 53.8562L64.6574 53.1366C64.7072 53.1849 64.7412 53.2339 64.757 53.2837C64.791 53.3865 64.7467 53.4766 64.6329 53.5423L64.4083 53.6798L65.7564 54.4531C66.166 54.1796 66.3423 53.9028 66.2822 53.6277C66.2245 53.3636 65.9233 53.0584 65.3848 52.716L66.3178 52.1776L65.8355 51.8984L64.9009 52.4353C64.3925 52.1696 63.907 52.0139 63.4548 51.9736C62.9345 51.9269 62.4672 52.0249 62.0252 52.274C61.6212 52.5017 61.5184 52.856 61.7129 53.3596L61.9722 54.0673C61.9778 54.0815 61.9825 54.0942 61.988 54.1084L60.2493 55.107C60.1726 54.9781 60.1892 54.8161 60.485 54.6469L61.0448 54.3266L59.7204 53.5739L59.3116 53.8048C58.7739 54.1076 58.5415 54.4191 58.6245 54.7283C58.6893 54.9742 58.9645 55.2573 59.442 55.572L58.4229 56.1571L58.9336 56.4441L59.9323 55.8669C60.5822 56.2266 61.1744 56.4124 61.6923 56.4188C62.2371 56.4259 62.7771 56.2733 63.2966 55.9673C63.5259 55.8321 63.6809 55.6913 63.7592 55.5482L63.7584 55.5474ZM63.4453 52.8947C63.571 52.8227 63.7347 52.7943 63.9189 52.8125C63.998 52.8204 64.0778 52.837 64.1585 52.8623L63.2436 53.3881C63.2009 53.162 63.2682 52.9967 63.4453 52.8955V52.8947ZM61.157 55.5316C61.0076 55.5316 60.8518 55.4968 60.6905 55.4288L62.1493 54.586C62.1525 54.5994 62.1557 54.6121 62.1588 54.6239C62.1857 54.7489 62.1683 54.8754 62.1059 55.0011C62.0426 55.1284 61.9058 55.2533 61.6979 55.3743C61.516 55.4794 61.3389 55.5316 61.157 55.5316Z",
    fill: "url(#paint41_linear_402_1371)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 52.8559C55.1802 52.8559 55.1802 51.5924 55.1802 54.0965C55.1802 56.6005 58.5485 58.6302 62.7027 58.6302C66.857 58.6302 70.2253 56.6005 70.2253 54.0965C70.2253 52.115 70.2253 52.8559 70.2253 52.8559H55.1802Z",
    fill: "url(#paint42_linear_402_1371)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 56.1735C65.0802 57.8679 60.3053 57.86 57.3632 56.1624C54.4273 54.468 54.4194 51.7259 57.3466 50.0315C60.2792 48.3339 65.0541 48.326 68.0113 50.0204C70.9748 51.718 70.9819 54.4759 68.0279 56.1735Z",
    fill: "url(#paint43_linear_402_1371)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 55.8792C64.851 57.4123 60.5315 57.406 57.8693 55.8705C55.2118 54.3374 55.2046 51.8562 57.8542 50.3231C60.5078 48.7876 64.8273 48.7812 67.5021 50.3144C70.1818 51.8499 70.1881 54.3445 67.5172 55.88V55.8792Z",
    fill: "#FFDB00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 54.2857C63.8367 54.141 63.8667 53.9924 63.8477 53.8437C63.8272 53.6856 63.7742 53.4982 63.6912 53.2871L63.4121 52.5945L64.6574 51.8749C64.7072 51.9232 64.7412 51.9722 64.757 52.022C64.791 52.1248 64.7467 52.2149 64.6329 52.2805L64.4083 52.4181L65.7564 53.1914C66.166 52.9178 66.3423 52.6411 66.2822 52.3659C66.2245 52.1019 65.9233 51.7966 65.3848 51.4543L66.3178 50.9158L65.8355 50.6367L64.9009 51.1736C64.3925 50.9079 63.907 50.7522 63.4548 50.7118C62.9345 50.6652 62.4672 50.7632 62.0252 51.0123C61.6212 51.24 61.5184 51.5942 61.7129 52.0979L61.9722 52.8056C61.9778 52.8198 61.9825 52.8324 61.988 52.8467L60.2493 53.8453C60.1726 53.7164 60.1892 53.5543 60.485 53.3851L61.0448 53.0649L59.7204 52.3122L59.3116 52.5431C58.7739 52.8459 58.5415 53.1574 58.6245 53.4666C58.6893 53.7125 58.9645 53.9955 59.442 54.3102L58.4229 54.8953L58.9336 55.1824L59.9323 54.6052C60.5822 54.9649 61.1744 55.1507 61.6923 55.1571C62.2371 55.1642 62.7771 55.0116 63.2966 54.7056C63.5259 54.5704 63.6809 54.4296 63.7592 54.2865L63.7584 54.2857ZM63.4453 51.633C63.571 51.561 63.7347 51.5326 63.9189 51.5507C63.998 51.5587 64.0778 51.5753 64.1585 51.6006L63.2436 52.1264C63.2009 51.9002 63.2682 51.735 63.4453 51.6338V51.633ZM61.157 54.2699C61.0076 54.2699 60.8518 54.2351 60.6905 54.1671L62.1493 53.3242C62.1525 53.3377 62.1557 53.3503 62.1588 53.3622C62.1857 53.4871 62.1683 53.6136 62.1059 53.7394C62.0426 53.8667 61.9058 53.9916 61.6979 54.1126C61.516 54.2177 61.3389 54.2699 61.157 54.2699Z",
    fill: "url(#paint44_linear_402_1371)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 51.5922C55.1802 51.5922 55.1802 50.3287 55.1802 52.8328C55.1802 55.3369 58.5485 57.3666 62.7027 57.3666C66.857 57.3666 70.2253 55.3369 70.2253 52.8328C70.2253 50.8513 70.2253 51.5922 70.2253 51.5922H55.1802Z",
    fill: "url(#paint45_linear_402_1371)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 54.9098C65.0802 56.6042 60.3053 56.5963 57.3632 54.8987C54.4273 53.2043 54.4194 50.4622 57.3466 48.7678C60.2792 47.0702 65.0541 47.0623 68.0113 48.7567C70.9748 50.4543 70.9819 53.2122 68.0279 54.9098Z",
    fill: "url(#paint46_linear_402_1371)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 54.6155C64.851 56.1487 60.5315 56.1423 57.8693 54.6068C55.2118 53.0737 55.2046 50.5925 57.8542 49.0594C60.5078 47.5239 64.8273 47.5176 67.5021 49.0507C70.1818 50.5862 70.1881 53.0808 67.5172 54.6163V54.6155Z",
    fill: "#FFDB00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 53.0221C63.8367 52.8774 63.8667 52.7287 63.8477 52.5801C63.8272 52.4219 63.7742 52.2345 63.6912 52.0234L63.4121 51.3308L64.6574 50.6113C64.7072 50.6595 64.7412 50.7085 64.757 50.7583C64.791 50.8611 64.7467 50.9512 64.6329 51.0169L64.4083 51.1545L65.7564 51.9277C66.166 51.6542 66.3423 51.3774 66.2822 51.1023C66.2245 50.8382 65.9233 50.533 65.3848 50.1906L66.3178 49.6522L65.8355 49.373L64.9009 49.9099C64.3925 49.6442 63.907 49.4885 63.4548 49.4482C62.9345 49.4015 62.4672 49.4996 62.0252 49.7486C61.6212 49.9763 61.5184 50.3306 61.7129 50.8342L61.9722 51.5419C61.9778 51.5561 61.9825 51.5688 61.988 51.583L60.2493 52.5816C60.1726 52.4528 60.1892 52.2907 60.485 52.1215L61.0448 51.8012L59.7204 51.0485L59.3116 51.2794C58.7739 51.5822 58.5415 51.8937 58.6245 52.2029C58.6893 52.4488 58.9645 52.7319 59.442 53.0466L58.4229 53.6317L58.9336 53.9187L59.9323 53.3415C60.5822 53.7012 61.1744 53.8871 61.6923 53.8934C62.2371 53.9005 62.7771 53.7479 63.2966 53.4419C63.5259 53.3067 63.6809 53.166 63.7592 53.0228L63.7584 53.0221ZM63.4453 50.3693C63.571 50.2974 63.7347 50.2689 63.9189 50.2871C63.998 50.295 64.0778 50.3116 64.1585 50.3369L63.2436 50.8627C63.2009 50.6366 63.2682 50.4713 63.4453 50.3701V50.3693ZM61.157 53.0062C61.0076 53.0062 60.8518 52.9714 60.6905 52.9034L62.1493 52.0606C62.1525 52.074 62.1557 52.0867 62.1588 52.0985C62.1857 52.2235 62.1683 52.3508 62.1059 52.4757C62.0426 52.603 61.9058 52.7279 61.6979 52.8489C61.516 52.9541 61.3389 53.0062 61.157 53.0062Z",
    fill: "url(#paint47_linear_402_1371)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 50.3324C55.1802 50.3324 55.1802 49.0689 55.1802 51.573C55.1802 54.0771 58.5485 56.1068 62.7027 56.1068C66.857 56.1068 70.2253 54.0771 70.2253 51.573C70.2253 49.5916 70.2253 50.3324 70.2253 50.3324H55.1802Z",
    fill: "url(#paint48_linear_402_1371)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 53.65C65.0802 55.3445 60.3053 55.3366 57.3632 53.639C54.4273 51.9445 54.4194 49.2025 57.3466 47.508C60.2792 45.8104 65.0541 45.8025 68.0113 47.497C70.9748 49.1946 70.9819 51.9525 68.0279 53.65Z",
    fill: "url(#paint49_linear_402_1371)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 53.3558C64.851 54.8889 60.5315 54.8826 57.8693 53.3471C55.2118 51.8139 55.2046 49.3328 57.8542 47.7996C60.5078 46.2641 64.8273 46.2578 67.5021 47.7909C70.1818 49.3264 70.1881 51.8202 67.5172 53.3565V53.3558Z",
    fill: "#FFDB00"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 51.7623C63.8367 51.6176 63.8667 51.4689 63.8477 51.3203C63.8272 51.1622 63.7742 50.9748 63.6912 50.7637L63.4121 50.071L64.6574 49.3515C64.7072 49.3997 64.7412 49.4487 64.757 49.4986C64.791 49.6013 64.7467 49.6915 64.6329 49.7571L64.4083 49.8947L65.7564 50.668C66.166 50.3944 66.3423 50.1177 66.2822 49.8425C66.2245 49.5784 65.9233 49.2732 65.3848 48.9308L66.3178 48.3924L65.8355 48.1133L64.9009 48.6502C64.3925 48.3845 63.907 48.2287 63.4548 48.1884C62.9345 48.1417 62.4672 48.2398 62.0252 48.4889C61.6212 48.7166 61.5184 49.0708 61.7129 49.5745L61.9722 50.2821C61.9778 50.2964 61.9825 50.309 61.988 50.3232L60.2493 51.3219C60.1726 51.193 60.1892 51.0309 60.485 50.8617L61.0448 50.5415L59.7204 49.7887L59.3116 50.0196C58.7739 50.3224 58.5415 50.634 58.6245 50.9431C58.6893 51.189 58.9645 51.4721 59.442 51.7868L58.4229 52.3719L58.9336 52.6589L59.9323 52.0817C60.5822 52.4415 61.1744 52.6273 61.6923 52.6336C62.2371 52.6407 62.7771 52.4881 63.2966 52.1821C63.5259 52.0469 63.6809 51.9062 63.7592 51.7631L63.7584 51.7623ZM63.4453 49.1095C63.571 49.0376 63.7347 49.0091 63.9189 49.0273C63.998 49.0352 64.0778 49.0518 64.1585 49.0771L63.2436 49.6029C63.2009 49.3768 63.2682 49.2115 63.4453 49.1103V49.1095ZM61.157 51.7465C61.0076 51.7465 60.8518 51.7117 60.6905 51.6437L62.1493 50.8008C62.1525 50.8143 62.1557 50.8269 62.1588 50.8388C62.1857 50.9637 62.1683 51.091 62.1059 51.2159C62.0426 51.3432 61.9058 51.4682 61.6979 51.5891C61.516 51.6943 61.3389 51.7465 61.157 51.7465Z",
    fill: "url(#paint50_linear_402_1371)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 49.0707C55.1802 49.0707 55.1802 47.8072 55.1802 50.3113C55.1802 52.8154 58.5485 54.8451 62.7027 54.8451C66.857 54.8451 70.2253 52.8154 70.2253 50.3113C70.2253 48.3298 70.2253 49.0707 70.2253 49.0707H55.1802Z",
    fill: "url(#paint51_linear_402_1371)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 52.3883C65.0802 54.0828 60.3053 54.0749 57.3632 52.3773C54.4273 50.6828 54.4194 47.9407 57.3466 46.2463C60.2792 44.5487 65.0541 44.5408 68.0113 46.2352C70.9748 47.9328 70.9819 50.6907 68.0279 52.3883Z",
    fill: "url(#paint52_linear_402_1371)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 52.094C64.851 53.6272 60.5315 53.6208 57.8693 52.0853C55.2118 50.5522 55.2046 48.071 57.8542 46.5379C60.5078 45.0024 64.8273 44.9961 67.5021 46.5292C70.1818 48.0647 70.1881 50.5593 67.5172 52.0948V52.094Z",
    fill: "#FFDB00"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 50.5006C63.8367 50.3559 63.8667 50.2072 63.8477 50.0586C63.8272 49.9004 63.7742 49.713 63.6912 49.5019L63.4121 48.8093L64.6574 48.0898C64.7072 48.138 64.7412 48.187 64.757 48.2368C64.791 48.3396 64.7467 48.4298 64.6329 48.4954L64.4083 48.633L65.7564 49.4063C66.166 49.1327 66.3423 48.8559 66.2822 48.5808C66.2245 48.3167 65.9233 48.0115 65.3848 47.6691L66.3178 47.1307L65.8355 46.8516L64.9009 47.3884C64.3925 47.1228 63.907 46.967 63.4548 46.9267C62.9345 46.88 62.4672 46.9781 62.0252 47.2271C61.6212 47.4549 61.5184 47.8091 61.7129 48.3127L61.9722 49.0204C61.9778 49.0346 61.9825 49.0473 61.988 49.0615L60.2493 50.0602C60.1726 49.9313 60.1892 49.7692 60.485 49.6L61.0448 49.2798L59.7204 48.527L59.3116 48.7579C58.7739 49.0607 58.5415 49.3723 58.6245 49.6814C58.6893 49.9273 58.9645 50.2104 59.442 50.5251L58.4229 51.1102L58.9336 51.3972L59.9323 50.82C60.5822 51.1798 61.1744 51.3656 61.6923 51.3719C62.2371 51.379 62.7771 51.2264 63.2966 50.9204C63.5259 50.7852 63.6809 50.6445 63.7592 50.5014L63.7584 50.5006ZM63.4453 47.8478C63.571 47.7759 63.7347 47.7474 63.9189 47.7656C63.998 47.7735 64.0778 47.7901 64.1585 47.8154L63.2436 48.3412C63.2009 48.1159 63.2682 47.9498 63.4453 47.8486V47.8478ZM61.157 50.4848C61.0076 50.4848 60.8518 50.45 60.6905 50.382L62.1493 49.5391C62.1525 49.5525 62.1557 49.5652 62.1588 49.577C62.1857 49.702 62.1683 49.8293 62.1059 49.9542C62.0426 50.0815 61.9058 50.2064 61.6979 50.3274C61.516 50.4326 61.3389 50.4848 61.157 50.4848Z",
    fill: "url(#paint53_linear_402_1371)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 47.811C55.1802 47.811 55.1802 46.5474 55.1802 49.0515C55.1802 51.5556 58.5485 53.5853 62.7027 53.5853C66.857 53.5853 70.2253 51.5556 70.2253 49.0515C70.2253 47.0701 70.2253 47.811 70.2253 47.811H55.1802Z",
    fill: "url(#paint54_linear_402_1371)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 51.1266C65.0802 52.821 60.3053 52.8131 57.3632 51.1155C54.4273 49.4211 54.4194 46.679 57.3466 44.9846C60.2792 43.287 65.0541 43.2791 68.0113 44.9735C70.9748 46.6711 70.9819 49.429 68.0279 51.1266Z",
    fill: "url(#paint55_linear_402_1371)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 50.8323C64.851 52.3655 60.5315 52.3591 57.8693 50.8236C55.2118 49.2905 55.2046 46.8093 57.8542 45.2762C60.5078 43.7407 64.8273 43.7344 67.5021 45.2675C70.1818 46.803 70.1881 49.2976 67.5172 50.8331V50.8323Z",
    fill: "#FFDB00"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 49.2408C63.8367 49.0961 63.8667 48.9475 63.8477 48.7988C63.8272 48.6407 63.7742 48.4533 63.6912 48.2422L63.4121 47.5495L64.6574 46.83C64.7072 46.8782 64.7412 46.9273 64.757 46.9771C64.791 47.0799 64.7467 47.17 64.6329 47.2356L64.4083 47.3732L65.7564 48.1465C66.166 47.8729 66.3423 47.5962 66.2822 47.321C66.2245 47.0569 65.9233 46.7517 65.3848 46.4094L66.3178 45.8709L65.8355 45.5918L64.9009 46.1287C64.3925 45.863 63.907 45.7072 63.4548 45.6669C62.9345 45.6203 62.4672 45.7183 62.0252 45.9674C61.6212 46.1951 61.5184 46.5493 61.7129 47.053L61.9722 47.7606C61.9778 47.7749 61.9825 47.7875 61.988 47.8018L60.2493 48.8004C60.1726 48.6715 60.1892 48.5094 60.485 48.3402L61.0448 48.02L59.7204 47.2673L59.3116 47.4981C58.7739 47.801 58.5415 48.1125 58.6245 48.4216C58.6893 48.6676 58.9645 48.9506 59.442 49.2653L58.4229 49.8504L58.9336 50.1374L59.9323 49.5602C60.5822 49.92 61.1744 50.1058 61.6923 50.1121C62.2371 50.1192 62.7771 49.9666 63.2966 49.6606C63.5259 49.5254 63.6809 49.3847 63.7592 49.2416L63.7584 49.2408ZM63.4453 46.5881C63.571 46.5161 63.7347 46.4876 63.9189 46.5058C63.998 46.5137 64.0778 46.5303 64.1585 46.5556L63.2436 47.0814C63.2009 46.8561 63.2682 46.6901 63.4453 46.5888V46.5881ZM61.157 49.225C61.0076 49.225 60.8518 49.1902 60.6905 49.1222L62.1493 48.2793C62.1525 48.2928 62.1557 48.3054 62.1588 48.3173C62.1857 48.4422 62.1683 48.5695 62.1059 48.6944C62.0426 48.8217 61.9058 48.9467 61.6979 49.0676C61.516 49.1728 61.3389 49.225 61.157 49.225Z",
    fill: "url(#paint56_linear_402_1371)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 46.5473C55.1802 46.5473 55.1802 45.2838 55.1802 47.7879C55.1802 50.292 58.5485 52.3216 62.7027 52.3216C66.857 52.3216 70.2253 50.292 70.2253 47.7879C70.2253 45.8064 70.2253 46.5473 70.2253 46.5473H55.1802Z",
    fill: "url(#paint57_linear_402_1371)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 49.8649C65.0802 51.5593 60.3053 51.5514 57.3632 49.8538C54.4273 48.1594 54.4194 45.4173 57.3466 43.7229C60.2792 42.0253 65.0541 42.0174 68.0113 43.7118C70.9748 45.4094 70.9819 48.1673 68.0279 49.8649Z",
    fill: "url(#paint58_linear_402_1371)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 49.5706C64.851 51.1037 60.5315 51.0974 57.8693 49.5619C55.2118 48.0288 55.2046 45.5476 57.8542 44.0145C60.5078 42.479 64.8273 42.4726 67.5021 44.0058C70.1818 45.5413 70.1881 48.0359 67.5172 49.5714V49.5706Z",
    fill: "#FFDB00"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 47.9791C63.8367 47.8344 63.8667 47.6857 63.8477 47.5371C63.8272 47.379 63.7742 47.1916 63.6912 46.9804L63.4121 46.2878L64.6574 45.5683C64.7072 45.6165 64.7412 45.6655 64.757 45.7154C64.791 45.8181 64.7467 45.9083 64.6329 45.9739L64.4083 46.1115L65.7564 46.8848C66.166 46.6112 66.3423 46.3345 66.2822 46.0593C66.2245 45.7952 65.9233 45.49 65.3848 45.1476L66.3178 44.6092L65.8355 44.3301L64.9009 44.867C64.3925 44.6013 63.907 44.4455 63.4548 44.4052C62.9345 44.3585 62.4672 44.4566 62.0252 44.7057C61.6212 44.9334 61.5184 45.2876 61.7129 45.7913L61.9722 46.4989C61.9778 46.5132 61.9825 46.5258 61.988 46.54L60.2493 47.5387C60.1726 47.4098 60.1892 47.2477 60.485 47.0785L61.0448 46.7583L59.7204 46.0055L59.3116 46.2364C58.7739 46.5392 58.5415 46.8508 58.6245 47.1599C58.6893 47.4058 58.9645 47.6889 59.442 48.0036L58.4229 48.5887L58.9336 48.8757L59.9323 48.2985C60.5822 48.6583 61.1744 48.8441 61.6923 48.8504C62.2371 48.8575 62.7771 48.7049 63.2966 48.3989C63.5259 48.2637 63.6809 48.123 63.7592 47.9799L63.7584 47.9791ZM63.4453 45.3263C63.571 45.2544 63.7347 45.2259 63.9189 45.2441C63.998 45.252 64.0778 45.2686 64.1585 45.2939L63.2436 45.8197C63.2009 45.5944 63.2682 45.4283 63.4453 45.3271V45.3263ZM61.157 47.9633C61.0076 47.9633 60.8518 47.9285 60.6905 47.8605L62.1493 47.0176C62.1525 47.031 62.1557 47.0437 62.1588 47.0556C62.1857 47.1805 62.1683 47.3078 62.1059 47.4327C62.0426 47.56 61.9058 47.6849 61.6979 47.8059C61.516 47.9111 61.3389 47.9633 61.157 47.9633Z",
    fill: "url(#paint59_linear_402_1371)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 45.2875C55.1802 45.2875 55.1802 44.024 55.1802 46.5281C55.1802 49.0322 58.5485 51.0619 62.7027 51.0619C66.857 51.0619 70.2253 49.0322 70.2253 46.5281C70.2253 44.5466 70.2253 45.2875 70.2253 45.2875H55.1802Z",
    fill: "url(#paint60_linear_402_1371)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 48.6051C65.0802 50.2996 60.3053 50.2917 57.3632 48.5941C54.4273 46.8996 54.4194 44.1575 57.3466 42.4631C60.2792 40.7655 65.0541 40.7576 68.0113 42.452C70.9748 44.1496 70.9819 46.9075 68.0279 48.6051Z",
    fill: "url(#paint61_linear_402_1371)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 48.3108C64.851 49.844 60.5315 49.8376 57.8693 48.3021C55.2118 46.769 55.2046 44.2878 57.8542 42.7547C60.5078 41.2192 64.8273 41.2129 67.5021 42.746C70.1818 44.2815 70.1881 46.7761 67.5172 48.3116V48.3108Z",
    fill: "#FFDB00"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 46.7174C63.8367 46.5727 63.8667 46.424 63.8477 46.2754C63.8272 46.1172 63.7742 45.9298 63.6912 45.7187L63.4121 45.0261L64.6574 44.3066C64.7072 44.3548 64.7412 44.4038 64.757 44.4536C64.791 44.5564 64.7467 44.6466 64.6329 44.7122L64.4083 44.8498L65.7564 45.6231C66.166 45.3495 66.3423 45.0727 66.2822 44.7976C66.2245 44.5335 65.9233 44.2283 65.3848 43.8859L66.3178 43.3475L65.8355 43.0684L64.9009 43.6052C64.3925 43.3396 63.907 43.1838 63.4548 43.1435C62.9345 43.0968 62.4672 43.1949 62.0252 43.4439C61.6212 43.6717 61.5184 44.0259 61.7129 44.5295L61.9722 45.2372C61.9778 45.2514 61.9825 45.2641 61.988 45.2783L60.2493 46.277C60.1726 46.1481 60.1892 45.986 60.485 45.8168L61.0448 45.4965L59.7204 44.7438L59.3116 44.9747C58.7739 45.2775 58.5415 45.5891 58.6245 45.8982C58.6893 46.1441 58.9645 46.4272 59.442 46.7419L58.4229 47.327L58.9336 47.614L59.9323 47.0368C60.5822 47.3966 61.1744 47.5824 61.6923 47.5887C62.2371 47.5958 62.7771 47.4432 63.2966 47.1372C63.5259 47.002 63.6809 46.8613 63.7592 46.7182L63.7584 46.7174ZM63.4453 44.0646C63.571 43.9927 63.7347 43.9642 63.9189 43.9824C63.998 43.9903 64.0778 44.0069 64.1585 44.0322L63.2436 44.558C63.2009 44.3319 63.2682 44.1666 63.4453 44.0654V44.0646ZM61.157 46.7015C61.0076 46.7015 60.8518 46.6668 60.6905 46.5988L62.1493 45.7559C62.1525 45.7693 62.1557 45.782 62.1588 45.7938C62.1857 45.9188 62.1683 46.0453 62.1059 46.171C62.0426 46.2983 61.9058 46.4232 61.6979 46.5442C61.516 46.6494 61.3389 46.7015 61.157 46.7015Z",
    fill: "url(#paint62_linear_402_1371)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 44.0258C55.1802 44.0258 55.1802 42.7623 55.1802 45.2664C55.1802 47.7705 58.5485 49.8002 62.7027 49.8002C66.857 49.8002 70.2253 47.7705 70.2253 45.2664C70.2253 43.2849 70.2253 44.0258 70.2253 44.0258H55.1802Z",
    fill: "url(#paint63_linear_402_1371)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 47.3415C65.0802 49.0359 60.3053 49.028 57.3632 47.3304C54.4273 45.636 54.4194 42.8939 57.3466 41.1994C60.2792 39.5018 65.0541 39.4939 68.0113 41.1884C70.9748 42.886 70.9819 45.6439 68.0279 47.3415Z",
    fill: "url(#paint64_linear_402_1371)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 47.0472C64.851 48.5803 60.5315 48.574 57.8693 47.0385C55.2118 45.5053 55.2046 43.0242 57.8542 41.491C60.5078 39.9555 64.8273 39.9492 67.5021 41.4823C70.1818 43.0178 70.1881 45.5124 67.5172 47.0479V47.0472Z",
    fill: "#FFDB00"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7584 45.4537C63.8367 45.309 63.8667 45.1603 63.8477 45.0117C63.8272 44.8536 63.7742 44.6662 63.6912 44.4551L63.4121 43.7624L64.6574 43.0429C64.7072 43.0911 64.7412 43.1402 64.757 43.19C64.791 43.2928 64.7467 43.3829 64.6329 43.4485L64.4083 43.5861L65.7564 44.3594C66.166 44.0858 66.3423 43.8091 66.2822 43.5339C66.2245 43.2698 65.9233 42.9646 65.3848 42.6223L66.3178 42.0838L65.8355 41.8047L64.9009 42.3416C64.3925 42.0759 63.907 41.9201 63.4548 41.8798C62.9345 41.8332 62.4672 41.9312 62.0252 42.1803C61.6212 42.408 61.5184 42.7622 61.7129 43.2659L61.9722 43.9735C61.9778 43.9878 61.9825 44.0004 61.988 44.0146L60.2493 45.0133C60.1726 44.8844 60.1892 44.7223 60.485 44.5531L61.0448 44.2329L59.7204 43.4801L59.3116 43.711C58.7739 44.0139 58.5415 44.3254 58.6245 44.6345C58.6893 44.8804 58.9645 45.1635 59.442 45.4782L58.4229 46.0633L58.9336 46.3503L59.9323 45.7731C60.5822 46.1329 61.1744 46.3187 61.6923 46.325C62.2371 46.3321 62.7771 46.1795 63.2966 45.8735C63.5259 45.7383 63.6809 45.5976 63.7592 45.4545L63.7584 45.4537ZM63.4453 42.801C63.571 42.729 63.7347 42.7005 63.9189 42.7187C63.998 42.7266 64.0778 42.7432 64.1585 42.7685L63.2436 43.2943C63.2009 43.0682 63.2682 42.9029 63.4453 42.8017V42.801ZM61.157 45.4379C61.0076 45.4379 60.8518 45.4031 60.6905 45.3351L62.1493 44.4922C62.1525 44.5057 62.1557 44.5183 62.1588 44.5302C62.1857 44.6551 62.1683 44.7816 62.1059 44.9073C62.0426 45.0346 61.9058 45.1596 61.6979 45.2805C61.516 45.3857 61.3389 45.4379 61.157 45.4379Z",
    fill: "url(#paint65_linear_402_1371)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1802 42.766C55.1802 42.766 55.1802 41.5025 55.1802 44.0066C55.1802 46.5107 58.5485 48.5404 62.7027 48.5404C66.857 48.5404 70.2253 46.5107 70.2253 44.0066C70.2253 42.0252 70.2253 42.766 70.2253 42.766H55.1802Z",
    fill: "url(#paint66_linear_402_1371)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0279 46.0817C65.0802 47.7761 60.3053 47.7682 57.3632 46.0706C54.4273 44.3762 54.4194 41.6341 57.3466 39.9397C60.2792 38.2421 65.0541 38.2342 68.0113 39.9286C70.9748 41.6262 70.9819 44.3841 68.0279 46.0817Z",
    fill: "url(#paint67_linear_402_1371)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5172 45.7874C64.851 47.3205 60.5315 47.3142 57.8693 45.7787C55.2118 44.2456 55.2046 41.7644 57.8542 40.2313C60.5078 38.6958 64.8273 38.6894 67.5021 40.2226C70.1818 41.7581 70.1881 44.2519 67.5172 45.7882V45.7874Z",
    fill: "url(#paint68_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M58.5225 40.6092C61.0567 39.1425 65.1089 39.0721 67.7988 40.4036C67.704 40.342 67.6051 40.2811 67.5023 40.2226C64.8275 38.6894 60.508 38.6958 57.8544 40.2313C55.2056 41.7644 55.212 44.2456 57.8694 45.7787C57.996 45.8514 58.1272 45.9202 58.2608 45.9859C55.8848 44.4448 55.9694 42.0862 58.5225 40.6092Z",
    fill: "url(#paint69_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0924 44.4908C64.1706 44.3461 64.2007 44.1975 64.1817 44.0488C64.1612 43.8907 64.1082 43.7033 64.0252 43.4922L63.746 42.7995L64.9914 42.08C65.0412 42.1282 65.0752 42.1773 65.091 42.2271C65.125 42.3299 65.0807 42.42 64.9669 42.4856L64.7423 42.6232L66.0904 43.3965C66.5 43.1229 66.6763 42.8462 66.6162 42.571C66.5585 42.3069 66.2573 42.0017 65.7188 41.6594L66.6518 41.1209L66.1695 40.8418L65.2349 41.3787C64.7265 41.113 64.241 40.9572 63.7887 40.9169C63.2685 40.8703 62.8012 40.9683 62.3592 41.2174C61.9551 41.4451 61.8524 41.7993 62.0469 42.303L62.3062 43.0106C62.3117 43.0249 62.3165 43.0375 62.322 43.0518L60.5833 44.0504C60.5066 43.9215 60.5232 43.7594 60.8189 43.5902L61.3787 43.27L60.0543 42.5173L59.6456 42.7481C59.1079 43.051 58.8754 43.3625 58.9585 43.6717C59.0233 43.9176 59.2985 44.2006 59.776 44.5153L58.7568 45.1004L59.2676 45.3874L60.2663 44.8102C60.9162 45.17 61.5084 45.3558 62.0263 45.3621C62.5711 45.3692 63.1111 45.2166 63.6306 44.9107C63.8599 44.7754 64.0149 44.6347 64.0932 44.4916L64.0924 44.4908ZM63.7793 41.8381C63.905 41.7661 64.0686 41.7376 64.2529 41.7558C64.3319 41.7637 64.4118 41.7803 64.4925 41.8056L63.5776 42.3314C63.5349 42.1053 63.6021 41.9401 63.7793 41.8388V41.8381ZM61.491 44.475C61.3416 44.475 61.1858 44.4402 61.0245 44.3722L62.4833 43.5293C62.4865 43.5428 62.4897 43.5554 62.4928 43.5673C62.5197 43.6922 62.5023 43.8195 62.4398 43.9444C62.3766 44.0717 62.2398 44.1967 62.0318 44.3176C61.85 44.4228 61.6729 44.475 61.491 44.475Z",
    fill: "#FED9B0"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M63.851 44.3336C63.9095 44.2253 63.9411 44.1154 63.9451 44.0047C63.9466 43.9675 63.9522 43.6093 63.9474 43.5714C63.9269 43.4132 63.8668 43.5461 63.7838 43.335L63.5047 42.6423L64.75 41.9228C64.7998 41.971 64.8338 42.02 64.8496 42.0699C64.8836 42.1726 64.6148 42.0374 64.5001 42.1031V42.466L65.8482 43.2393C66.2064 43.0005 66.3867 42.7585 66.3859 42.5174C66.3859 42.4826 66.397 42.1853 66.3891 42.1505C66.3748 42.0849 66.3306 42.2794 66.2855 42.2082C66.1511 41.9947 65.8807 41.7591 65.4774 41.5029L66.4104 40.9645V40.6016L65.9281 40.6854L64.9935 41.2222C64.4851 40.9566 63.9996 40.8008 63.5473 40.7605C63.0271 40.7138 62.5598 40.8119 62.1178 41.0609C61.7138 41.2887 61.611 41.6429 61.8055 42.1466L62.0648 42.8542C62.0704 42.8684 62.0751 42.8811 62.0806 42.8953L60.3419 43.894C60.2652 43.7651 60.2818 43.603 60.5775 43.4338L61.1373 43.1136V42.7506L59.813 42.3608L59.4042 42.5917C59.114 42.7554 58.9132 42.9206 58.8025 43.0875C58.7487 43.1689 58.7115 42.9278 58.7005 43.0092C58.6926 43.0701 58.7005 43.4543 58.7163 43.5152C58.7811 43.7611 59.0563 44.0442 59.5338 44.3589L58.5146 44.5811V44.944L59.0254 45.231L60.0241 44.6538C60.674 45.0136 61.2662 45.1994 61.7841 45.2057C62.3289 45.2128 62.8689 45.0602 63.3884 44.7542C63.6177 44.619 63.7727 44.4783 63.851 44.3352V44.3336ZM63.5379 41.6808C63.6636 41.6089 63.8272 41.5804 64.0115 41.5986C64.0905 41.6065 64.1704 41.6231 64.2511 41.6484L63.3362 42.1742C63.2935 41.9481 63.3607 41.7828 63.5379 41.6816V41.6808ZM61.2496 44.3178C61.1002 44.3178 60.9444 44.283 60.7831 44.215L62.2419 43.3721C62.2451 43.3856 62.2483 43.3982 62.2514 43.4101C62.2783 43.535 62.2609 43.6615 62.1984 43.7872C62.1352 43.9145 61.9984 44.0395 61.7904 44.1604C61.6086 44.2656 61.4315 44.3178 61.2496 44.3178Z",
    fill: "url(#paint70_linear_402_1371)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8512 43.9713C63.9294 43.8266 63.9595 43.6779 63.9405 43.5293C63.9199 43.3711 63.867 43.1837 63.7839 42.9726L63.5048 42.28L64.7502 41.5605C64.8 41.6087 64.834 41.6577 64.8498 41.7075C64.8838 41.8103 64.8395 41.9005 64.7257 41.9661L64.5011 42.1037L65.8492 42.877C66.2588 42.6034 66.4351 42.3266 66.375 42.0515C66.3173 41.7874 66.016 41.4822 65.4776 41.1398L66.4106 40.6014L65.9283 40.3223L64.9937 40.8591C64.4853 40.5935 63.9998 40.4377 63.5475 40.3974C63.0273 40.3507 62.56 40.4488 62.118 40.6978C61.7139 40.9256 61.6111 41.2798 61.8057 41.7834L62.065 42.4911C62.0705 42.5053 62.0753 42.518 62.0808 42.5322L60.3421 43.5309C60.2654 43.402 60.282 43.2399 60.5777 43.0707L61.1375 42.7505L59.8131 41.9977L59.4044 42.2286C58.8667 42.5314 58.6342 42.843 58.7172 43.1521C58.7821 43.398 59.0572 43.6811 59.5348 43.9958L58.5156 44.5809L59.0264 44.8679L60.025 44.2907C60.675 44.6505 61.2672 44.8363 61.7851 44.8426C62.3299 44.8497 62.8699 44.6971 63.3894 44.3911C63.6187 44.2559 63.7737 44.1152 63.8519 43.9721L63.8512 43.9713ZM63.538 41.3185C63.6638 41.2466 63.8274 41.2181 64.0117 41.2363C64.0907 41.2442 64.1706 41.2608 64.2512 41.2861L63.3364 41.8119C63.2937 41.5858 63.3609 41.4205 63.538 41.3193V41.3185ZM61.2498 43.9555C61.1004 43.9555 60.9446 43.9207 60.7833 43.8527L62.2421 43.0098C62.2453 43.0232 62.2484 43.0359 62.2516 43.0477C62.2785 43.1727 62.2611 43.3 62.1986 43.4249C62.1354 43.5522 61.9986 43.6771 61.7906 43.7981C61.6088 43.9033 61.4317 43.9555 61.2498 43.9555Z",
    fill: "url(#paint71_linear_402_1371)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0868 40.5033C60.7403 38.9678 65.0598 38.9614 67.7347 40.4946C68.221 40.7729 68.6187 41.0836 68.9287 41.4141C68.595 40.9816 68.1198 40.576 67.5015 40.2226C64.8266 38.6894 60.5071 38.6958 57.8536 40.2313C55.6808 41.4885 55.2957 43.3845 56.6944 44.871C55.5819 43.4312 56.0437 41.6853 58.086 40.5033H58.0868Z",
    fill: "url(#paint72_linear_402_1371)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 76.8559C41.7671 76.8559 41.7671 75.5924 41.7671 78.0965C41.7671 80.6005 45.1354 82.6302 49.2896 82.6302C53.4439 82.6302 56.8122 80.6005 56.8122 78.0965C56.8122 76.115 56.8122 76.8559 56.8122 76.8559H41.7671Z",
    fill: "url(#paint73_linear_402_1371)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 80.1735C51.6674 81.8679 46.8925 81.86 43.9504 80.1624C41.0138 78.468 41.0067 75.7259 43.9338 74.0315C46.8664 72.3339 51.6413 72.326 54.5985 74.0204C57.562 75.718 57.5691 78.4759 54.6151 80.1735Z",
    fill: "url(#paint74_linear_402_1371)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 79.8792C51.4384 81.4123 47.1189 81.406 44.4567 79.8705C41.7992 78.3374 41.7921 75.8562 44.4416 74.3231C47.0952 72.7876 51.4147 72.7812 54.0895 74.3144C56.7692 75.8499 56.7755 78.3437 54.1046 79.88V79.8792Z",
    fill: "#FFDB00"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 78.2877C50.4236 78.143 50.4536 77.9943 50.4346 77.8457C50.4141 77.6875 50.3611 77.5002 50.2781 77.289L49.999 76.5964L51.2443 75.8769C51.2941 75.9251 51.3281 75.9741 51.3439 76.0239C51.3779 76.1267 51.3337 76.2169 51.2198 76.2825L50.9952 76.4201L52.3433 77.1934C52.7529 76.9198 52.9292 76.6431 52.8692 76.3679C52.8114 76.1038 52.5102 75.7986 51.9717 75.4562L52.9047 74.9178L52.4224 74.6387L51.4878 75.1755C50.9794 74.9099 50.4939 74.7541 50.0417 74.7138C49.5214 74.6671 49.0541 74.7652 48.6121 75.0142C48.2081 75.242 48.1053 75.5962 48.2998 76.0999L48.5591 76.8075C48.5647 76.8217 48.5694 76.8344 48.575 76.8486L46.8362 77.8473C46.7595 77.7184 46.7762 77.5563 47.0719 77.3871L47.6317 77.0669L46.3073 76.3141L45.8985 76.545C45.3608 76.8478 45.1284 77.1594 45.2114 77.4685C45.2762 77.7144 45.5514 77.9975 46.029 78.3122L45.0098 78.8973L45.5205 79.1843L46.5192 78.6071C47.1691 78.9669 47.7613 79.1527 48.2792 79.159C48.824 79.1661 49.3641 79.0135 49.8835 78.7075C50.1128 78.5723 50.2678 78.4316 50.3461 78.2885L50.3453 78.2877ZM50.0322 75.6349C50.1579 75.563 50.3216 75.5345 50.5058 75.5527C50.5849 75.5606 50.6647 75.5772 50.7454 75.6025L49.8306 76.1283C49.7879 75.9022 49.8551 75.7369 50.0322 75.6357V75.6349ZM47.7439 78.2719C47.5945 78.2719 47.4387 78.2371 47.2774 78.1691L48.7363 77.3262C48.7394 77.3396 48.7426 77.3523 48.7457 77.3642C48.7726 77.4891 48.7552 77.6164 48.6928 77.7413C48.6295 77.8686 48.4927 77.9935 48.2848 78.1145C48.1029 78.2197 47.9258 78.2719 47.7439 78.2719Z",
    fill: "url(#paint75_linear_402_1371)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7676 75.5961C41.7676 75.5961 41.7676 74.3326 41.7676 76.8367C41.7676 79.3408 45.1359 81.3705 49.2901 81.3705C53.4444 81.3705 56.8127 79.3408 56.8127 76.8367C56.8127 74.8552 56.8127 75.5961 56.8127 75.5961H41.7676Z",
    fill: "url(#paint76_linear_402_1371)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 78.9137C51.6674 80.6082 46.8925 80.6002 43.9504 78.9027C41.0138 77.2082 41.0067 74.4661 43.9338 72.7717C46.8664 71.0741 51.6413 71.0662 54.5985 72.7606C57.562 74.4582 57.5691 77.2161 54.6151 78.9137Z",
    fill: "url(#paint77_linear_402_1371)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 78.6194C51.4384 80.1526 47.1189 80.1462 44.4567 78.6107C41.7992 77.0776 41.7921 74.5964 44.4416 73.0633C47.0952 71.5278 51.4147 71.5215 54.0895 73.0546C56.7692 74.5901 56.7755 77.0839 54.1046 78.6202V78.6194Z",
    fill: "#FFDB00"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 77.0279C50.4236 76.8832 50.4536 76.7346 50.4346 76.5859C50.4141 76.4278 50.3611 76.2404 50.2781 76.0293L49.999 75.3366L51.2443 74.6171C51.2941 74.6653 51.3281 74.7144 51.3439 74.7642C51.3779 74.867 51.3337 74.9571 51.2198 75.0227L50.9952 75.1603L52.3433 75.9336C52.7529 75.66 52.9292 75.3833 52.8692 75.1081C52.8114 74.844 52.5102 74.5388 51.9717 74.1965L52.9047 73.658L52.4224 73.3789L51.4878 73.9158C50.9794 73.6501 50.4939 73.4943 50.0417 73.454C49.5214 73.4074 49.0541 73.5054 48.6121 73.7545C48.2081 73.9822 48.1053 74.3364 48.2998 74.8401L48.5591 75.5477C48.5647 75.562 48.5694 75.5746 48.575 75.5889L46.8362 76.5875C46.7595 76.4586 46.7762 76.2965 47.0719 76.1273L47.6317 75.8071L46.3073 75.0544L45.8985 75.2852C45.3608 75.5881 45.1284 75.8996 45.2114 76.2088C45.2762 76.4547 45.5514 76.7377 46.029 77.0524L45.0098 77.6375L45.5205 77.9245L46.5192 77.3473C47.1691 77.7071 47.7613 77.8929 48.2792 77.8992C48.824 77.9064 49.3641 77.7538 49.8835 77.4478C50.1128 77.3126 50.2678 77.1718 50.3461 77.0287L50.3453 77.0279ZM50.0322 74.3752C50.1579 74.3032 50.3216 74.2747 50.5058 74.2929C50.5849 74.3008 50.6647 74.3174 50.7454 74.3427L49.8306 74.8686C49.7879 74.6432 49.8551 74.4772 50.0322 74.376V74.3752ZM47.7439 77.0121C47.5945 77.0121 47.4387 76.9773 47.2774 76.9093L48.7363 76.0664C48.7394 76.0799 48.7426 76.0925 48.7457 76.1044C48.7726 76.2293 48.7552 76.3566 48.6928 76.4815C48.6295 76.6088 48.4927 76.7338 48.2848 76.8547C48.1029 76.9599 47.9258 77.0121 47.7439 77.0121Z",
    fill: "url(#paint78_linear_402_1371)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7676 74.3363C41.7676 74.3363 41.7676 73.0728 41.7676 75.5769C41.7676 78.081 45.1359 80.1107 49.2901 80.1107C53.4444 80.1107 56.8127 78.081 56.8127 75.5769C56.8127 73.5955 56.8127 74.3363 56.8127 74.3363H41.7676Z",
    fill: "url(#paint79_linear_402_1371)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 77.654C51.6674 79.3484 46.8925 79.3405 43.9504 77.6429C41.0138 75.9485 41.0067 73.2064 43.9338 71.5119C46.8664 69.8143 51.6413 69.8064 54.5985 71.5009C57.562 73.1985 57.5691 75.9564 54.6151 77.654Z",
    fill: "url(#paint80_linear_402_1371)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 77.3597C51.4384 78.8928 47.1189 78.8865 44.4567 77.351C41.7992 75.8178 41.7921 73.3367 44.4416 71.8035C47.0952 70.268 51.4147 70.2617 54.0895 71.7948C56.7692 73.3303 56.7755 75.8242 54.1046 77.3604V77.3597Z",
    fill: "#FFDB00"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 75.7662C50.4236 75.6215 50.4536 75.4728 50.4346 75.3242C50.4141 75.1661 50.3611 74.9787 50.2781 74.7676L49.999 74.0749L51.2443 73.3554C51.2941 73.4036 51.3281 73.4526 51.3439 73.5025C51.3779 73.6052 51.3337 73.6954 51.2198 73.761L50.9952 73.8986L52.3433 74.6719C52.7529 74.3983 52.9292 74.1216 52.8692 73.8464C52.8114 73.5823 52.5102 73.2771 51.9717 72.9348L52.9047 72.3963L52.4224 72.1172L51.4878 72.6541C50.9794 72.3884 50.4939 72.2326 50.0417 72.1923C49.5214 72.1456 49.0541 72.2437 48.6121 72.4928C48.2081 72.7205 48.1053 73.0747 48.2998 73.5784L48.5591 74.286C48.5647 74.3003 48.5694 74.3129 48.575 74.3271L46.8362 75.3258C46.7595 75.1969 46.7762 75.0348 47.0719 74.8656L47.6317 74.5454L46.3073 73.7926L45.8985 74.0235C45.3608 74.3264 45.1284 74.6379 45.2114 74.947C45.2762 75.1929 45.5514 75.476 46.029 75.7907L45.0098 76.3758L45.5205 76.6628L46.5192 76.0856C47.1691 76.4454 47.7613 76.6312 48.2792 76.6375C48.824 76.6446 49.3641 76.492 49.8835 76.186C50.1128 76.0508 50.2678 75.9101 50.3461 75.767L50.3453 75.7662ZM50.0322 73.1134C50.1579 73.0415 50.3216 73.013 50.5058 73.0312C50.5849 73.0391 50.6647 73.0557 50.7454 73.081L49.8306 73.6068C49.7879 73.3807 49.8551 73.2154 50.0322 73.1142V73.1134ZM47.7439 75.7504C47.5945 75.7504 47.4387 75.7156 47.2774 75.6476L48.7363 74.8047C48.7394 74.8182 48.7426 74.8308 48.7457 74.8427C48.7726 74.9676 48.7552 75.0949 48.6928 75.2198C48.6295 75.3471 48.4927 75.4721 48.2848 75.593C48.1029 75.6982 47.9258 75.7504 47.7439 75.7504Z",
    fill: "url(#paint81_linear_402_1371)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 73.0727C41.7671 73.0727 41.7671 71.8092 41.7671 74.3133C41.7671 76.8173 45.1354 78.847 49.2896 78.847C53.4439 78.847 56.8122 76.8173 56.8122 74.3133C56.8122 72.3318 56.8122 73.0727 56.8122 73.0727H41.7671Z",
    fill: "url(#paint82_linear_402_1371)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 76.3903C51.6674 78.0847 46.8925 78.0768 43.9504 76.3792C41.0138 74.6848 41.0067 71.9427 43.9338 70.2483C46.8664 68.5507 51.6413 68.5428 54.5985 70.2372C57.562 71.9348 57.5691 74.6927 54.6151 76.3903Z",
    fill: "url(#paint83_linear_402_1371)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 76.096C51.4384 77.6291 47.1189 77.6228 44.4567 76.0873C41.7992 74.5542 41.7921 72.073 44.4416 70.5399C47.0952 69.0044 51.4147 68.998 54.0895 70.5312C56.7692 72.0667 56.7755 74.5613 54.1046 76.0968V76.096Z",
    fill: "#FFDB00"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 74.5025C50.4236 74.3578 50.4536 74.2092 50.4346 74.0605C50.4141 73.9024 50.3611 73.715 50.2781 73.5039L49.999 72.8112L51.2443 72.0917C51.2941 72.14 51.3281 72.189 51.3439 72.2388C51.3779 72.3416 51.3337 72.4317 51.2198 72.4973L50.9952 72.6349L52.3433 73.4082C52.7529 73.1346 52.9292 72.8579 52.8692 72.5827C52.8114 72.3187 52.5102 72.0134 51.9717 71.6711L52.9047 71.1326L52.4224 70.8535L51.4878 71.3904C50.9794 71.1247 50.4939 70.969 50.0417 70.9286C49.5214 70.882 49.0541 70.98 48.6121 71.2291C48.2081 71.4568 48.1053 71.811 48.2998 72.3147L48.5591 73.0224C48.5647 73.0366 48.5694 73.0492 48.575 73.0635L46.8362 74.0621C46.7595 73.9332 46.7762 73.7711 47.0719 73.6019L47.6317 73.2817L46.3073 72.529L45.8985 72.7599C45.3608 73.0627 45.1284 73.3742 45.2114 73.6834C45.2762 73.9293 45.5514 74.2123 46.029 74.527L45.0098 75.1121L45.5205 75.3992L46.5192 74.822C47.1691 75.1817 47.7613 75.3675 48.2792 75.3738C48.824 75.381 49.3641 75.2284 49.8835 74.9224C50.1128 74.7872 50.2678 74.6464 50.3461 74.5033L50.3453 74.5025ZM50.0322 71.8498C50.1579 71.7778 50.3216 71.7494 50.5058 71.7675C50.5849 71.7755 50.6647 71.7921 50.7454 71.8174L49.8306 72.3432C49.7879 72.117 49.8551 71.9518 50.0322 71.8506V71.8498ZM47.7439 74.4867C47.5945 74.4867 47.4387 74.4519 47.2774 74.3839L48.7363 73.541C48.7394 73.5545 48.7426 73.5671 48.7457 73.579C48.7726 73.7039 48.7552 73.8312 48.6928 73.9562C48.6295 74.0835 48.4927 74.2084 48.2848 74.3294C48.1029 74.4345 47.9258 74.4867 47.7439 74.4867Z",
    fill: "url(#paint84_linear_402_1371)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 71.8129C41.7671 71.8129 41.7671 70.5494 41.7671 73.0535C41.7671 75.5576 45.1354 77.5873 49.2896 77.5873C53.4439 77.5873 56.8122 75.5576 56.8122 73.0535C56.8122 71.072 56.8122 71.8129 56.8122 71.8129H41.7671Z",
    fill: "url(#paint85_linear_402_1371)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 75.1305C51.6674 76.825 46.8925 76.817 43.9504 75.1194C41.0138 73.425 41.0067 70.6829 43.9338 68.9885C46.8664 67.2909 51.6413 67.283 54.5985 68.9774C57.562 70.675 57.5691 73.4329 54.6151 75.1305Z",
    fill: "url(#paint86_linear_402_1371)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1041 74.8362C51.4379 76.3694 47.1184 76.363 44.4562 74.8275C41.7987 73.2944 41.7916 70.8132 44.4411 69.2801C47.0947 67.7446 51.4142 67.7383 54.0891 69.2714C56.7687 70.8069 56.775 73.3015 54.1041 74.837V74.8362Z",
    fill: "#FFDB00"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 73.2428C50.4236 73.0981 50.4536 72.9494 50.4346 72.8008C50.4141 72.6426 50.3611 72.4552 50.2781 72.2441L49.999 71.5515L51.2443 70.832C51.2941 70.8802 51.3281 70.9292 51.3439 70.979C51.3779 71.0818 51.3337 71.172 51.2198 71.2376L50.9952 71.3752L52.3433 72.1484C52.7529 71.8749 52.9292 71.5981 52.8692 71.323C52.8114 71.0589 52.5102 70.7537 51.9717 70.4113L52.9047 69.8729L52.4224 69.5938L51.4878 70.1306C50.9794 69.865 50.4939 69.7092 50.0417 69.6689C49.5214 69.6222 49.0541 69.7203 48.6121 69.9693C48.2081 70.197 48.1053 70.5513 48.2998 71.0549L48.5591 71.7626C48.5647 71.7768 48.5694 71.7895 48.575 71.8037L46.8362 72.8023C46.7595 72.6735 46.7762 72.5114 47.0719 72.3422L47.6317 72.0219L46.3073 71.2692L45.8985 71.5001C45.3608 71.8029 45.1284 72.1144 45.2114 72.4236C45.2762 72.6695 45.5514 72.9526 46.029 73.2673L45.0098 73.8524L45.5205 74.1394L46.5192 73.5622C47.1691 73.9219 47.7613 74.1078 48.2792 74.1141C48.824 74.1212 49.3641 73.9686 49.8835 73.6626C50.1128 73.5274 50.2678 73.3867 50.3461 73.2435L50.3453 73.2428ZM50.0322 70.59C50.1579 70.5181 50.3216 70.4896 50.5058 70.5078C50.5849 70.5157 50.6647 70.5323 50.7454 70.5576L49.8306 71.0834C49.7879 70.8573 49.8551 70.692 50.0322 70.5908V70.59ZM47.7439 73.2269C47.5945 73.2269 47.4387 73.1921 47.2774 73.1242L48.7363 72.2813C48.7394 72.2947 48.7426 72.3074 48.7457 72.3192C48.7726 72.4442 48.7552 72.5715 48.6928 72.6964C48.6295 72.8237 48.4927 72.9486 48.2848 73.0696C48.1029 73.1748 47.9258 73.2269 47.7439 73.2269Z",
    fill: "url(#paint87_linear_402_1371)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7676 70.5512C41.7676 70.5512 41.7676 69.2877 41.7676 71.7918C41.7676 74.2959 45.1359 76.3255 49.2901 76.3255C53.4444 76.3255 56.8127 74.2959 56.8127 71.7918C56.8127 69.8103 56.8127 70.5512 56.8127 70.5512H41.7676Z",
    fill: "url(#paint88_linear_402_1371)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 73.8708C51.6674 75.5652 46.8925 75.5573 43.9504 73.8597C41.0138 72.1652 41.0067 69.4232 43.9338 67.7287C46.8664 66.0311 51.6413 66.0232 54.5985 67.7177C57.562 69.4153 57.5691 72.1732 54.6151 73.8708Z",
    fill: "url(#paint89_linear_402_1371)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 73.5765C51.4384 75.1096 47.1189 75.1033 44.4567 73.5678C41.7992 72.0346 41.7921 69.5535 44.4416 68.0203C47.0952 66.4848 51.4147 66.4785 54.0895 68.0116C56.7692 69.5471 56.7755 72.0417 54.1046 73.5772V73.5765Z",
    fill: "#FFDB00"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 71.983C50.4236 71.8383 50.4536 71.6896 50.4346 71.541C50.4141 71.3829 50.3611 71.1955 50.2781 70.9844L49.999 70.2917L51.2443 69.5722C51.2941 69.6204 51.3281 69.6694 51.3439 69.7193C51.3779 69.8221 51.3337 69.9122 51.2198 69.9778L50.9952 70.1154L52.3433 70.8887C52.7529 70.6151 52.9292 70.3384 52.8692 70.0632C52.8114 69.7991 52.5102 69.4939 51.9717 69.1516L52.9047 68.6131L52.4224 68.334L51.4878 68.8709C50.9794 68.6052 50.4939 68.4494 50.0417 68.4091C49.5214 68.3624 49.0541 68.4605 48.6121 68.7096C48.2081 68.9373 48.1053 69.2915 48.2998 69.7952L48.5591 70.5028C48.5647 70.5171 48.5694 70.5297 48.575 70.5439L46.8362 71.5426C46.7595 71.4137 46.7762 71.2516 47.0719 71.0824L47.6317 70.7622L46.3073 70.0094L45.8985 70.2403C45.3608 70.5432 45.1284 70.8547 45.2114 71.1638C45.2762 71.4097 45.5514 71.6928 46.029 72.0075L45.0098 72.5926L45.5205 72.8796L46.5192 72.3024C47.1691 72.6622 47.7613 72.848 48.2792 72.8543C48.824 72.8614 49.3641 72.7088 49.8835 72.4028C50.1128 72.2676 50.2678 72.1269 50.3461 71.9838L50.3453 71.983ZM50.0322 69.3302C50.1579 69.2583 50.3216 69.2298 50.5058 69.248C50.5849 69.2559 50.6647 69.2725 50.7454 69.2978L49.8306 69.8236C49.7879 69.5975 49.8551 69.4322 50.0322 69.331V69.3302ZM47.7439 71.9672C47.5945 71.9672 47.4387 71.9324 47.2774 71.8644L48.7363 71.0215C48.7394 71.035 48.7426 71.0476 48.7457 71.0595C48.7726 71.1844 48.7552 71.3117 48.6928 71.4366C48.6295 71.5639 48.4927 71.6889 48.2848 71.8098C48.1029 71.915 47.9258 71.9672 47.7439 71.9672Z",
    fill: "url(#paint90_linear_402_1371)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 69.2875C41.7671 69.2875 41.7671 68.024 41.7671 70.5281C41.7671 73.0322 45.1354 75.0619 49.2896 75.0619C53.4439 75.0619 56.8122 73.0322 56.8122 70.5281C56.8122 68.5466 56.8122 69.2875 56.8122 69.2875H41.7671Z",
    fill: "url(#paint91_linear_402_1371)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 72.6051C51.6674 74.2996 46.8925 74.2917 43.9504 72.5941C41.0138 70.8996 41.0067 68.1575 43.9338 66.4631C46.8664 64.7655 51.6413 64.7576 54.5985 66.452C57.562 68.1496 57.5691 70.9075 54.6151 72.6051Z",
    fill: "url(#paint92_linear_402_1371)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 72.3108C51.4384 73.844 47.1189 73.8376 44.4567 72.3021C41.7992 70.769 41.7921 68.2878 44.4416 66.7547C47.0952 65.2192 51.4147 65.2129 54.0895 66.746C56.7692 68.2815 56.7755 70.7753 54.1046 72.3116V72.3108Z",
    fill: "#FFDB00"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 70.7193C50.4236 70.5746 50.4536 70.426 50.4346 70.2773C50.4141 70.1192 50.3611 69.9318 50.2781 69.7207L49.999 69.028L51.2443 68.3085C51.2941 68.3568 51.3281 68.4058 51.3439 68.4556C51.3779 68.5584 51.3337 68.6485 51.2198 68.7141L50.9952 68.8517L52.3433 69.625C52.7529 69.3514 52.9292 69.0747 52.8692 68.7995C52.8114 68.5354 52.5102 68.2302 51.9717 67.8879L52.9047 67.3494L52.4224 67.0703L51.4878 67.6072C50.9794 67.3415 50.4939 67.1858 50.0417 67.1454C49.5214 67.0988 49.0541 67.1968 48.6121 67.4459C48.2081 67.6736 48.1053 68.0278 48.2998 68.5315L48.5591 69.2392C48.5647 69.2534 48.5694 69.266 48.575 69.2803L46.8362 70.2789C46.7595 70.15 46.7762 69.9879 47.0719 69.8187L47.6317 69.4985L46.3073 68.7458L45.8985 68.9767C45.3608 69.2795 45.1284 69.591 45.2114 69.9002C45.2762 70.1461 45.5514 70.4291 46.029 70.7438L45.0098 71.3289L45.5205 71.6159L46.5192 71.0388C47.1691 71.3985 47.7613 71.5843 48.2792 71.5907C48.824 71.5978 49.3641 71.4452 49.8835 71.1392C50.1128 71.004 50.2678 70.8632 50.3461 70.7201L50.3453 70.7193ZM50.0322 68.0666C50.1579 67.9946 50.3216 67.9662 50.5058 67.9843C50.5849 67.9922 50.6647 68.0089 50.7454 68.0342L49.8306 68.56C49.7879 68.3338 49.8551 68.1686 50.0322 68.0674V68.0666ZM47.7439 70.7035C47.5945 70.7035 47.4387 70.6687 47.2774 70.6007L48.7363 69.7578C48.7394 69.7713 48.7426 69.7839 48.7457 69.7958C48.7726 69.9207 48.7552 70.048 48.6928 70.173C48.6295 70.3003 48.4927 70.4252 48.2848 70.5462C48.1029 70.6513 47.9258 70.7035 47.7439 70.7035Z",
    fill: "url(#paint93_linear_402_1371)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 68.0277C41.7671 68.0277 41.7671 66.7642 41.7671 69.2683C41.7671 71.7724 45.1354 73.8021 49.2896 73.8021C53.4439 73.8021 56.8122 71.7724 56.8122 69.2683C56.8122 67.2869 56.8122 68.0277 56.8122 68.0277H41.7671Z",
    fill: "url(#paint94_linear_402_1371)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 71.3454C51.6674 73.0398 46.8925 73.0319 43.9504 71.3343C41.0138 69.6399 41.0067 66.8978 43.9338 65.2033C46.8664 63.5057 51.6413 63.4978 54.5985 65.1923C57.562 66.8899 57.5691 69.6478 54.6151 71.3454Z",
    fill: "url(#paint95_linear_402_1371)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 71.0511C51.4384 72.5842 47.1189 72.5779 44.4567 71.0424C41.7992 69.5092 41.7921 67.0281 44.4416 65.4949C47.0952 63.9594 51.4147 63.9531 54.0895 65.4862C56.7692 67.0217 56.7755 69.5156 54.1046 71.0519V71.0511Z",
    fill: "#FFDB00"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 69.4595C50.4236 69.3149 50.4536 69.1662 50.4346 69.0176C50.4141 68.8594 50.3611 68.672 50.2781 68.4609L49.999 67.7683L51.2443 67.0488C51.2941 67.097 51.3281 67.146 51.3439 67.1958C51.3779 67.2986 51.3337 67.3887 51.2198 67.4544L50.9952 67.592L52.3433 68.3652C52.7529 68.0917 52.9292 67.8149 52.8692 67.5398C52.8114 67.2757 52.5102 66.9705 51.9717 66.6281L52.9047 66.0897L52.4224 65.8105L51.4878 66.3474C50.9794 66.0817 50.4939 65.926 50.0417 65.8857C49.5214 65.839 49.0541 65.9371 48.6121 66.1861C48.2081 66.4138 48.1053 66.7681 48.2998 67.2717L48.5591 67.9794C48.5647 67.9936 48.5694 68.0063 48.575 68.0205L46.8362 69.0191C46.7595 68.8903 46.7762 68.7282 47.0719 68.559L47.6317 68.2387L46.3073 67.486L45.8985 67.7169C45.3608 68.0197 45.1284 68.3312 45.2114 68.6404C45.2762 68.8863 45.5514 69.1694 46.029 69.4841L45.0098 70.0692L45.5205 70.3562L46.5192 69.779C47.1691 70.1387 47.7613 70.3246 48.2792 70.3309C48.824 70.338 49.3641 70.1854 49.8835 69.8794C50.1128 69.7442 50.2678 69.6035 50.3461 69.4603L50.3453 69.4595ZM50.0322 66.8068C50.1579 66.7349 50.3216 66.7064 50.5058 66.7246C50.5849 66.7325 50.6647 66.7491 50.7454 66.7744L49.8306 67.3002C49.7879 67.0741 49.8551 66.9088 50.0322 66.8076V66.8068ZM47.7439 69.4437C47.5945 69.4437 47.4387 69.4089 47.2774 69.3409L48.7363 68.4981C48.7394 68.5115 48.7426 68.5242 48.7457 68.536C48.7726 68.661 48.7552 68.7883 48.6928 68.9132C48.6295 69.0405 48.4927 69.1654 48.2848 69.2864C48.1029 69.3915 47.9258 69.4437 47.7439 69.4437Z",
    fill: "url(#paint96_linear_402_1371)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 66.766C41.7671 66.766 41.7671 65.5025 41.7671 68.0066C41.7671 70.5107 45.1354 72.5404 49.2896 72.5404C53.4439 72.5404 56.8122 70.5107 56.8122 68.0066C56.8122 66.0252 56.8122 66.766 56.8122 66.766H41.7671Z",
    fill: "url(#paint97_linear_402_1371)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 70.0856C51.6674 71.78 46.8925 71.7721 43.9504 70.0745C41.0138 68.3801 41.0067 65.638 43.9338 63.9436C46.8664 62.246 51.6413 62.2381 54.5985 63.9325C57.562 65.6301 57.5691 68.388 54.6151 70.0856Z",
    fill: "url(#paint98_linear_402_1371)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 69.7913C51.4384 71.3244 47.1189 71.3181 44.4567 69.7826C41.7992 68.2495 41.7921 65.7683 44.4416 64.2352C47.0952 62.6997 51.4147 62.6933 54.0895 64.2265C56.7692 65.762 56.7755 68.2566 54.1046 69.7921V69.7913Z",
    fill: "#FFDB00"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 68.1978C50.4236 68.0531 50.4536 67.9045 50.4346 67.7558C50.4141 67.5977 50.3611 67.4103 50.2781 67.1992L49.999 66.5066L51.2443 65.787C51.2941 65.8353 51.3281 65.8843 51.3439 65.9341C51.3779 66.0369 51.3337 66.127 51.2198 66.1927L50.9952 66.3302L52.3433 67.1035C52.7529 66.8299 52.9292 66.5532 52.8692 66.2781C52.8114 66.014 52.5102 65.7088 51.9717 65.3664L52.9047 64.8279L52.4224 64.5488L51.4878 65.0857C50.9794 64.82 50.4939 64.6643 50.0417 64.6239C49.5214 64.5773 49.0541 64.6753 48.6121 64.9244C48.2081 65.1521 48.1053 65.5063 48.2998 66.01L48.5591 66.7177C48.5647 66.7319 48.5694 66.7446 48.575 66.7588L46.8362 67.7574C46.7595 67.6285 46.7762 67.4664 47.0719 67.2972L47.6317 66.977L46.3073 66.2243L45.8985 66.4552C45.3608 66.758 45.1284 67.0695 45.2114 67.3787C45.2762 67.6246 45.5514 67.9077 46.029 68.2223L45.0098 68.8074L45.5205 69.0945L46.5192 68.5173C47.1691 68.877 47.7613 69.0628 48.2792 69.0692C48.824 69.0763 49.3641 68.9237 49.8835 68.6177C50.1128 68.4825 50.2678 68.3417 50.3461 68.1986L50.3453 68.1978ZM50.0322 65.5451C50.1579 65.4731 50.3216 65.4447 50.5058 65.4629C50.5849 65.4708 50.6647 65.4874 50.7454 65.5127L49.8306 66.0385C49.7879 65.8123 49.8551 65.6471 50.0322 65.5459V65.5451ZM47.7439 68.182C47.5945 68.182 47.4387 68.1472 47.2774 68.0792L48.7363 67.2364C48.7394 67.2498 48.7426 67.2624 48.7457 67.2743C48.7726 67.3992 48.7552 67.5265 48.6928 67.6515C48.6295 67.7788 48.4927 67.9037 48.2848 68.0247C48.1029 68.1298 47.9258 68.182 47.7439 68.182Z",
    fill: "url(#paint99_linear_402_1371)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 65.5063C41.7671 65.5063 41.7671 64.2428 41.7671 66.7468C41.7671 69.2509 45.1354 71.2806 49.2896 71.2806C53.4439 71.2806 56.8122 69.2509 56.8122 66.7468C56.8122 64.7654 56.8122 65.5063 56.8122 65.5063H41.7671Z",
    fill: "url(#paint100_linear_402_1371)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 68.8219C51.6674 70.5164 46.8925 70.5084 43.9504 68.8109C41.0138 67.1164 41.0067 64.3743 43.9338 62.6799C46.8664 60.9823 51.6413 60.9744 54.5985 62.6688C57.562 64.3664 57.5691 67.1243 54.6151 68.8219Z",
    fill: "url(#paint101_linear_402_1371)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 68.5276C51.4384 70.0608 47.1189 70.0544 44.4567 68.5189C41.7992 66.9858 41.7921 64.5046 44.4416 62.9715C47.0952 61.436 51.4147 61.4297 54.0895 62.9628C56.7692 64.4983 56.7755 66.9929 54.1046 68.5284V68.5276Z",
    fill: "#FFDB00"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 66.9342C50.4236 66.7895 50.4536 66.6408 50.4346 66.4922C50.4141 66.334 50.3611 66.1466 50.2781 65.9355L49.999 65.2429L51.2443 64.5234C51.2941 64.5716 51.3281 64.6206 51.3439 64.6704C51.3779 64.7732 51.3337 64.8634 51.2198 64.929L50.9952 65.0666L52.3433 65.8399C52.7529 65.5663 52.9292 65.2895 52.8692 65.0144C52.8114 64.7503 52.5102 64.4451 51.9717 64.1027L52.9047 63.5643L52.4224 63.2852L51.4878 63.822C50.9794 63.5564 50.4939 63.4006 50.0417 63.3603C49.5214 63.3136 49.0541 63.4117 48.6121 63.6607C48.2081 63.8884 48.1053 64.2427 48.2998 64.7463L48.5591 65.454C48.5647 65.4682 48.5694 65.4809 48.575 65.4951L46.8362 66.4937C46.7595 66.3649 46.7762 66.2028 47.0719 66.0336L47.6317 65.7133L46.3073 64.9606L45.8985 65.1915C45.3608 65.4943 45.1284 65.8059 45.2114 66.115C45.2762 66.3609 45.5514 66.644 46.029 66.9587L45.0098 67.5438L45.5205 67.8308L46.5192 67.2536C47.1691 67.6134 47.7613 67.7992 48.2792 67.8055C48.824 67.8126 49.3641 67.66 49.8835 67.354C50.1128 67.2188 50.2678 67.0781 50.3461 66.935L50.3453 66.9342ZM50.0322 64.2814C50.1579 64.2095 50.3216 64.181 50.5058 64.1992C50.5849 64.2071 50.6647 64.2237 50.7454 64.249L49.8306 64.7748C49.7879 64.5487 49.8551 64.3834 50.0322 64.2822V64.2814ZM47.7439 66.9183C47.5945 66.9183 47.4387 66.8836 47.2774 66.8156L48.7363 65.9727C48.7394 65.9861 48.7426 65.9988 48.7457 66.0106C48.7726 66.1356 48.7552 66.2629 48.6928 66.3878C48.6295 66.5151 48.4927 66.64 48.2848 66.761C48.1029 66.8662 47.9258 66.9183 47.7439 66.9183Z",
    fill: "url(#paint102_linear_402_1371)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7676 64.2426C41.7676 64.2426 41.7676 62.9791 41.7676 65.4832C41.7676 67.9873 45.1359 70.017 49.2901 70.017C53.4444 70.017 56.8127 67.9873 56.8127 65.4832C56.8127 63.5017 56.8127 64.2426 56.8127 64.2426H41.7676Z",
    fill: "url(#paint103_linear_402_1371)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 67.5602C51.6674 69.2546 46.8925 69.2467 43.9504 67.5491C41.0138 65.8547 41.0067 63.1126 43.9338 61.4182C46.8664 59.7206 51.6413 59.7127 54.5985 61.4071C57.562 63.1047 57.5691 65.8626 54.6151 67.5602Z",
    fill: "url(#paint104_linear_402_1371)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 67.2659C51.4384 68.799 47.1189 68.7927 44.4567 67.2572C41.7992 65.7241 41.7921 63.2429 44.4416 61.7098C47.0952 60.1743 51.4147 60.168 54.0895 61.7011C56.7692 63.2366 56.7755 65.7312 54.1046 67.2667V67.2659Z",
    fill: "#FFDB00"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 65.6724C50.4236 65.5277 50.4536 65.3791 50.4346 65.2304C50.4141 65.0723 50.3611 64.8849 50.2781 64.6738L49.999 63.9812L51.2443 63.2616C51.2941 63.3099 51.3281 63.3589 51.3439 63.4087C51.3779 63.5115 51.3337 63.6016 51.2198 63.6673L50.9952 63.8048L52.3433 64.5781C52.7529 64.3046 52.9292 64.0278 52.8692 63.7527C52.8114 63.4886 52.5102 63.1834 51.9717 62.841L52.9047 62.3026L52.4224 62.0234L51.4878 62.5603C50.9794 62.2946 50.4939 62.1389 50.0417 62.0986C49.5214 62.0519 49.0541 62.1499 48.6121 62.399C48.2081 62.6267 48.1053 62.981 48.2998 63.4846L48.5591 64.1923C48.5647 64.2065 48.5694 64.2192 48.575 64.2334L46.8362 65.232C46.7595 65.1031 46.7762 64.9411 47.0719 64.7719L47.6317 64.4516L46.3073 63.6989L45.8985 63.9298C45.3608 64.2326 45.1284 64.5441 45.2114 64.8533C45.2762 65.0992 45.5514 65.3823 46.029 65.697L45.0098 66.2821L45.5205 66.5691L46.5192 65.9919C47.1691 66.3516 47.7613 66.5374 48.2792 66.5438C48.824 66.5509 49.3641 66.3983 49.8835 66.0923C50.1128 65.9571 50.2678 65.8163 50.3461 65.6732L50.3453 65.6724ZM50.0322 63.0197C50.1579 62.9477 50.3216 62.9193 50.5058 62.9375C50.5849 62.9454 50.6647 62.962 50.7454 62.9873L49.8306 63.5131C49.7879 63.287 49.8551 63.1217 50.0322 63.0205V63.0197ZM47.7439 65.6566C47.5945 65.6566 47.4387 65.6218 47.2774 65.5538L48.7363 64.711C48.7394 64.7244 48.7426 64.7371 48.7457 64.7489C48.7726 64.8739 48.7552 65.0011 48.6928 65.1261C48.6295 65.2534 48.4927 65.3783 48.2848 65.4993C48.1029 65.6044 47.9258 65.6566 47.7439 65.6566Z",
    fill: "url(#paint105_linear_402_1371)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 62.9809C41.7671 62.9809 41.7671 61.7174 41.7671 64.2215C41.7671 66.7255 45.1354 68.7552 49.2896 68.7552C53.4439 68.7552 56.8122 66.7255 56.8122 64.2215C56.8122 62.24 56.8122 62.9809 56.8122 62.9809H41.7671Z",
    fill: "url(#paint106_linear_402_1371)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 66.3004C51.6674 67.9949 46.8925 67.987 43.9504 66.2894C41.0138 64.5949 41.0067 61.8528 43.9338 60.1584C46.8664 58.4608 51.6413 58.4529 54.5985 60.1473C57.562 61.8449 57.5691 64.6028 54.6151 66.3004Z",
    fill: "url(#paint107_linear_402_1371)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1041 66.0061C51.4379 67.5393 47.1184 67.533 44.4562 65.9974C41.7987 64.4643 41.7916 61.9832 44.4411 60.45C47.0947 58.9145 51.4142 58.9082 54.0891 60.4413C56.7687 61.9768 56.775 64.4714 54.1041 66.0069V66.0061Z",
    fill: "#FFDB00"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 64.4127C50.4236 64.268 50.4536 64.1193 50.4346 63.9707C50.4141 63.8125 50.3611 63.6252 50.2781 63.414L49.999 62.7214L51.2443 62.0019C51.2941 62.0501 51.3281 62.0991 51.3439 62.1489C51.3779 62.2517 51.3337 62.3419 51.2198 62.4075L50.9952 62.5451L52.3433 63.3184C52.7529 63.0448 52.9292 62.7681 52.8692 62.4929C52.8114 62.2288 52.5102 61.9236 51.9717 61.5812L52.9047 61.0428L52.4224 60.7637L51.4878 61.3005C50.9794 61.0349 50.4939 60.8791 50.0417 60.8388C49.5214 60.7921 49.0541 60.8902 48.6121 61.1392C48.2081 61.367 48.1053 61.7212 48.2998 62.2249L48.5591 62.9325C48.5647 62.9468 48.5694 62.9594 48.575 62.9736L46.8362 63.9723C46.7595 63.8434 46.7762 63.6813 47.0719 63.5121L47.6317 63.1919L46.3073 62.4391L45.8985 62.67C45.3608 62.9728 45.1284 63.2844 45.2114 63.5935C45.2762 63.8394 45.5514 64.1225 46.029 64.4372L45.0098 65.0223L45.5205 65.3093L46.5192 64.7321C47.1691 65.0919 47.7613 65.2777 48.2792 65.284C48.824 65.2911 49.3641 65.1385 49.8835 64.8325C50.1128 64.6973 50.2678 64.5566 50.3461 64.4135L50.3453 64.4127ZM50.0322 61.7599C50.1579 61.688 50.3216 61.6595 50.5058 61.6777C50.5849 61.6856 50.6647 61.7022 50.7454 61.7275L49.8306 62.2533C49.7879 62.0272 49.8551 61.8619 50.0322 61.7607V61.7599ZM47.7439 64.3969C47.5945 64.3969 47.4387 64.3621 47.2774 64.2941L48.7363 63.4512C48.7394 63.4646 48.7426 63.4773 48.7457 63.4892C48.7726 63.6141 48.7552 63.7406 48.6928 63.8663C48.6295 63.9936 48.4927 64.1185 48.2848 64.2395C48.1029 64.3447 47.9258 64.3969 47.7439 64.3969Z",
    fill: "url(#paint108_linear_402_1371)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7671 61.7231C41.7671 61.7231 41.7671 60.4595 41.7671 62.9636C41.7671 65.4677 45.1354 67.4974 49.2896 67.4974C53.4439 67.4974 56.8122 65.4677 56.8122 62.9636C56.8122 60.9822 56.8122 61.7231 56.8122 61.7231H41.7671Z",
    fill: "url(#paint109_linear_402_1371)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6151 65.0407C51.6674 66.7351 46.8925 66.7272 43.9504 65.0296C41.0138 63.3352 41.0067 60.5931 43.9338 58.8986C46.8664 57.2011 51.6413 57.1931 54.5985 58.8876C57.562 60.5852 57.5691 63.3431 54.6151 65.0407Z",
    fill: "url(#paint110_linear_402_1371)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1046 64.7464C51.4384 66.2795 47.1189 66.2732 44.4567 64.7377C41.7992 63.2046 41.7921 60.7234 44.4416 59.1903C47.0952 57.6547 51.4147 57.6484 54.0895 59.1816C56.7692 60.7171 56.7755 63.2117 54.1046 64.7472V64.7464Z",
    fill: "#FFDB00"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3453 63.1549C50.4236 63.0102 50.4536 62.8615 50.4346 62.7129C50.4141 62.5547 50.3611 62.3673 50.2781 62.1562L49.999 61.4636L51.2443 60.7441C51.2941 60.7923 51.3281 60.8413 51.3439 60.8911C51.3779 60.9939 51.3337 61.0841 51.2198 61.1497L50.9952 61.2873L52.3433 62.0606C52.7529 61.787 52.9292 61.5102 52.8692 61.2351C52.8114 60.971 52.5102 60.6658 51.9717 60.3234L52.9047 59.785L52.4224 59.5059L51.4878 60.0427C50.9794 59.7771 50.4939 59.6213 50.0417 59.581C49.5214 59.5343 49.0541 59.6324 48.6121 59.8814C48.2081 60.1092 48.1053 60.4634 48.2998 60.967L48.5591 61.6747C48.5647 61.6889 48.5694 61.7016 48.575 61.7158L46.8362 62.7144C46.7595 62.5856 46.7762 62.4235 47.0719 62.2543L47.6317 61.934L46.3073 61.1813L45.8985 61.4122C45.3608 61.715 45.1284 62.0266 45.2114 62.3357C45.2762 62.5816 45.5514 62.8647 46.029 63.1794L45.0098 63.7645L45.5205 64.0515L46.5192 63.4743C47.1691 63.8341 47.7613 64.0199 48.2792 64.0262C48.824 64.0333 49.3641 63.8807 49.8835 63.5747C50.1128 63.4395 50.2678 63.2988 50.3461 63.1556L50.3453 63.1549ZM50.0322 60.5021C50.1579 60.4302 50.3216 60.4017 50.5058 60.4199C50.5849 60.4278 50.6647 60.4444 50.7454 60.4697L49.8306 60.9955C49.7879 60.7694 49.8551 60.6041 50.0322 60.5029V60.5021ZM47.7439 63.139C47.5945 63.139 47.4387 63.1043 47.2774 63.0363L48.7363 62.1934C48.7394 62.2068 48.7426 62.2195 48.7457 62.2313C48.7726 62.3563 48.7552 62.4836 48.6928 62.6085C48.6295 62.7358 48.4927 62.8607 48.2848 62.9817C48.1029 63.0869 47.9258 63.139 47.7439 63.139Z",
    fill: "url(#paint111_linear_402_1371)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8076 60.3285C41.8076 60.3285 41.8076 59.065 41.8076 61.5691C41.8076 64.0732 45.1759 66.1029 49.3302 66.1029C53.4844 66.1029 56.8527 64.0732 56.8527 61.5691C56.8527 59.5877 56.8527 60.3285 56.8527 60.3285H41.8076Z",
    fill: "url(#paint112_linear_402_1371)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6553 63.6461C51.7077 65.3406 46.9327 65.3327 43.9906 63.6351C41.0548 61.9406 41.0469 59.1985 43.974 57.5041C46.9066 55.8065 51.6816 55.7986 54.6387 57.4931C57.6022 59.1906 57.6093 61.9485 54.6553 63.6461Z",
    fill: "url(#paint113_linear_402_1371)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1446 63.3519C51.4784 64.885 47.1589 64.8787 44.4967 63.3432C41.8392 61.81 41.8321 59.3289 44.4817 57.7957C47.1352 56.2602 51.4547 56.2539 54.1296 57.787C56.8092 59.3225 56.8155 61.8171 54.1446 63.3526V63.3519Z",
    fill: "url(#paint114_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M45.1495 58.1737C47.6836 56.707 51.7359 56.6366 54.4258 57.9681C54.3309 57.9064 54.2321 57.8455 54.1293 57.787C51.4544 56.2539 47.1349 56.2602 44.4814 57.7957C41.8326 59.3289 41.8389 61.81 44.4964 63.3432C44.6229 63.4159 44.7542 63.4847 44.8878 63.5503C42.5118 62.0093 42.5964 59.6507 45.1495 58.1737Z",
    fill: "url(#paint115_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7193 62.0533C50.7976 61.9086 50.8276 61.76 50.8087 61.6113C50.7881 61.4532 50.7351 61.2658 50.6521 61.0547L50.373 60.362L51.6183 59.6425C51.6681 59.6907 51.7021 59.7398 51.718 59.7896C51.752 59.8924 51.7077 59.9825 51.5938 60.0481L51.3693 60.1857L52.7174 60.959C53.1269 60.6854 53.3033 60.4087 53.2432 60.1335C53.1855 59.8694 52.8842 59.5642 52.3458 59.2219L53.2788 58.6834L52.7964 58.4043L51.8619 58.9412C51.3534 58.6755 50.868 58.5197 50.4157 58.4794C49.8954 58.4328 49.4281 58.5308 48.9861 58.7799C48.5821 59.0076 48.4793 59.3618 48.6738 59.8655L48.9332 60.5731C48.9387 60.5874 48.9434 60.6 48.949 60.6143L47.2103 61.6129C47.1336 61.484 47.1502 61.3219 47.4459 61.1527L48.0057 60.8325L46.6813 60.0798L46.2725 60.3106C45.7349 60.6135 45.5024 60.925 45.5854 61.2341C45.6503 61.4801 45.9254 61.7631 46.403 62.0778L45.3838 62.6629L45.8946 62.9499L46.8932 62.3727C47.5431 62.7325 48.1354 62.9183 48.6533 62.9246C49.198 62.9317 49.7381 62.7791 50.2576 62.4732C50.4869 62.3379 50.6418 62.1972 50.7201 62.0541L50.7193 62.0533ZM50.4062 59.4006C50.5319 59.3286 50.6956 59.3001 50.8798 59.3183C50.9589 59.3262 51.0388 59.3428 51.1194 59.3681L50.2046 59.8939C50.1619 59.6678 50.2291 59.5026 50.4062 59.4013V59.4006ZM48.118 62.0375C47.9685 62.0375 47.8128 62.0027 47.6515 61.9347L49.1103 61.0918C49.1134 61.1053 49.1166 61.1179 49.1198 61.1298C49.1466 61.2547 49.1293 61.3812 49.0668 61.5069C49.0035 61.6342 48.8668 61.7592 48.6588 61.8801C48.4769 61.9853 48.2998 62.0375 48.118 62.0375Z",
    fill: "#FED9B0"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4779 61.898C50.5364 61.7897 50.5681 61.6798 50.572 61.5691C50.5736 61.532 50.5791 61.1738 50.5744 61.1358C50.5538 60.9777 50.4937 61.1105 50.4107 60.8994L50.1316 60.2068L51.3769 59.4872C51.4267 59.5355 51.4607 59.5845 51.4766 59.6343C51.5106 59.7371 51.2417 59.6019 51.1271 59.6675V60.0304L52.4752 60.8037C52.8334 60.5649 53.0136 60.323 53.0129 60.0818C53.0129 60.047 53.0239 59.7498 53.016 59.715C53.0018 59.6493 52.9575 59.8438 52.9124 59.7727C52.778 59.5592 52.5076 59.3236 52.1044 59.0674L53.0374 58.5289V58.166L52.555 58.2498L51.6205 58.7867C51.112 58.521 50.6266 58.3653 50.1743 58.3249C49.654 58.2783 49.1867 58.3763 48.7447 58.6254C48.3407 58.8531 48.2379 59.2073 48.4324 59.711L48.6918 60.4187C48.6973 60.4329 48.702 60.4456 48.7076 60.4598L46.9689 61.4584C46.8922 61.3295 46.9088 61.1674 47.2045 60.9982L47.7643 60.678V60.3151L46.4399 59.9253L46.0311 60.1562C45.7409 60.3198 45.5401 60.4851 45.4294 60.6519C45.3756 60.7334 45.3385 60.4922 45.3274 60.5736C45.3195 60.6345 45.3274 61.0188 45.3432 61.0797C45.4081 61.3256 45.6832 61.6087 46.1608 61.9233L45.1416 62.1455V62.5084L45.6524 62.7955L46.651 62.2183C47.301 62.578 47.8932 62.7638 48.4111 62.7702C48.9559 62.7773 49.4959 62.6247 50.0154 62.3187C50.2447 62.1835 50.3996 62.0427 50.4779 61.8996V61.898ZM50.1648 59.2453C50.2905 59.1733 50.4542 59.1449 50.6384 59.1631C50.7175 59.171 50.7974 59.1876 50.878 59.2129L49.9632 59.7387C49.9205 59.5125 49.9877 59.3473 50.1648 59.2461V59.2453ZM47.8766 61.8822C47.7271 61.8822 47.5714 61.8474 47.4101 61.7794L48.8689 60.9366C48.872 60.95 48.8752 60.9627 48.8784 60.9745C48.9053 61.0995 48.8879 61.226 48.8254 61.3517C48.7621 61.479 48.6254 61.6039 48.4174 61.7249C48.2355 61.83 48.0584 61.8822 47.8766 61.8822Z",
    fill: "url(#paint116_linear_402_1371)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4781 61.5357C50.5564 61.391 50.5864 61.2424 50.5675 61.0937C50.5469 60.9356 50.4939 60.7482 50.4109 60.5371L50.1318 59.8445L51.3771 59.1249C51.4269 59.1732 51.4609 59.2222 51.4767 59.272C51.5107 59.3748 51.4665 59.4649 51.3526 59.5305L51.128 59.6681L52.4762 60.4414C52.8857 60.1678 53.0621 59.8911 53.002 59.6159C52.9442 59.3519 52.643 59.0466 52.1045 58.7043L53.0376 58.1658L52.5552 57.8867L51.6206 58.4236C51.1122 58.1579 50.6268 58.0022 50.1745 57.9618C49.6542 57.9152 49.1869 58.0132 48.7449 58.2623C48.3409 58.49 48.2381 58.8442 48.4326 59.3479L48.692 60.0556C48.6975 60.0698 48.7022 60.0824 48.7078 60.0967L46.9691 61.0953C46.8924 60.9664 46.909 60.8043 47.2047 60.6351L47.7645 60.3149L46.4401 59.5622L46.0313 59.7931C45.4936 60.0959 45.2612 60.4074 45.3442 60.7166C45.409 60.9625 45.6842 61.2455 46.1618 61.5602L45.1426 62.1453L45.6534 62.4324L46.652 61.8552C47.3019 62.2149 47.8942 62.4007 48.4121 62.4071C48.9568 62.4142 49.4969 62.2616 50.0163 61.9556C50.2456 61.8204 50.4006 61.6796 50.4789 61.5365L50.4781 61.5357ZM50.165 58.883C50.2907 58.811 50.4544 58.7826 50.6386 58.8007C50.7177 58.8087 50.7975 58.8253 50.8782 58.8506L49.9634 59.3764C49.9207 59.1502 49.9879 58.985 50.165 58.8838V58.883ZM47.8768 61.5199C47.7273 61.5199 47.5716 61.4851 47.4103 61.4171L48.8691 60.5742C48.8722 60.5877 48.8754 60.6003 48.8786 60.6122C48.9054 60.7371 48.888 60.8644 48.8256 60.9894C48.7623 61.1167 48.6255 61.2416 48.4176 61.3626C48.2357 61.4677 48.0586 61.5199 47.8768 61.5199Z",
    fill: "url(#paint117_linear_402_1371)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7142 58.0677C47.3678 56.5322 51.6873 56.5259 54.3622 58.059C54.8484 58.3373 55.2461 58.6481 55.5561 58.9786C55.2224 58.5461 54.7472 58.1405 54.1289 57.787C51.454 56.2539 47.1345 56.2602 44.481 57.7957C42.3082 59.0529 41.9231 60.949 43.3219 62.4354C42.2094 60.9956 42.6711 59.2498 44.7135 58.0677H44.7142Z",
    fill: "url(#paint118_linear_402_1371)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 84.3324C30.6411 84.3324 30.6411 83.0689 30.6411 85.573C30.6411 88.0771 34.0094 90.1068 38.1637 90.1068C42.3179 90.1068 45.6862 88.0771 45.6862 85.573C45.6862 83.5916 45.6862 84.3324 45.6862 84.3324H30.6411Z",
    fill: "url(#paint119_linear_402_1371)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4898 87.6501C40.5421 89.3445 35.7672 89.3366 32.8251 87.639C29.8893 85.9445 29.8814 83.2025 32.8085 81.508C35.7411 79.8104 40.516 79.8025 43.4732 81.497C46.4367 83.1946 46.4438 85.9525 43.4898 87.6501Z",
    fill: "url(#paint120_linear_402_1371)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9791 87.3558C40.3129 88.8889 35.9934 88.8826 33.3312 87.3471C30.6737 85.8139 30.6666 83.3328 33.3161 81.7996C35.9697 80.2641 40.2892 80.2578 42.9641 81.7909C45.6437 83.3264 45.65 85.821 42.9791 87.3565V87.3558Z",
    fill: "#FFDB00"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2203 85.7623C39.2986 85.6176 39.3286 85.4689 39.3096 85.3203C39.2891 85.1621 39.2361 84.9748 39.1531 84.7637L38.874 84.071L40.1193 83.3515C40.1691 83.3997 40.2031 83.4487 40.2189 83.4986C40.2529 83.6013 40.2086 83.6915 40.0948 83.7571L39.8702 83.8947L41.2183 84.668C41.6279 84.3944 41.8042 84.1177 41.7442 83.8425C41.6864 83.5784 41.3852 83.2732 40.8467 82.9308L41.7797 82.3924L41.2974 82.1133L40.3628 82.6502C39.8544 82.3845 39.3689 82.2287 38.9167 82.1884C38.3964 82.1417 37.9291 82.2398 37.4871 82.4889C37.0831 82.7166 36.9803 83.0708 37.1748 83.5745L37.4341 84.2821C37.4397 84.2964 37.4444 84.309 37.45 84.3232L35.7112 85.3219C35.6345 85.193 35.6512 85.0309 35.9469 84.8617L36.5067 84.5415L35.1823 83.7887L34.7735 84.0196C34.2358 84.3224 34.0034 84.634 34.0864 84.9431C34.1512 85.189 34.4264 85.4721 34.904 85.7868L33.8848 86.3719L34.3955 86.6589L35.3942 86.0817C36.0441 86.4415 36.6363 86.6273 37.1542 86.6336C37.699 86.6407 38.2391 86.4881 38.7585 86.1821C38.9878 86.0469 39.1428 85.9062 39.2211 85.7631L39.2203 85.7623ZM38.9072 83.1095C39.0329 83.0376 39.1966 83.0091 39.3808 83.0273C39.4599 83.0352 39.5397 83.0518 39.6204 83.0771L38.7056 83.6029C38.6629 83.3768 38.7301 83.2115 38.9072 83.1103V83.1095ZM36.6189 85.7465C36.4695 85.7465 36.3137 85.7117 36.1524 85.6437L37.6113 84.8008C37.6144 84.8143 37.6176 84.8269 37.6207 84.8388C37.6476 84.9637 37.6302 85.0902 37.5678 85.2159C37.5045 85.3432 37.3677 85.4681 37.1598 85.5891C36.9779 85.6943 36.8008 85.7465 36.6189 85.7465Z",
    fill: "url(#paint121_linear_402_1371)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 83.0727C30.6411 83.0727 30.6411 81.8092 30.6411 84.3133C30.6411 86.8173 34.0094 88.847 38.1637 88.847C42.3179 88.847 45.6862 86.8173 45.6862 84.3133C45.6862 82.3318 45.6862 83.0727 45.6862 83.0727H30.6411Z",
    fill: "url(#paint122_linear_402_1371)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4898 86.3903C40.5421 88.0847 35.7672 88.0768 32.8251 86.3792C29.8893 84.6848 29.8814 81.9427 32.8085 80.2483C35.7411 78.5507 40.516 78.5428 43.4732 80.2372C46.4367 81.9348 46.4438 84.6927 43.4898 86.3903Z",
    fill: "url(#paint123_linear_402_1371)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9791 86.096C40.3129 87.6291 35.9934 87.6228 33.3312 86.0873C30.6737 84.5542 30.6666 82.073 33.3161 80.5399C35.9697 79.0044 40.2892 78.998 42.9641 80.5312C45.6437 82.0667 45.65 84.5613 42.9791 86.0968V86.096Z",
    fill: "#FFDB00"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2203 84.5045C39.2986 84.3598 39.3286 84.2111 39.3096 84.0625C39.2891 83.9043 39.2361 83.7169 39.1531 83.5058L38.874 82.8132L40.1193 82.0937C40.1691 82.1419 40.2031 82.1909 40.2189 82.2407C40.2529 82.3435 40.2086 82.4337 40.0948 82.4993L39.8702 82.6369L41.2183 83.4102C41.6279 83.1366 41.8042 82.8599 41.7442 82.5847C41.6864 82.3206 41.3852 82.0154 40.8467 81.673L41.7797 81.1346L41.2974 80.8555L40.3628 81.3923C39.8544 81.1267 39.3689 80.9709 38.9167 80.9306C38.3964 80.8839 37.9291 80.982 37.4871 81.231C37.0831 81.4588 36.9803 81.813 37.1748 82.3167L37.4341 83.0243C37.4397 83.0385 37.4444 83.0512 37.45 83.0654L35.7112 84.0641C35.6345 83.9352 35.6512 83.7731 35.9469 83.6039L36.5067 83.2837L35.1823 82.5309L34.7735 82.7618C34.2358 83.0646 34.0034 83.3762 34.0864 83.6853C34.1512 83.9312 34.4264 84.2143 34.904 84.529L33.8848 85.1141L34.3955 85.4011L35.3942 84.8239C36.0441 85.1837 36.6363 85.3695 37.1542 85.3758C37.699 85.3829 38.2391 85.2303 38.7585 84.9243C38.9878 84.7891 39.1428 84.6484 39.2211 84.5053L39.2203 84.5045ZM38.9072 81.8517C39.0329 81.7798 39.1966 81.7513 39.3808 81.7695C39.4599 81.7774 39.5397 81.794 39.6204 81.8193L38.7056 82.3451C38.6629 82.119 38.7301 81.9537 38.9072 81.8525V81.8517ZM36.6189 84.4887C36.4695 84.4887 36.3137 84.4539 36.1524 84.3859L37.6113 83.543C37.6144 83.5564 37.6176 83.5691 37.6207 83.581C37.6476 83.7059 37.6302 83.8332 37.5678 83.9581C37.5045 84.0854 37.3677 84.2103 37.1598 84.3313C36.9779 84.4365 36.8008 84.4887 36.6189 84.4887Z",
    fill: "url(#paint124_linear_402_1371)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 81.8129C30.6411 81.8129 30.6411 80.5494 30.6411 83.0535C30.6411 85.5576 34.0094 87.5873 38.1637 87.5873C42.3179 87.5873 45.6862 85.5576 45.6862 83.0535C45.6862 81.072 45.6862 81.8129 45.6862 81.8129H30.6411Z",
    fill: "url(#paint125_linear_402_1371)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4898 85.1305C40.5421 86.825 35.7672 86.817 32.8251 85.1194C29.8893 83.425 29.8814 80.6829 32.8085 78.9885C35.7411 77.2909 40.516 77.283 43.4732 78.9774C46.4367 80.675 46.4438 83.4329 43.4898 85.1305Z",
    fill: "url(#paint126_linear_402_1371)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9791 84.8362C40.3129 86.3694 35.9934 86.363 33.3312 84.8275C30.6737 83.2944 30.6666 80.8132 33.3161 79.2801C35.9697 77.7446 40.2892 77.7383 42.9641 79.2714C45.6437 80.8069 45.65 83.3015 42.9791 84.837V84.8362Z",
    fill: "#FFDB00"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2203 83.2447C39.2986 83.1 39.3286 82.9514 39.3096 82.8027C39.2891 82.6446 39.2361 82.4572 39.1531 82.2461L38.874 81.5534L40.1193 80.8339C40.1691 80.8821 40.2031 80.9312 40.2189 80.981C40.2529 81.0838 40.2086 81.1739 40.0948 81.2395L39.8702 81.3771L41.2183 82.1504C41.6279 81.8768 41.8042 81.6001 41.7442 81.3249C41.6864 81.0608 41.3852 80.7556 40.8467 80.4133L41.7797 79.8748L41.2974 79.5957L40.3628 80.1326C39.8544 79.8669 39.3689 79.7111 38.9167 79.6708C38.3964 79.6242 37.9291 79.7222 37.4871 79.9713C37.0831 80.199 36.9803 80.5532 37.1748 81.0569L37.4341 81.7646C37.4397 81.7788 37.4444 81.7914 37.45 81.8057L35.7112 82.8043C35.6345 82.6754 35.6512 82.5133 35.9469 82.3441L36.5067 82.0239L35.1823 81.2712L34.7735 81.502C34.2358 81.8049 34.0034 82.1164 34.0864 82.4256C34.1512 82.6715 34.4264 82.9545 34.904 83.2692L33.8848 83.8543L34.3955 84.1413L35.3942 83.5641C36.0441 83.9239 36.6363 84.1097 37.1542 84.116C37.699 84.1232 38.2391 83.9705 38.7585 83.6646C38.9878 83.5293 39.1428 83.3886 39.2211 83.2455L39.2203 83.2447ZM38.9072 80.592C39.0329 80.52 39.1966 80.4915 39.3808 80.5097C39.4599 80.5176 39.5397 80.5342 39.6204 80.5595L38.7056 81.0854C38.6629 80.8592 38.7301 80.694 38.9072 80.5928V80.592ZM36.6189 83.2289C36.4695 83.2289 36.3137 83.1941 36.1524 83.1261L37.6113 82.2832C37.6144 82.2967 37.6176 82.3093 37.6207 82.3212C37.6476 82.4461 37.6302 82.5734 37.5678 82.6983C37.5045 82.8256 37.3677 82.9506 37.1598 83.0715C36.9779 83.1767 36.8008 83.2289 36.6189 83.2289Z",
    fill: "url(#paint127_linear_402_1371)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 80.5512C30.6411 80.5512 30.6411 79.2877 30.6411 81.7918C30.6411 84.2959 34.0094 86.3255 38.1637 86.3255C42.3179 86.3255 45.6862 84.2959 45.6862 81.7918C45.6862 79.8103 45.6862 80.5512 45.6862 80.5512H30.6411Z",
    fill: "url(#paint128_linear_402_1371)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4898 83.8708C40.5421 85.5652 35.7672 85.5573 32.8251 83.8597C29.8893 82.1653 29.8814 79.4232 32.8085 77.7287C35.7411 76.0311 40.516 76.0232 43.4732 77.7177C46.4367 79.4153 46.4438 82.1732 43.4898 83.8708Z",
    fill: "url(#paint129_linear_402_1371)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9791 83.5765C40.3129 85.1096 35.9934 85.1033 33.3312 83.5678C30.6737 82.0346 30.6666 79.5535 33.3161 78.0203C35.9697 76.4848 40.2892 76.4785 42.9641 78.0116C45.6437 79.5471 45.65 82.0417 42.9791 83.5772V83.5765Z",
    fill: "#FFDB00"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2203 81.983C39.2986 81.8383 39.3286 81.6896 39.3096 81.541C39.2891 81.3829 39.2361 81.1955 39.1531 80.9844L38.874 80.2917L40.1193 79.5722C40.1691 79.6204 40.2031 79.6694 40.2189 79.7193C40.2529 79.822 40.2086 79.9122 40.0948 79.9778L39.8702 80.1154L41.2183 80.8887C41.6279 80.6151 41.8042 80.3384 41.7442 80.0632C41.6864 79.7991 41.3852 79.4939 40.8467 79.1515L41.7797 78.6131L41.2974 78.334L40.3628 78.8709C39.8544 78.6052 39.3689 78.4494 38.9167 78.4091C38.3964 78.3624 37.9291 78.4605 37.4871 78.7096C37.0831 78.9373 36.9803 79.2915 37.1748 79.7952L37.4341 80.5028C37.4397 80.5171 37.4444 80.5297 37.45 80.5439L35.7112 81.5426C35.6345 81.4137 35.6512 81.2516 35.9469 81.0824L36.5067 80.7622L35.1823 80.0094L34.7735 80.2403C34.2358 80.5432 34.0034 80.8547 34.0864 81.1638C34.1512 81.4097 34.4264 81.6928 34.904 82.0075L33.8848 82.5926L34.3955 82.8796L35.3942 82.3024C36.0441 82.6622 36.6363 82.848 37.1542 82.8543C37.699 82.8614 38.2391 82.7088 38.7585 82.4028C38.9878 82.2676 39.1428 82.1269 39.2211 81.9838L39.2203 81.983ZM38.9072 79.3302C39.0329 79.2583 39.1966 79.2298 39.3808 79.248C39.4599 79.2559 39.5397 79.2725 39.6204 79.2978L38.7056 79.8236C38.6629 79.5975 38.7301 79.4322 38.9072 79.331V79.3302ZM36.6189 81.9672C36.4695 81.9672 36.3137 81.9324 36.1524 81.8644L37.6113 81.0215C37.6144 81.035 37.6176 81.0476 37.6207 81.0595C37.6476 81.1844 37.6302 81.3117 37.5678 81.4366C37.5045 81.5639 37.3677 81.6888 37.1598 81.8098C36.9779 81.915 36.8008 81.9672 36.6189 81.9672Z",
    fill: "url(#paint130_linear_402_1371)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 79.2895C30.6411 79.2895 30.6411 78.026 30.6411 80.53C30.6411 83.0341 34.0094 85.0638 38.1637 85.0638C42.3179 85.0638 45.6862 83.0341 45.6862 80.53C45.6862 78.5486 45.6862 79.2895 45.6862 79.2895H30.6411Z",
    fill: "url(#paint131_linear_402_1371)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4898 82.6071C40.5421 84.3015 35.7672 84.2936 32.8251 82.596C29.8893 80.9016 29.8814 78.1595 32.8085 76.4651C35.7411 74.7675 40.516 74.7596 43.4732 76.454C46.4367 78.1516 46.4438 80.9095 43.4898 82.6071Z",
    fill: "url(#paint132_linear_402_1371)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9791 82.3128C40.3129 83.8459 35.9934 83.8396 33.3312 82.3041C30.6737 80.771 30.6666 78.2898 33.3161 76.7567C35.9697 75.2212 40.2892 75.2148 42.9641 76.748C45.6437 78.2835 45.65 80.7773 42.9791 82.3136V82.3128Z",
    fill: "#FFDB00"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2203 80.7193C39.2986 80.5746 39.3286 80.426 39.3096 80.2773C39.2891 80.1192 39.2361 79.9318 39.1531 79.7207L38.874 79.028L40.1193 78.3085C40.1691 78.3568 40.2031 78.4058 40.2189 78.4556C40.2529 78.5584 40.2086 78.6485 40.0948 78.7141L39.8702 78.8517L41.2183 79.625C41.6279 79.3514 41.8042 79.0747 41.7442 78.7995C41.6864 78.5354 41.3852 78.2302 40.8467 77.8879L41.7797 77.3494L41.2974 77.0703L40.3628 77.6072C39.8544 77.3415 39.3689 77.1858 38.9167 77.1454C38.3964 77.0988 37.9291 77.1968 37.4871 77.4459C37.0831 77.6736 36.9803 78.0278 37.1748 78.5315L37.4341 79.2392C37.4397 79.2534 37.4444 79.266 37.45 79.2803L35.7112 80.2789C35.6345 80.15 35.6512 79.9879 35.9469 79.8187L36.5067 79.4985L35.1823 78.7458L34.7735 78.9766C34.2358 79.2795 34.0034 79.591 34.0864 79.9002C34.1512 80.1461 34.4264 80.4291 34.904 80.7438L33.8848 81.3289L34.3955 81.6159L35.3942 81.0388C36.0441 81.3985 36.6363 81.5843 37.1542 81.5906C37.699 81.5978 38.2391 81.4452 38.7585 81.1392C38.9878 81.004 39.1428 80.8632 39.2211 80.7201L39.2203 80.7193ZM38.9072 78.0666C39.0329 77.9946 39.1966 77.9662 39.3808 77.9843C39.4599 77.9922 39.5397 78.0089 39.6204 78.0342L38.7056 78.56C38.6629 78.3346 38.7301 78.1686 38.9072 78.0674V78.0666ZM36.6189 80.7035C36.4695 80.7035 36.3137 80.6687 36.1524 80.6007L37.6113 79.7578C37.6144 79.7713 37.6176 79.7839 37.6207 79.7958C37.6476 79.9207 37.6302 80.048 37.5678 80.173C37.5045 80.3003 37.3677 80.4252 37.1598 80.5462C36.9779 80.6513 36.8008 80.7035 36.6189 80.7035Z",
    fill: "url(#paint133_linear_402_1371)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 78.0277C30.6411 78.0277 30.6411 76.7642 30.6411 79.2683C30.6411 81.7724 34.0094 83.8021 38.1637 83.8021C42.3179 83.8021 45.6862 81.7724 45.6862 79.2683C45.6862 77.2869 45.6862 78.0277 45.6862 78.0277H30.6411Z",
    fill: "url(#paint134_linear_402_1371)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4898 81.3454C40.5421 83.0398 35.7672 83.0319 32.8251 81.3343C29.8893 79.6399 29.8814 76.8978 32.8085 75.2033C35.7411 73.5057 40.516 73.4978 43.4732 75.1923C46.4367 76.8899 46.4438 79.6478 43.4898 81.3454Z",
    fill: "url(#paint135_linear_402_1371)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9791 81.0511C40.3129 82.5842 35.9934 82.5779 33.3312 81.0424C30.6737 79.5092 30.6666 77.0281 33.3161 75.4949C35.9697 73.9594 40.2892 73.9531 42.9641 75.4862C45.6437 77.0217 45.65 79.5164 42.9791 81.0519V81.0511Z",
    fill: "#FFDB00"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2203 79.4576C39.2986 79.3129 39.3286 79.1643 39.3096 79.0156C39.2891 78.8575 39.2361 78.6701 39.1531 78.459L38.874 77.7663L40.1193 77.0468C40.1691 77.095 40.2031 77.1441 40.2189 77.1939C40.2529 77.2967 40.2086 77.3868 40.0948 77.4524L39.8702 77.59L41.2183 78.3633C41.6279 78.0897 41.8042 77.813 41.7442 77.5378C41.6864 77.2737 41.3852 76.9685 40.8467 76.6262L41.7797 76.0877L41.2974 75.8086L40.3628 76.3455C39.8544 76.0798 39.3689 75.924 38.9167 75.8837C38.3964 75.8371 37.9291 75.9351 37.4871 76.1842C37.0831 76.4119 36.9803 76.7661 37.1748 77.2698L37.4341 77.9774C37.4397 77.9917 37.4444 78.0043 37.45 78.0186L35.7112 79.0172C35.6345 78.8883 35.6512 78.7262 35.9469 78.557L36.5067 78.2368L35.1823 77.4841L34.7735 77.7149C34.2358 78.0178 34.0034 78.3293 34.0864 78.6384C34.1512 78.8843 34.4264 79.1674 34.904 79.4821L33.8848 80.0672L34.3955 80.3542L35.3942 79.777C36.0441 80.1368 36.6363 80.3226 37.1542 80.3289C37.699 80.336 38.2391 80.1834 38.7585 79.8774C38.9878 79.7422 39.1428 79.6015 39.2211 79.4584L39.2203 79.4576ZM38.9072 76.8049C39.0329 76.7329 39.1966 76.7044 39.3808 76.7226C39.4599 76.7305 39.5397 76.7471 39.6204 76.7724L38.7056 77.2982C38.6629 77.0729 38.7301 76.9069 38.9072 76.8056V76.8049ZM36.6189 79.4418C36.4695 79.4418 36.3137 79.407 36.1524 79.339L37.6113 78.4961C37.6144 78.5096 37.6176 78.5222 37.6207 78.5341C37.6476 78.659 37.6302 78.7863 37.5678 78.9112C37.5045 79.0385 37.3677 79.1635 37.1598 79.2844C36.9779 79.3896 36.8008 79.4418 36.6189 79.4418Z",
    fill: "url(#paint136_linear_402_1371)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 76.768C30.6411 76.768 30.6411 75.5045 30.6411 78.0086C30.6411 80.5127 34.0094 82.5423 38.1637 82.5423C42.3179 82.5423 45.6862 80.5127 45.6862 78.0086C45.6862 76.0271 45.6862 76.768 45.6862 76.768H30.6411Z",
    fill: "url(#paint137_linear_402_1371)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4898 80.0856C40.5421 81.78 35.7672 81.7721 32.8251 80.0745C29.8893 78.3801 29.8814 75.638 32.8085 73.9436C35.7411 72.246 40.516 72.2381 43.4732 73.9325C46.4367 75.6301 46.4438 78.388 43.4898 80.0856Z",
    fill: "url(#paint138_linear_402_1371)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9791 79.7913C40.3129 81.3244 35.9934 81.3181 33.3312 79.7826C30.6737 78.2495 30.6666 75.7683 33.3161 74.2352C35.9697 72.6997 40.2892 72.6933 42.9641 74.2265C45.6437 75.762 45.65 78.2566 42.9791 79.7921V79.7913Z",
    fill: "#FFDB00"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2203 78.1978C39.2986 78.0531 39.3286 77.9045 39.3096 77.7558C39.2891 77.5977 39.2361 77.4103 39.1531 77.1992L38.874 76.5066L40.1193 75.787C40.1691 75.8353 40.2031 75.8843 40.2189 75.9341C40.2529 76.0369 40.2086 76.127 40.0948 76.1927L39.8702 76.3302L41.2183 77.1035C41.6279 76.8299 41.8042 76.5532 41.7442 76.2781C41.6864 76.014 41.3852 75.7088 40.8467 75.3664L41.7797 74.8279L41.2974 74.5488L40.3628 75.0857C39.8544 74.82 39.3689 74.6643 38.9167 74.6239C38.3964 74.5773 37.9291 74.6753 37.4871 74.9244C37.0831 75.1521 36.9803 75.5063 37.1748 76.01L37.4341 76.7177C37.4397 76.7319 37.4444 76.7446 37.45 76.7588L35.7112 77.7574C35.6345 77.6285 35.6512 77.4664 35.9469 77.2972L36.5067 76.977L35.1823 76.2243L34.7735 76.4552C34.2358 76.758 34.0034 77.0695 34.0864 77.3787C34.1512 77.6246 34.4264 77.9077 34.904 78.2223L33.8848 78.8074L34.3955 79.0945L35.3942 78.5173C36.0441 78.877 36.6363 79.0628 37.1542 79.0692C37.699 79.0763 38.2391 78.9237 38.7585 78.6177C38.9878 78.4825 39.1428 78.3417 39.2211 78.1986L39.2203 78.1978ZM38.9072 75.5451C39.0329 75.4731 39.1966 75.4447 39.3808 75.4629C39.4599 75.4708 39.5397 75.4874 39.6204 75.5127L38.7056 76.0385C38.6629 75.8131 38.7301 75.6471 38.9072 75.5459V75.5451ZM36.6189 78.182C36.4695 78.182 36.3137 78.1472 36.1524 78.0792L37.6113 77.2364C37.6144 77.2498 37.6176 77.2625 37.6207 77.2743C37.6476 77.3992 37.6302 77.5257 37.5678 77.6515C37.5045 77.7788 37.3677 77.9037 37.1598 78.0247C36.9779 78.1298 36.8008 78.182 36.6189 78.182Z",
    fill: "url(#paint139_linear_402_1371)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6611 75.3442C30.6611 75.3442 30.6611 74.0806 30.6611 76.5847C30.6611 79.0888 34.0294 81.1193 38.1837 81.1193C42.3379 81.1193 45.7062 79.0896 45.7062 76.5847C45.7062 74.6033 45.7062 75.3442 45.7062 75.3442H30.6611Z",
    fill: "url(#paint140_linear_402_1371)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5086 78.6618C40.561 80.3562 35.786 80.3483 32.8439 78.6507C29.9073 76.9563 29.9002 74.2142 32.8273 72.5197C35.76 70.8221 40.5349 70.8142 43.492 72.5087C46.4555 74.2063 46.4626 76.9642 43.5086 78.6618Z",
    fill: "url(#paint141_linear_402_1371)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9981 78.3675C40.3319 79.9006 36.0124 79.8943 33.3502 78.3588C30.6927 76.8256 30.6856 74.3445 33.3352 72.8113C35.9887 71.2758 40.3082 71.2695 42.9831 72.8026C45.6627 74.3382 45.669 76.8328 42.9981 78.3683V78.3675Z",
    fill: "url(#paint142_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M34.004 73.1893C36.5381 71.7226 40.5904 71.6522 43.2803 72.9837C43.1854 72.922 43.0866 72.8612 42.9838 72.8026C40.3089 71.2695 35.9894 71.2758 33.3359 72.8113C30.6871 74.3445 30.6934 76.8256 33.3509 78.3588C33.4774 78.4315 33.6086 78.5003 33.7423 78.5659C31.3663 77.0249 31.4509 74.6663 34.004 73.1893Z",
    fill: "url(#paint143_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5728 77.0709C39.6511 76.9262 39.6812 76.7775 39.6622 76.6289C39.6416 76.4707 39.5886 76.2834 39.5056 76.0722L39.2265 75.3796L40.4718 74.6601C40.5217 74.7083 40.5557 74.7573 40.5715 74.8072C40.6055 74.9099 40.5612 75.0001 40.4473 75.0657L40.2228 75.2033L41.5709 75.9766C41.9805 75.703 42.1568 75.4263 42.0967 75.1511C42.039 74.887 41.7377 74.5818 41.1993 74.2394L42.1323 73.701L41.65 73.4219L40.7154 73.9587C40.207 73.6931 39.7215 73.5373 39.2692 73.497C38.7489 73.4503 38.2816 73.5484 37.8397 73.7974C37.4356 74.0252 37.3328 74.3794 37.5273 74.8831L37.7867 75.5907C37.7922 75.6049 37.797 75.6176 37.8025 75.6318L36.0638 76.6305C35.9871 76.5016 36.0037 76.3395 36.2994 76.1703L36.8592 75.8501L35.5348 75.0973L35.126 75.3282C34.5884 75.631 34.3559 75.9426 34.4389 76.2517C34.5038 76.4976 34.7789 76.7807 35.2565 77.0954L34.2373 77.6805L34.7481 77.9675L35.7467 77.3903C36.3967 77.7501 36.9889 77.9359 37.5068 77.9422C38.0516 77.9493 38.5916 77.7967 39.1111 77.4907C39.3404 77.3555 39.4953 77.2148 39.5736 77.0717L39.5728 77.0709ZM39.2597 74.4181C39.3854 74.3462 39.5491 74.3177 39.7333 74.3359C39.8124 74.3438 39.8923 74.3604 39.9729 74.3857L39.0581 74.9115C39.0154 74.6854 39.0826 74.5201 39.2597 74.4189V74.4181ZM36.9715 77.0551C36.822 77.0551 36.6663 77.0203 36.505 76.9523L37.9638 76.1094C37.967 76.1228 37.9701 76.1355 37.9733 76.1474C38.0002 76.2723 37.9828 76.3996 37.9203 76.5245C37.857 76.6518 37.7203 76.7767 37.5123 76.8977C37.3305 77.0029 37.1533 77.0551 36.9715 77.0551Z",
    fill: "#FED9B0"
  }))), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3324 76.9156C39.3909 76.8073 39.4225 76.6974 39.4265 76.5867C39.4281 76.5495 39.4336 76.1914 39.4289 76.1534C39.4083 75.9953 39.3482 76.1281 39.2652 75.917L38.9861 75.2243L40.2314 74.5048C40.2812 74.5531 40.3152 74.6021 40.331 74.6519C40.365 74.7547 40.0962 74.6195 39.9816 74.6851V75.048L41.3297 75.8213C41.6879 75.5825 41.8681 75.3406 41.8673 75.0994C41.8673 75.0646 41.8784 74.7673 41.8705 74.7325C41.8563 74.6669 41.812 74.8614 41.7669 74.7903C41.6325 74.5768 41.3621 74.3412 40.9588 74.085L41.8919 73.5465V73.1836L41.4095 73.2674L40.4749 73.8043C39.9665 73.5386 39.4811 73.3828 39.0288 73.3425C38.5085 73.2959 38.0412 73.3939 37.5992 73.643C37.1952 73.8707 37.0924 74.2249 37.2869 74.7286L37.5463 75.4362C37.5518 75.4505 37.5565 75.4631 37.5621 75.4774L35.8234 76.476C35.7467 76.3471 35.7633 76.185 36.059 76.0158L36.6188 75.6956V75.3327L35.2944 74.9429L34.8856 75.1737C34.5954 75.3374 34.3946 75.5027 34.2839 75.6695C34.2301 75.7509 34.193 75.5098 34.1819 75.5912C34.174 75.6521 34.1819 76.0364 34.1977 76.0973C34.2626 76.3432 34.5377 76.6262 35.0153 76.9409L33.9961 77.1631V77.526L34.5069 77.813L35.5055 77.2358C36.1554 77.5956 36.7477 77.7814 37.2656 77.7877C37.8103 77.7949 38.3504 77.6423 38.8699 77.3363C39.0992 77.2011 39.2541 77.0603 39.3324 76.9172V76.9156ZM39.0193 74.2629C39.145 74.1909 39.3087 74.1625 39.4929 74.1806C39.572 74.1886 39.6518 74.2052 39.7325 74.2305L38.8177 74.7563C38.775 74.5301 38.8422 74.3649 39.0193 74.2637V74.2629ZM36.7311 76.8998C36.5816 76.8998 36.4259 76.865 36.2646 76.797L37.7234 75.9541C37.7265 75.9676 37.7297 75.9802 37.7329 75.9921C37.7597 76.117 37.7423 76.2443 37.6799 76.3693C37.6166 76.4966 37.4798 76.6215 37.2719 76.7425C37.09 76.8476 36.9129 76.8998 36.7311 76.8998Z",
    fill: "url(#paint144_linear_402_1371)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3326 76.5533C39.4109 76.4086 39.4409 76.26 39.4219 76.1113C39.4014 75.9532 39.3484 75.7658 39.2654 75.5547L38.9863 74.862L40.2316 74.1425C40.2814 74.1907 40.3154 74.2398 40.3312 74.2896C40.3652 74.3924 40.321 74.4825 40.2071 74.5481L39.9825 74.6857L41.3307 75.459C41.7402 75.1854 41.9166 74.9087 41.8565 74.6335C41.7987 74.3694 41.4975 74.0642 40.959 73.7219L41.892 73.1834L41.4097 72.9043L40.4751 73.4412C39.9667 73.1755 39.4812 73.0197 39.029 72.9794C38.5087 72.9328 38.0414 73.0308 37.5994 73.2799C37.1954 73.5076 37.0926 73.8618 37.2871 74.3655L37.5464 75.0731C37.552 75.0874 37.5567 75.1 37.5623 75.1143L35.8235 76.1129C35.7469 75.984 35.7635 75.8219 36.0592 75.6527L36.619 75.3325L35.2946 74.5798L34.8858 74.8106C34.3481 75.1135 34.1157 75.425 34.1987 75.7341C34.2635 75.9801 34.5387 76.2631 35.0163 76.5778L33.9971 77.1629L34.5079 77.4499L35.5065 76.8727C36.1564 77.2325 36.7486 77.4183 37.2665 77.4246C37.8113 77.4317 38.3514 77.2791 38.8708 76.9731C39.1001 76.8379 39.2551 76.6972 39.3334 76.5541L39.3326 76.5533ZM39.0195 73.9006C39.1452 73.8286 39.3089 73.8001 39.4931 73.8183C39.5722 73.8262 39.652 73.8428 39.7327 73.8681L38.8179 74.3939C38.7752 74.1678 38.8424 74.0026 39.0195 73.9013V73.9006ZM36.7313 76.5375C36.5818 76.5375 36.4261 76.5027 36.2648 76.4347L37.7236 75.5918C37.7267 75.6053 37.7299 75.6179 37.733 75.6298C37.7599 75.7547 37.7425 75.882 37.6801 76.0069C37.6168 76.1342 37.48 76.2592 37.2721 76.3801C37.0902 76.4853 36.9131 76.5375 36.7313 76.5375Z",
    fill: "url(#paint145_linear_402_1371)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5673 73.0833C36.2208 71.5478 40.5403 71.5415 43.2152 73.0746C43.7015 73.353 44.0992 73.6637 44.4091 73.9942C44.0755 73.5617 43.6003 73.1561 42.9819 72.8026C40.3071 71.2695 35.9876 71.2758 33.334 72.8113C31.1612 74.0685 30.7762 75.9646 32.1749 77.4511C31.0624 76.0112 31.5242 74.2654 33.5665 73.0833H33.5673Z",
    fill: "url(#paint146_linear_402_1371)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0142 90.8656C18.0142 90.8656 18.0142 89.6021 18.0142 92.1062C18.0142 94.6103 21.3825 96.64 25.5367 96.64C29.691 96.64 33.0593 94.6103 33.0593 92.1062C33.0593 90.1248 33.0593 90.8656 33.0593 90.8656H18.0142Z",
    fill: "url(#paint147_linear_402_1371)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8628 94.1833C27.9152 95.8777 23.1402 95.8698 20.1981 94.1722C17.2623 92.4778 17.2544 89.7357 20.1815 88.0412C23.1142 86.3436 27.8891 86.3357 30.8462 88.0302C33.8097 89.7278 33.8168 92.4857 30.8628 94.1833Z",
    fill: "url(#paint148_linear_402_1371)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3521 93.889C27.6859 95.4221 23.3664 95.4158 20.7042 93.8803C18.0467 92.3471 18.0396 89.866 20.6892 88.3328C23.3427 86.7973 27.6622 86.791 30.3371 88.3241C33.0167 89.8596 33.0231 92.3542 30.3521 93.8897V93.889Z",
    fill: "#FFDB00"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5933 92.2955C26.6716 92.1508 26.7017 92.0021 26.6827 91.8535C26.6621 91.6954 26.6092 91.508 26.5261 91.2969L26.247 90.6042L27.4923 89.8847C27.5422 89.9329 27.5762 89.9819 27.592 90.0318C27.626 90.1346 27.5817 90.2247 27.4678 90.2903L27.2433 90.4279L28.5914 91.2012C29.001 90.9276 29.1773 90.6509 29.1172 90.3757C29.0595 90.1116 28.7582 89.8064 28.2198 89.464L29.1528 88.9256L28.6705 88.6465L27.7359 89.1834C27.2275 88.9177 26.742 88.7619 26.2897 88.7216C25.7695 88.6749 25.3022 88.773 24.8602 89.0221C24.4561 89.2498 24.3533 89.604 24.5478 90.1077L24.8072 90.8153C24.8127 90.8296 24.8175 90.8422 24.823 90.8564L23.0843 91.8551C23.0076 91.7262 23.0242 91.5641 23.3199 91.3949L23.8797 91.0747L22.5553 90.3219L22.1465 90.5528C21.6089 90.8557 21.3764 91.1672 21.4594 91.4763C21.5243 91.7222 21.7994 92.0053 22.277 92.32L21.2578 92.9051L21.7686 93.1921L22.7672 92.6149C23.4172 92.9747 24.0094 93.1605 24.5273 93.1668C25.0721 93.1739 25.6121 93.0213 26.1316 92.7153C26.3609 92.5801 26.5159 92.4394 26.5941 92.2963L26.5933 92.2955ZM26.2802 89.6427C26.4059 89.5708 26.5696 89.5423 26.7539 89.5605C26.8329 89.5684 26.9128 89.585 26.9934 89.6103L26.0786 90.1361C26.0359 89.9108 26.1031 89.7447 26.281 89.6435L26.2802 89.6427ZM23.992 92.2797C23.8426 92.2797 23.6868 92.2449 23.5255 92.1769L24.9843 91.334C24.9875 91.3475 24.9906 91.3601 24.9938 91.372C25.0207 91.4969 25.0033 91.6242 24.9408 91.7491C24.8776 91.8764 24.7408 92.0013 24.5328 92.1223C24.351 92.2275 24.1739 92.2797 23.992 92.2797Z",
    fill: "url(#paint149_linear_402_1371)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0142 89.6059C18.0142 89.6059 18.0142 88.3424 18.0142 90.8465C18.0142 93.3505 21.3825 95.3802 25.5367 95.3802C29.691 95.3802 33.0593 93.3505 33.0593 90.8465C33.0593 88.865 33.0593 89.6059 33.0593 89.6059H18.0142Z",
    fill: "url(#paint150_linear_402_1371)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8628 92.9235C27.9152 94.6179 23.1402 94.61 20.1981 92.9124C17.2623 91.218 17.2544 88.4759 20.1815 86.7815C23.1142 85.0839 27.8891 85.076 30.8462 86.7704C33.8097 88.468 33.8168 91.2259 30.8628 92.9235Z",
    fill: "url(#paint151_linear_402_1371)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3521 92.6292C27.6859 94.1623 23.3664 94.156 20.7042 92.6205C18.0467 91.0874 18.0396 88.6062 20.6892 87.0731C23.3427 85.5376 27.6622 85.5312 30.3371 87.0644C33.0167 88.5999 33.0231 91.0945 30.3521 92.63V92.6292Z",
    fill: "#FFDB00"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5933 91.0357C26.6716 90.891 26.7017 90.7424 26.6827 90.5937C26.6621 90.4356 26.6092 90.2482 26.5261 90.0371L26.247 89.3444L27.4923 88.6249C27.5422 88.6732 27.5762 88.7222 27.592 88.772C27.626 88.8748 27.5817 88.9649 27.4678 89.0305L27.2433 89.1681L28.5914 89.9414C29.001 89.6678 29.1773 89.3911 29.1172 89.1159C29.0595 88.8519 28.7582 88.5466 28.2198 88.2043L29.1528 87.6658L28.6705 87.3867L27.7359 87.9236C27.2275 87.6579 26.742 87.5022 26.2897 87.4618C25.7695 87.4152 25.3022 87.5132 24.8602 87.7623C24.4561 87.99 24.3533 88.3442 24.5478 88.8479L24.8072 89.5556C24.8127 89.5698 24.8175 89.5824 24.823 89.5967L23.0843 90.5953C23.0076 90.4664 23.0242 90.3043 23.3199 90.1351L23.8797 89.8149L22.5553 89.0622L22.1465 89.2931C21.6089 89.5959 21.3764 89.9074 21.4594 90.2166C21.5243 90.4625 21.7994 90.7455 22.277 91.0602L21.2578 91.6453L21.7686 91.9324L22.7672 91.3552C23.4172 91.7149 24.0094 91.9007 24.5273 91.907C25.0721 91.9142 25.6121 91.7616 26.1316 91.4556C26.3609 91.3204 26.5159 91.1796 26.5941 91.0365L26.5933 91.0357ZM26.2802 88.383C26.4059 88.311 26.5696 88.2826 26.7539 88.3007C26.8329 88.3086 26.9128 88.3253 26.9934 88.3506L26.0786 88.8764C26.0359 88.651 26.1031 88.485 26.281 88.3838L26.2802 88.383ZM23.992 91.0199C23.8426 91.0199 23.6868 90.9851 23.5255 90.9171L24.9843 90.0742C24.9875 90.0877 24.9906 90.1003 24.9938 90.1122C25.0207 90.2371 25.0033 90.3636 24.9408 90.4894C24.8776 90.6167 24.7408 90.7416 24.5328 90.8626C24.351 90.9677 24.1739 91.0199 23.992 91.0199Z",
    fill: "url(#paint152_linear_402_1371)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0698 88.2387C18.0698 88.2387 18.0698 86.9752 18.0698 89.4793C18.0698 91.9834 21.4381 94.013 25.5924 94.013C29.7466 94.013 33.1149 91.9834 33.1149 89.4793C33.1149 87.4978 33.1149 88.2387 33.1149 88.2387H18.0698Z",
    fill: "url(#paint153_linear_402_1371)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9183 91.5563C27.9707 93.2507 23.1957 93.2428 20.2536 91.5452C17.317 89.8508 17.3099 87.1087 20.237 85.4143C23.1696 83.7167 27.9446 83.7088 30.9017 85.4032C33.8652 87.1008 33.8723 89.8587 30.9183 91.5563Z",
    fill: "url(#paint154_linear_402_1371)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4073 91.262C27.7411 92.7951 23.4216 92.7888 20.7594 91.2533C18.1019 89.7202 18.0948 87.239 20.7444 85.7059C23.3979 84.1704 27.7174 84.164 30.3923 85.6972C33.0719 87.2327 33.0782 89.7273 30.4073 91.2628V91.262Z",
    fill: "url(#paint155_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M21.4127 86.0838C23.9468 84.6171 27.9991 84.5467 30.689 85.8782C30.5941 85.8166 30.4953 85.7557 30.3925 85.6972C27.7176 84.164 23.3981 84.1704 20.7446 85.7059C18.0958 87.239 18.1021 89.7202 20.7596 91.2533C20.8861 91.3261 21.0173 91.3948 21.151 91.4605C18.775 89.9194 18.8596 87.5608 21.4127 86.0838Z",
    fill: "url(#paint156_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9815 89.9654C27.0598 89.8207 27.0898 89.6721 27.0709 89.5234C27.0503 89.3653 26.9973 89.1779 26.9143 88.9668L26.6352 88.2741L27.8805 87.5546C27.9303 87.6028 27.9643 87.6519 27.9802 87.7017C28.0142 87.8045 27.9699 87.8946 27.856 87.9602L27.6315 88.0978L28.9796 88.8711C29.3892 88.5975 29.5655 88.3208 29.5054 88.0456C29.4477 87.7815 29.1464 87.4763 28.608 87.134L29.541 86.5955L29.0586 86.3164L28.1241 86.8533C27.6157 86.5876 27.1302 86.4318 26.6779 86.3915C26.1576 86.3449 25.6903 86.4429 25.2483 86.692C24.8443 86.9197 24.7415 87.2739 24.936 87.7776L25.1954 88.4852C25.2009 88.4995 25.2057 88.5121 25.2112 88.5264L23.4725 89.525C23.3958 89.3961 23.4124 89.234 23.7081 89.0648L24.2679 88.7446L22.9435 87.9919L22.5347 88.2227C21.9971 88.5256 21.7646 88.8371 21.8476 89.1463C21.9125 89.3922 22.1876 89.6752 22.6652 89.9899L21.646 90.575L22.1568 90.862L23.1554 90.2848C23.8054 90.6446 24.3976 90.8304 24.9155 90.8367C25.4603 90.8439 26.0003 90.6913 26.5198 90.3853C26.7491 90.2501 26.904 90.1093 26.9823 89.9662L26.9815 89.9654ZM26.6684 87.3127C26.7941 87.2407 26.9578 87.2122 27.142 87.2304C27.2211 87.2383 27.301 87.2549 27.3816 87.2802L26.4668 87.8061C26.4241 87.5799 26.4913 87.4147 26.6684 87.3135V87.3127ZM24.3802 89.9496C24.2307 89.9496 24.075 89.9148 23.9137 89.8468L25.3725 89.0039C25.3756 89.0174 25.3788 89.03 25.382 89.0419C25.4089 89.1668 25.3915 89.2933 25.329 89.419C25.2657 89.5463 25.129 89.6713 24.921 89.7922C24.7391 89.8974 24.562 89.9496 24.3802 89.9496Z",
    fill: "#FED9B0"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7411 89.8101C26.7996 89.7018 26.8312 89.5919 26.8352 89.4812C26.8368 89.4441 26.8423 89.0859 26.8376 89.0479C26.817 88.8898 26.7569 89.0226 26.6739 88.8115L26.3948 88.1189L27.6401 87.3994C27.6899 87.4476 27.7239 87.4966 27.7397 87.5464C27.7737 87.6492 27.5049 87.514 27.3903 87.5796V87.9426L28.7384 88.7158C29.0965 88.4771 29.2768 88.2351 29.276 87.9939C29.276 87.9592 29.2871 87.6619 29.2792 87.6271C29.265 87.5614 29.2207 87.756 29.1756 87.6848C29.0412 87.4713 28.7708 87.2357 28.3675 86.9795L29.3005 86.441V86.0781L28.8182 86.1619L27.8836 86.6988C27.3752 86.4331 26.8898 86.2774 26.4375 86.2371C25.9172 86.1904 25.4499 86.2884 25.0079 86.5375C24.6039 86.7652 24.5011 87.1194 24.6956 87.6231L24.955 88.3308C24.9605 88.345 24.9652 88.3577 24.9708 88.3719L23.2321 89.3705C23.1554 89.2416 23.172 89.0796 23.4677 88.9103L24.0275 88.5901V88.2272L22.7031 87.8374L22.2943 88.0683C22.0041 88.2319 21.8033 88.3972 21.6926 88.564C21.6388 88.6455 21.6017 88.4043 21.5906 88.4858C21.5827 88.5466 21.5906 88.9309 21.6064 88.9918C21.6712 89.2377 21.9464 89.5208 22.424 89.8355L21.4048 90.0576V90.4205L21.9156 90.7076L22.9142 90.1304C23.5641 90.4901 24.1564 90.6759 24.6743 90.6823C25.219 90.6894 25.7591 90.5368 26.2786 90.2308C26.5079 90.0956 26.6628 89.9548 26.7411 89.8117V89.8101ZM26.428 87.1574C26.5537 87.0855 26.7174 87.057 26.9016 87.0752C26.9807 87.0831 27.0605 87.0997 27.1412 87.125L26.2264 87.6508C26.1837 87.4247 26.2509 87.2594 26.428 87.1582V87.1574ZM24.1398 89.7943C23.9903 89.7943 23.8346 89.7595 23.6733 89.6915L25.1321 88.8487C25.1352 88.8621 25.1384 88.8748 25.1416 88.8866C25.1684 89.0116 25.151 89.1389 25.0886 89.2638C25.0253 89.3911 24.8885 89.516 24.6806 89.637C24.4987 89.7422 24.3216 89.7943 24.1398 89.7943Z",
    fill: "url(#paint157_linear_402_1371)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7413 89.4478C26.8196 89.3031 26.8496 89.1545 26.8306 89.0058C26.8101 88.8477 26.7571 88.6603 26.6741 88.4492L26.395 87.7566L27.6403 87.037C27.6901 87.0853 27.7241 87.1343 27.7399 87.1841C27.7739 87.2869 27.7296 87.377 27.6158 87.4427L27.3912 87.5802L28.7393 88.3535C29.1489 88.08 29.3252 87.8032 29.2651 87.5281C29.2074 87.264 28.9062 86.9588 28.3677 86.6164L29.3007 86.0779L28.8184 85.7988L27.8838 86.3357C27.3754 86.07 26.8899 85.9143 26.4377 85.8739C25.9174 85.8273 25.4501 85.9253 25.0081 86.1744C24.6041 86.4021 24.5013 86.7563 24.6958 87.26L24.9551 87.9677C24.9607 87.9819 24.9654 87.9946 24.971 88.0088L23.2322 89.0074C23.1555 88.8785 23.1721 88.7164 23.4679 88.5472L24.0277 88.227L22.7033 87.4743L22.2945 87.7052C21.7568 88.008 21.5244 88.3195 21.6074 88.6287C21.6722 88.8746 21.9474 89.1576 22.425 89.4723L21.4058 90.0574L21.9165 90.3445L22.9152 89.7673C23.5651 90.127 24.1573 90.3128 24.6752 90.3192C25.22 90.3263 25.7601 90.1737 26.2795 89.8677C26.5088 89.7325 26.6638 89.5917 26.7421 89.4486L26.7413 89.4478ZM26.4282 86.7951C26.5539 86.7231 26.7176 86.6947 26.9018 86.7129C26.9809 86.7208 27.0607 86.7374 27.1414 86.7627L26.2266 87.2885C26.1839 87.0623 26.2511 86.8971 26.4282 86.7959V86.7951ZM24.1399 89.432C23.9905 89.432 23.8347 89.3972 23.6734 89.3292L25.1323 88.4864C25.1354 88.4998 25.1386 88.5124 25.1417 88.5243C25.1686 88.6492 25.1512 88.7765 25.0888 88.9015C25.0255 89.0288 24.8887 89.1537 24.6808 89.2747C24.4989 89.3798 24.3218 89.432 24.1399 89.432Z",
    fill: "url(#paint158_linear_402_1371)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9765 85.9779C23.63 84.4424 27.9495 84.436 30.6244 85.9692C31.1106 86.2475 31.5084 86.5582 31.8183 86.8887C31.4846 86.4562 31.0094 86.0506 30.3911 85.6972C27.7162 84.164 23.3967 84.1704 20.7432 85.7059C18.5704 86.9631 18.1853 88.8591 19.5841 90.3456C18.4716 88.9058 18.9333 87.1599 20.9757 85.9787L20.9765 85.9779Z",
    fill: "url(#paint159_linear_402_1371)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26875 104.966L5.25488 103.86L40.2442 31.082L42.2098 32.2957L7.26875 104.966Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M68.156 17.0613L60.5781 6.26927L70.4039 0.59375L68.156 17.0613Z",
    fill: "#D1D3D4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1959 31.1907L46.2612 48.0291L64.8652 5.2207L68.6257 7.23299L45.7141 59.6039L39.5918 42.3322L40.1959 31.1907Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26855 104.967L13.7822 101.207L41.6055 43.4388L47.7278 61.1035L67.8704 14.741L70.4805 18.3251L72.3354 1.74609L62.5072 7.37655L64.986 10.7804L48.1627 49.4725L42.2096 32.2973L7.26855 104.967Z",
    fill: "url(#paint160_linear_402_1371)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5781 6.26927L62.5074 7.37386L72.3356 1.7434L70.4039 0.59375L60.5781 6.26927Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5781 6.27148L62.5074 7.37607L64.9862 10.78L62.9423 9.63031L60.5781 6.27148Z",
    fill: "url(#paint161_linear_402_1371)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8706 14.7402L70.4807 18.3244L68.1561 17.0633L67.2871 16.0883L67.8706 14.7402Z",
    fill: "url(#paint162_linear_402_1371)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5239 45.7249L41.6056 43.4375L47.7278 61.1021L45.5716 59.8971L40.5239 45.7249Z",
    fill: "url(#paint163_linear_402_1371)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37972 89.2507C3.37972 89.2507 3.42164 88.8647 3.37656 88.784C3.33147 88.7033 3.26503 88.5981 3.26503 88.5981C3.26503 88.5981 3.19542 88.3719 3.18118 88.375C3.16773 88.3782 2.91778 88.5071 2.88772 88.5601C2.85766 88.6123 2.81732 88.8828 2.82049 88.9936C2.82365 89.1043 3.10129 89.3725 3.10129 89.3725C3.14875 89.4389 3.17802 89.5267 3.19384 89.6311L3.52289 89.5797C3.44221 89.3725 3.37972 89.2507 3.37972 89.2507Z",
    fill: "url(#paint164_linear_402_1371)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93533 88.5166C2.93533 88.5166 2.91001 88.7468 2.9464 88.7887C2.98279 88.8306 3.19715 88.9888 3.26754 88.9619C3.33794 88.935 3.34269 88.67 3.34269 88.67L3.18053 88.375L2.93454 88.5158L2.93533 88.5166Z",
    fill: "url(#paint165_linear_402_1371)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52258 91.7771C3.63644 91.2901 3.7495 90.3578 3.55262 89.5703L3.09877 89.6091C3.07584 90.3649 3.04184 90.8243 2.81966 91.6221C2.54846 92.5963 3.3597 92.4729 3.52258 91.7771Z",
    fill: "url(#paint166_linear_402_1371)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19351 89.6302L3.16504 89.506L3.48618 89.4316L3.52257 89.5788L3.19351 89.6302Z",
    fill: "url(#paint167_linear_402_1371)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10013 106.59H1.22748L1.21482 106.406L1.29313 106.595L2.2091 106.633C2.2091 106.633 2.2091 106.527 2.07384 106.452C2.04774 106.438 2.01531 106.424 1.97655 106.413C1.81202 106.366 1.53201 106.223 1.53201 106.223L1.50037 106.133H1.49958L1.09222 106.219L1.08984 106.24L1.09934 106.59H1.10013Z",
    fill: "#3A4135"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88646 98.2255C2.78367 98.6193 2.11396 102.757 2.00248 103.393C1.8902 104.03 1.50039 106.134 1.50039 106.134H1.50118C1.50118 106.134 1.72337 106.324 1.88546 106.384C1.71704 106.353 1.79532 106.479 1.70755 106.464C1.31142 106.394 1.09794 106.32 1.09082 106.242L1.09319 106.221L1.16277 105.929C1.44188 104.043 0.925568 102.563 1.32012 101.682C1.32012 100.16 1.21179 99.4266 1.23789 98.4762C1.23789 98.4762 0.987241 97.5163 1.73839 97.3052C2.48954 97.0941 2.83744 97.6222 2.88567 98.2263L2.88646 98.2255Z",
    fill: "url(#paint168_linear_402_1371)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19974 107.128H2.32709L2.31443 106.945L2.39274 107.133L3.30871 107.171C3.30871 107.171 3.30871 107.065 3.17345 106.991C3.14735 106.977 3.11492 106.963 3.07616 106.952C2.91163 106.905 2.63162 106.762 2.63162 106.762L2.59998 106.672H2.59919L2.19183 106.758L2.18945 106.779L2.19894 107.129L2.19974 107.128Z",
    fill: "#3A4135"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25607 98.9858C2.22998 99.937 2.41974 100.695 2.41974 102.217C2.0244 103.1 2.54072 104.58 2.2624 106.465L2.19281 106.757L2.19044 106.778C2.19756 106.855 2.41104 106.93 2.80718 107C2.89494 107.016 2.81666 106.889 2.98508 106.92C2.82378 106.859 2.60081 106.67 2.60081 106.67H2.60002C2.60002 106.67 2.98982 104.566 3.1021 103.929C3.21359 103.293 4.00348 99.1297 4.10627 98.7359C4.10627 98.7359 4.3917 96.8707 3.07285 97.0787C2.50909 97.168 1.98012 97.5823 2.25607 98.9858Z",
    fill: "url(#paint169_linear_402_1371)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95174 95.7039C3.95174 95.7039 4.35815 96.4448 4.25694 97.8127C4.17234 98.9497 3.91536 101.507 3.89718 101.614C3.87899 101.722 2.29605 102.046 1.64848 101.776L1.49666 99.9056L1.25946 101.74C1.25946 101.74 1.04518 101.662 1.03174 101.503C1.0183 101.345 1.13453 99.1956 1.03174 98.3899C0.928955 97.5849 0.723377 96.5294 1.57969 95.7893L3.95174 95.7031V95.7039Z",
    fill: "url(#paint170_linear_402_1371)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12205 88.207C2.06196 88.3209 1.64685 88.721 1.38672 90.3498L2.87953 90.2683C2.87953 90.2683 2.41144 89.2033 2.8906 88.5091L2.12126 88.207H2.12205Z",
    fill: "url(#paint171_linear_402_1371)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18229 86.9453C3.18229 86.9453 3.25187 87.1058 3.1981 87.4514C3.13801 87.8775 3.23605 87.819 3.30247 87.9866C3.31275 88.0127 3.26135 88.0183 3.18703 88.0428C3.19573 88.2405 3.09768 88.8319 3.01703 88.809C2.56714 88.6801 2.22161 88.5172 2.22556 88.0768C1.7812 87.5399 1.92431 87.0212 1.92431 87.0212L3.18229 86.9453Z",
    fill: "url(#paint172_linear_402_1371)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02211 89.8899C3.95274 90.1295 3.89977 90.7605 4.34967 91.8034C4.52124 92.2003 3.97884 92.8605 3.90846 93.5603C3.80014 94.6372 3.83019 94.9622 3.83019 94.9622L4.3718 96.4241C4.3718 96.4241 3.40796 98.1186 1.18614 97.1508C0.630294 97.063 1.334 95.5575 1.334 95.5575C1.334 95.5575 1.27154 94.6151 0.91573 93.021C0.325881 90.3794 0.709362 89.848 1.14898 89.6148C1.54274 89.406 3.02211 89.8899 3.02211 89.8899Z",
    fill: "url(#paint173_linear_402_1371)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26362 92.038C5.26362 92.038 4.84377 91.2307 4.35908 90.9927C3.92342 90.7792 3.69254 90.8678 3.64905 90.9879C3.60556 91.1081 4.12583 92.3906 4.38122 92.6342C4.70698 92.9441 5.51664 92.4942 5.26362 92.038Z",
    fill: "url(#paint174_linear_402_1371)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01087 92.6828C4.30163 93.1485 3.41528 92.3262 2.89263 91.345C2.68389 90.9528 2.49729 90.5646 2.74399 90.219C2.96063 89.9146 3.34095 89.8261 3.70862 90.1732C4.20042 90.6365 4.15615 91.4952 4.78711 91.6597C5.22357 91.7727 5.55486 92.3262 5.01087 92.6828Z",
    fill: "url(#paint175_linear_402_1371)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22603 89.3248C1.75637 89.1809 1.50256 89.3137 1.50256 89.3137L1.22266 89.7873C1.22266 89.7873 1.58795 90.0562 2.25133 90.0451C2.62375 90.0388 3.05309 89.8893 3.05309 89.8893C3.05309 89.8893 2.77239 89.4932 2.22603 89.3256V89.3248Z",
    fill: "#F1F2F2"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0.993344 88.4913C1.16255 88.2153 1.24162 87.9821 1.23529 87.7551C1.22264 87.3179 1.2179 87.0111 1.75082 86.6126C2.00542 86.422 2.24895 86.3485 2.45927 86.3374C2.60238 86.1176 2.97954 86.2528 2.99931 86.4545C3.16456 86.2908 3.37567 86.6577 3.23256 86.8292C3.4326 87.0388 3.24679 87.1171 3.15507 87.1368C2.97242 87.1756 2.81824 87.2388 2.83089 87.6247C2.83247 87.6729 2.6435 87.5085 2.63638 87.567C2.49406 87.7844 2.78582 87.9307 2.7534 88.0335C2.7534 88.0335 3.17958 88.3758 2.81903 88.9941C2.7028 89.4804 3.17247 89.1333 3.19223 89.6314C3.212 90.1296 3.13372 90.9479 2.03467 90.8056C1.90105 91.1203 1.31436 91.0238 1.22106 90.6577C0.926136 90.7945 0.512608 90.517 0.89609 90.0552C1.27957 89.5943 0.50233 89.2883 0.991762 88.4913H0.993344Z",
    fill: "#8C6239"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M116.039 107.974C128.95 107.974 139.416 101.879 139.416 94.361C139.416 86.8428 128.95 80.748 116.039 80.748C103.129 80.748 92.6631 86.8428 92.6631 94.361C92.6631 101.879 103.129 107.974 116.039 107.974Z",
    fill: "#E5D4EF"
  }))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M116.039 107.171C128.95 107.171 139.416 101.076 139.416 93.5582C139.416 86.04 128.95 79.9453 116.039 79.9453C103.129 79.9453 92.6631 86.04 92.6631 93.5582C92.6631 101.076 103.129 107.171 116.039 107.171Z",
    fill: "#EBDEF3"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M116.044 103.621C126.669 103.621 135.282 98.6057 135.282 92.4189C135.282 86.2322 126.669 81.2168 116.044 81.2168C105.419 81.2168 96.8062 86.2322 96.8062 92.4189C96.8062 98.6057 105.419 103.621 116.044 103.621Z",
    fill: "#6B24D6"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M116.044 84.4504C125.721 84.4504 133.723 88.6079 135.08 94.0261C135.21 93.5016 135.287 92.9627 135.287 92.4189C135.287 86.2308 126.674 81.2168 116.049 81.2168C105.424 81.2168 96.811 86.2308 96.811 92.4189C96.811 92.9675 96.888 93.5016 97.0179 94.0261C98.3749 88.6127 106.377 84.4504 116.054 84.4504H116.044Z",
    fill: "url(#paint176_linear_402_1371)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M127.785 92.9082H104.231V94.2844C104.231 94.3085 104.231 94.3325 104.231 94.3614C104.231 97.4025 109.505 99.8711 116.006 99.8711C122.507 99.8711 127.781 97.4025 127.781 94.3614C127.781 94.3373 127.781 94.3085 127.781 94.2844V92.9082H127.785Z",
    fill: "url(#paint177_linear_402_1371)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M116.006 98.4548C122.509 98.4548 127.78 95.9881 127.78 92.9452C127.78 89.9023 122.509 87.4355 116.006 87.4355C109.503 87.4355 104.231 89.9023 104.231 92.9452C104.231 95.9881 109.503 98.4548 116.006 98.4548Z",
    fill: "url(#paint178_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M127.78 93.4614C127.737 90.4347 122.483 87.9902 116.006 87.9902C109.529 87.9902 104.274 90.4347 104.231 93.4614V97.975C104.231 97.999 104.231 98.0231 104.231 98.052C104.231 101.093 109.505 103.562 116.006 103.562C122.507 103.562 127.78 101.093 127.78 98.052C127.78 98.0279 127.78 97.999 127.78 97.975V93.4614Z",
    fill: "url(#paint179_linear_402_1371)"
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M106.473 75.0758C105.871 77.7849 102.763 87.0623 100.679 86.6004C98.591 86.1384 98.1772 76.1345 98.9182 73.3965C99.5582 71.0386 101.435 69.8212 103.518 70.288C105.607 70.7499 107.002 72.6891 106.473 75.0758Z",
    fill: "url(#paint180_linear_402_1371)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M116.155 64.2832C106.738 64.2832 99.1011 66.2801 99.1011 74.5711C99.1011 79.7824 101.44 88.1503 105.126 94.5839C106.661 96.6097 111.001 98.0677 116.116 98.0677C121.231 98.0677 125.966 96.4701 127.304 94.3048C127.323 94.2711 127.361 94.2374 127.41 94.2037C130.97 87.8231 133.218 79.6813 133.218 74.5759C133.218 66.285 125.581 64.288 116.164 64.288L116.155 64.2832Z",
    fill: "url(#paint181_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M116.155 64.2832C106.738 64.2832 99.1011 66.2801 99.1011 74.5711C99.1011 79.7824 101.44 88.1503 105.126 94.5839C106.661 96.6097 111.001 98.0677 116.116 98.0677C121.231 98.0677 125.966 96.4701 127.304 94.3048C127.323 94.2711 127.361 94.2374 127.41 94.2037C130.97 87.8231 133.218 79.6813 133.218 74.5759C133.218 66.285 125.581 64.288 116.164 64.288L116.155 64.2832Z",
    fill: "url(#paint182_radial_402_1371)"
  }), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M116.189 82.7827C125.32 82.7827 132.722 78.4718 132.722 73.154C132.722 67.8363 125.32 63.5254 116.189 63.5254C107.057 63.5254 99.6548 67.8363 99.6548 73.154C99.6548 78.4718 107.057 82.7827 116.189 82.7827Z",
    fill: "url(#paint183_linear_402_1371)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M116.184 82.6006C125.203 82.6006 132.515 78.3414 132.515 73.0874C132.515 67.8334 125.203 63.5742 116.184 63.5742C107.164 63.5742 99.8521 67.8334 99.8521 73.0874C99.8521 78.3414 107.164 82.6006 116.184 82.6006Z",
    fill: "url(#paint184_linear_402_1371)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M116.179 82.4186C125.087 82.4186 132.308 78.2132 132.308 73.0257C132.308 67.8381 125.087 63.6328 116.179 63.6328C107.271 63.6328 100.049 67.8381 100.049 73.0257C100.049 78.2132 107.271 82.4186 116.179 82.4186Z",
    fill: "url(#paint185_linear_402_1371)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M116.169 82.2364C124.966 82.2364 132.097 78.0828 132.097 72.959C132.097 67.8353 124.966 63.6816 116.169 63.6816C107.373 63.6816 100.242 67.8353 100.242 72.959C100.242 78.0828 107.373 82.2364 116.169 82.2364Z",
    fill: "url(#paint186_linear_402_1371)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M116.165 82.0485C124.852 82.0485 131.895 77.9488 131.895 72.8915C131.895 67.8341 124.852 63.7344 116.165 63.7344C107.477 63.7344 100.435 67.8341 100.435 72.8915C100.435 77.9488 107.477 82.0485 116.165 82.0485Z",
    fill: "url(#paint187_linear_402_1371)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M116.16 81.8645C124.736 81.8645 131.688 77.8164 131.688 72.8229C131.688 67.8293 124.736 63.7812 116.16 63.7812C107.584 63.7812 100.632 67.8293 100.632 72.8229C100.632 77.8164 107.584 81.8645 116.16 81.8645Z",
    fill: "url(#paint188_linear_402_1371)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M116.155 81.6862C124.619 81.6862 131.481 77.6899 131.481 72.7601C131.481 67.8303 124.619 63.834 116.155 63.834C107.691 63.834 100.829 67.8303 100.829 72.7601C100.829 77.6899 107.691 81.6862 116.155 81.6862Z",
    fill: "url(#paint189_linear_402_1371)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M116.145 81.4984C124.498 81.4984 131.269 77.5559 131.269 72.6925C131.269 67.8292 124.498 63.8867 116.145 63.8867C107.793 63.8867 101.021 67.8292 101.021 72.6925C101.021 77.5559 107.793 81.4984 116.145 81.4984Z",
    fill: "url(#paint190_linear_402_1371)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M116.141 81.3162C124.382 81.3162 131.062 77.4254 131.062 72.6259C131.062 67.8263 124.382 63.9355 116.141 63.9355C107.899 63.9355 101.219 67.8263 101.219 72.6259C101.219 77.4254 107.899 81.3162 116.141 81.3162Z",
    fill: "url(#paint191_linear_402_1371)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M116.136 81.1341C124.265 81.1341 130.855 77.295 130.855 72.5592C130.855 67.8235 124.265 63.9844 116.136 63.9844C108.006 63.9844 101.416 67.8235 101.416 72.5592C101.416 77.295 108.006 81.1341 116.136 81.1341Z",
    fill: "url(#paint192_linear_402_1371)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M116.126 80.9521C124.144 80.9521 130.644 77.1668 130.644 72.4975C130.644 67.8282 124.144 64.043 116.126 64.043C108.108 64.043 101.608 67.8282 101.608 72.4975C101.608 77.1668 108.108 80.9521 116.126 80.9521Z",
    fill: "url(#paint193_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.05,
    d: "M118.06 78.8883C125.871 78.8883 132.202 75.2021 132.202 70.6551C132.202 66.108 125.871 62.4219 118.06 62.4219C110.25 62.4219 103.918 66.108 103.918 70.6551C103.918 75.2021 110.25 78.8883 118.06 78.8883Z",
    fill: "url(#paint194_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09,
    d: "M118.027 78.6954C125.63 78.6954 131.794 75.1062 131.794 70.6788C131.794 66.2513 125.63 62.6621 118.027 62.6621C110.423 62.6621 104.26 66.2513 104.26 70.6788C104.26 75.1062 110.423 78.6954 118.027 78.6954Z",
    fill: "url(#paint195_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14,
    d: "M117.993 78.5026C125.391 78.5026 131.389 75.0104 131.389 70.7025C131.389 66.3946 125.391 62.9023 117.993 62.9023C110.594 62.9023 104.596 66.3946 104.596 70.7025C104.596 75.0104 110.594 78.5026 117.993 78.5026Z",
    fill: "url(#paint196_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18,
    d: "M117.964 78.3098C125.155 78.3098 130.985 74.9145 130.985 70.7262C130.985 66.5379 125.155 63.1426 117.964 63.1426C110.773 63.1426 104.943 66.5379 104.943 70.7262C104.943 74.9145 110.773 78.3098 117.964 78.3098Z",
    fill: "url(#paint197_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M117.93 78.1169C124.914 78.1169 130.576 74.8186 130.576 70.7499C130.576 66.6812 124.914 63.3828 117.93 63.3828C110.946 63.3828 105.284 66.6812 105.284 70.7499C105.284 74.8186 110.946 78.1169 117.93 78.1169Z",
    fill: "url(#paint198_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.27,
    d: "M117.896 77.9242C124.676 77.9242 130.172 74.725 130.172 70.7785C130.172 66.8321 124.676 63.6328 117.896 63.6328C111.117 63.6328 105.621 66.8321 105.621 70.7785C105.621 74.725 111.117 77.9242 117.896 77.9242Z",
    fill: "url(#paint199_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32,
    d: "M117.863 77.7333C124.435 77.7333 129.763 74.631 129.763 70.8042C129.763 66.9773 124.435 63.875 117.863 63.875C111.291 63.875 105.963 66.9773 105.963 70.8042C105.963 74.631 111.291 77.7333 117.863 77.7333Z",
    fill: "url(#paint200_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M117.834 77.5405C124.199 77.5405 129.359 74.5351 129.359 70.8279C129.359 67.1206 124.199 64.1152 117.834 64.1152C111.469 64.1152 106.31 67.1206 106.31 70.8279C106.31 74.5351 111.469 77.5405 117.834 77.5405Z",
    fill: "url(#paint201_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.41,
    d: "M117.801 77.3477C123.961 77.3477 128.955 74.4393 128.955 70.8516C128.955 67.2639 123.961 64.3555 117.801 64.3555C111.64 64.3555 106.646 67.2639 106.646 70.8516C106.646 74.4393 111.64 77.3477 117.801 77.3477Z",
    fill: "url(#paint202_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45,
    d: "M117.766 77.1548C123.719 77.1548 128.545 74.3434 128.545 70.8753C128.545 67.4072 123.719 64.5957 117.766 64.5957C111.814 64.5957 106.988 67.4072 106.988 70.8753C106.988 74.3434 111.814 77.1548 117.766 77.1548Z",
    fill: "url(#paint203_linear_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M117.733 76.9582C123.481 76.9582 128.141 74.2459 128.141 70.9C128.141 67.5541 123.481 64.8418 117.733 64.8418C111.985 64.8418 107.325 67.5541 107.325 70.9C107.325 74.2459 111.985 76.9582 117.733 76.9582Z",
    fill: "url(#paint204_linear_402_1371)"
  }), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M131.275 85.3288C133.094 83.5098 133.094 80.5605 131.275 78.7415C129.455 76.9225 126.506 76.9225 124.687 78.7415C122.868 80.5605 122.868 83.5098 124.687 85.3288C126.506 87.1479 129.455 87.1479 131.275 85.3288Z",
    fill: "url(#paint205_radial_402_1371)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M132.587 84.1022C131.995 87.6053 127.073 95.3043 124.989 94.8424C122.901 94.3805 124.763 84.8962 125.365 82.187C125.894 79.8003 127.881 78.6118 129.965 79.0785C132.053 79.5405 132.992 81.6962 132.587 84.107V84.1022Z",
    fill: "url(#paint206_linear_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M132.587 84.1022C131.995 87.6053 127.073 95.3043 124.989 94.8424C122.901 94.3805 124.763 84.8962 125.365 82.187C125.894 79.8003 127.881 78.6118 129.965 79.0785C132.053 79.5405 132.992 81.6962 132.587 84.107V84.1022Z",
    fill: "url(#paint207_radial_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M129.128 83.2369C128.925 86.0038 125.701 93.7991 125.033 93.751C124.364 93.7028 125.47 86.6726 125.851 83.694C126.159 81.2688 126.9 80.0418 127.54 79.8301C129.359 79.2334 129.31 80.8021 129.128 83.2369Z",
    fill: "url(#paint208_radial_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M132.154 84.4655C131.297 88.5653 127.077 94.0124 126.418 93.8873C125.759 93.7622 129.512 88.267 130.239 85.3557C130.831 82.9835 130.263 80.5727 130.922 80.4428C132.794 80.0626 132.65 82.0788 132.149 84.4704L132.154 84.4655Z",
    fill: "url(#paint209_radial_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M107.281 81.7982C109.557 90.936 112.045 96.4841 110.924 96.9942C108.951 97.8892 103.422 92.5336 101.146 83.3909C99.1444 75.3454 100.092 65.8851 102.171 65.3655C104.255 64.8458 105.275 73.7526 107.277 81.7982H107.281Z",
    fill: "url(#paint210_radial_402_1371)"
  }), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M133.179 62.7869C133.179 70.8084 125.634 77.2323 116.328 77.2323C107.022 77.2323 99.4766 70.8132 99.4766 62.7869C99.4766 53.4806 107.022 45.9355 116.328 45.9355C125.634 45.9355 133.179 53.4806 133.179 62.7869Z",
    fill: "url(#paint211_radial_402_1371)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M100.838 64.2731C104.365 68.546 109.326 71.3947 114.797 72.2849C116.27 72.5255 117.608 71.3899 117.608 69.8934V65.5001C117.608 63.5368 116.323 61.8093 114.446 61.2367C110.491 60.0337 106.896 57.8636 103.999 54.9139C103.311 54.2161 102.137 54.3749 101.68 55.2363C100.742 57.0071 100.116 58.9703 99.8757 61.0491C99.7409 62.2087 100.097 63.3732 100.838 64.2731Z",
    fill: "url(#paint212_linear_402_1371)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M115.442 71.8036C109.971 70.9134 105.01 68.0648 101.483 63.7918C100.742 62.8919 100.386 61.7275 100.521 60.5678C100.761 58.489 101.387 56.5258 102.325 54.755C102.364 54.6828 102.412 54.6251 102.46 54.5625C102.142 54.678 101.858 54.9041 101.685 55.2362C100.747 57.007 100.121 58.9702 99.8806 61.049C99.7458 62.2086 100.102 63.3731 100.843 64.273C104.37 68.5459 109.331 71.3946 114.802 72.2848C115.63 72.4195 116.419 72.1164 116.948 71.563C116.506 71.794 115.986 71.8902 115.447 71.8036H115.442Z",
    fill: "url(#paint213_linear_402_1371)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M105.203 62.2234C105.203 63.0222 104.64 63.3397 103.947 62.9404C103.254 62.541 102.691 61.569 102.691 60.7702C102.691 59.9714 103.254 59.6538 103.947 60.0532C104.64 60.4526 105.203 61.4246 105.203 62.2234Z",
    fill: "#2AF6FF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M112.44 66.405C112.44 67.2038 111.877 67.5214 111.184 67.122C110.491 66.7226 109.928 65.7506 109.928 64.9518C109.928 64.153 110.491 63.8354 111.184 64.2348C111.877 64.6342 112.44 65.6062 112.44 66.405Z",
    fill: "#2AF6FF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M121.308 48.3125H111.227V49.0439C111.227 49.0439 111.227 49.0728 111.227 49.0824C111.227 50.704 113.484 52.0177 116.27 52.0177C119.056 52.0177 121.313 50.704 121.313 49.0824C121.313 49.068 121.313 49.0535 121.313 49.0439V48.3125H121.308Z",
    fill: "url(#paint214_linear_402_1371)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M116.265 51.2709C119.05 51.2709 121.308 49.9568 121.308 48.3357C121.308 46.7146 119.05 45.4004 116.265 45.4004C113.48 45.4004 111.222 46.7146 111.222 48.3357C111.222 49.9568 113.48 51.2709 116.265 51.2709Z",
    fill: "url(#paint215_linear_402_1371)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M117.02 41.377H115.514V48.0174C115.514 48.2676 115.851 48.4601 116.27 48.4601C116.688 48.4601 117.025 48.2628 117.025 48.0222V48.0174V41.377H117.02Z",
    fill: "url(#paint216_linear_402_1371)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M116.265 43.8128C117.503 43.8128 118.507 42.8089 118.507 41.5705C118.507 40.3321 117.503 39.3281 116.265 39.3281C115.026 39.3281 114.022 40.3321 114.022 41.5705C114.022 42.8089 115.026 43.8128 116.265 43.8128Z",
    fill: "url(#paint217_radial_402_1371)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M121.315 61.5185C122.667 55.8494 119.167 50.1579 113.498 48.8063C107.829 47.4547 102.137 50.9547 100.786 56.6238C99.4341 62.293 102.934 67.9844 108.603 69.336C114.272 70.6876 119.964 67.1876 121.315 61.5185Z",
    fill: "url(#paint218_radial_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M107.227 64.7227C109.071 62.8792 109.071 59.8903 107.227 58.0469C105.384 56.2034 102.395 56.2034 100.551 58.0469C98.7078 59.8903 98.7078 62.8792 100.551 64.7227C102.395 66.5661 105.384 66.5661 107.227 64.7227Z",
    fill: "url(#paint219_radial_402_1371)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M115.126 68.4328C116.616 66.2939 116.091 63.3516 113.952 61.8611C111.813 60.3706 108.87 60.8963 107.38 63.0353C105.889 65.1742 106.415 68.1165 108.554 69.607C110.693 71.0975 113.635 70.5718 115.126 68.4328Z",
    fill: "url(#paint220_radial_402_1371)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M127.827 75.3223C133.59 69.5589 133.59 60.2145 127.827 54.4511C122.063 48.6877 112.719 48.6877 106.956 54.4511C101.192 60.2145 101.192 69.5589 106.956 75.3223C112.719 81.0857 122.063 81.0857 127.827 75.3223Z",
    fill: "url(#paint221_linear_402_1371)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M123.402 78.1439C130.615 74.946 133.899 66.5711 130.737 59.4382C127.574 52.3052 119.163 49.1152 111.95 52.3131C104.737 55.5111 101.453 63.8859 104.616 71.0189C107.778 78.1519 116.189 81.3419 123.402 78.1439Z",
    fill: "url(#paint222_linear_402_1371)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M123.485 77.8849C130.446 74.7609 133.614 66.7132 130.561 59.9099C127.507 53.1065 119.389 50.1238 112.428 53.2478C105.467 56.3718 102.299 64.4195 105.353 71.2229C108.406 78.0262 116.524 81.0089 123.485 77.8849Z",
    fill: "url(#paint223_linear_402_1371)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M123.574 77.6134C130.282 74.562 133.334 66.8427 130.391 60.3718C127.447 53.9009 119.623 51.1288 112.915 54.1801C106.207 57.2315 103.155 64.9508 106.099 71.4217C109.042 77.8926 116.866 80.6648 123.574 77.6134Z",
    fill: "url(#paint224_linear_402_1371)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M123.658 77.354C130.113 74.3766 133.05 66.9842 130.218 60.8425C127.385 54.7008 119.855 52.1356 113.4 55.1129C106.945 58.0903 104.008 65.4827 106.84 71.6244C109.673 77.7661 117.203 80.3313 123.658 77.354Z",
    fill: "url(#paint225_linear_402_1371)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M123.748 77.096C129.952 74.1898 132.774 67.1203 130.05 61.306C127.327 55.4917 120.089 53.1342 113.885 56.0405C107.681 58.9467 104.859 66.0162 107.583 71.8305C110.307 77.6448 117.544 80.0023 123.748 77.096Z",
    fill: "url(#paint226_linear_402_1371)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M123.829 76.8389C129.782 74.0045 132.491 67.2602 129.879 61.7751C127.267 56.2899 120.324 54.141 114.371 56.9753C108.418 59.8097 105.709 66.554 108.321 72.0392C110.933 77.5244 117.876 79.6733 123.829 76.8389Z",
    fill: "url(#paint227_linear_402_1371)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M123.916 76.581C129.619 73.8154 132.214 67.3922 129.713 62.2343C127.212 57.0764 120.561 55.1371 114.858 57.9026C109.155 60.6682 106.559 67.0914 109.061 72.2493C111.562 77.4072 118.213 79.3465 123.916 76.581Z",
    fill: "url(#paint228_linear_402_1371)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M123.999 76.331C129.451 73.6348 131.935 67.5307 129.545 62.6971C127.155 57.8635 120.797 56.1308 115.344 58.8271C109.891 61.5233 107.408 67.6274 109.798 72.461C112.188 77.2946 118.546 79.0273 123.999 76.331Z",
    fill: "url(#paint229_linear_402_1371)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M124.082 76.0816C129.284 73.4539 131.655 67.6682 129.377 63.1589C127.099 58.6495 121.036 57.1241 115.834 59.7519C110.632 62.3796 108.261 68.1653 110.539 72.6747C112.817 77.184 118.88 78.7094 124.082 76.0816Z",
    fill: "url(#paint230_linear_402_1371)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M124.16 75.8306C129.114 73.2678 131.375 67.7957 129.209 63.6082C127.043 59.4207 121.271 58.1036 116.316 60.6663C111.361 63.2291 109.101 68.7013 111.267 72.8888C113.432 77.0763 119.205 78.3934 124.16 75.8306Z",
    fill: "url(#paint231_linear_402_1371)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M124.245 75.59C128.951 73.0909 131.1 67.9293 129.046 64.0613C126.992 60.1932 121.512 59.0834 116.806 61.5825C112.1 64.0815 109.95 69.2431 112.004 73.1112C114.059 76.9793 119.539 78.0891 124.245 75.59Z",
    fill: "url(#paint232_linear_402_1371)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M124.324 75.3465C128.783 72.9095 130.825 68.0567 128.885 64.5075C126.945 60.9582 121.758 60.0566 117.299 62.4936C112.841 64.9307 110.799 69.7835 112.739 73.3327C114.679 76.8819 119.866 77.7836 124.324 75.3465Z",
    fill: "url(#paint233_linear_402_1371)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M124.402 75.1149C128.614 72.7368 130.547 68.1864 128.721 64.9512C126.894 61.716 121.999 61.0212 117.787 63.3992C113.575 65.7773 111.642 70.3277 113.469 73.5629C115.295 76.7981 120.19 77.4929 124.402 75.1149Z",
    fill: "url(#paint234_linear_402_1371)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M124.482 74.8928C128.447 72.5711 130.274 68.3185 128.562 65.3945C126.85 62.4705 122.247 61.9823 118.282 64.304C114.317 66.6257 112.49 70.8782 114.203 73.8022C115.915 76.7262 120.517 77.2145 124.482 74.8928Z",
    fill: "url(#paint235_linear_402_1371)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M114.485 73.0204C113.657 70.0034 116.203 66.1779 120.168 64.4696C124.133 62.7614 128.016 63.8248 128.844 66.8419C129.671 69.859 127.126 73.6845 123.161 75.3927C119.196 77.1009 115.312 76.0375 114.485 73.0204Z",
    fill: "url(#paint236_linear_402_1371)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M115.274 73.4872C114.437 70.8118 116.742 67.2029 120.433 65.4225C124.119 63.6469 127.79 64.3735 128.627 67.0489C129.465 69.7243 127.16 73.3333 123.469 75.1137C119.783 76.8893 116.112 76.1627 115.274 73.4872Z",
    fill: "url(#paint237_linear_402_1371)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M116.058 73.951C115.207 71.6172 117.281 68.2248 120.692 66.377C124.104 64.5292 127.559 64.9238 128.411 67.2576C129.262 69.5914 127.188 72.9838 123.777 74.8316C120.365 76.6793 116.91 76.2847 116.058 73.951Z",
    fill: "url(#paint238_linear_402_1371)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M116.848 74.4161C115.982 72.424 117.824 69.2481 120.957 67.3281C124.09 65.4082 127.328 65.4659 128.194 67.4629C129.06 69.455 127.217 72.6309 124.085 74.5508C120.952 76.4708 117.714 76.413 116.848 74.4161Z",
    fill: "url(#paint239_linear_402_1371)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M117.637 74.8785C116.761 73.2232 118.363 70.2687 121.222 68.2813C124.075 66.2892 127.102 66.0149 127.978 67.6702C128.853 69.3255 127.251 72.28 124.393 74.2674C121.539 76.2595 118.513 76.5338 117.637 74.8785Z",
    fill: "url(#paint240_linear_402_1371)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M118.421 75.3455C117.531 74.0319 118.902 71.2987 121.481 69.2344C124.06 67.1701 126.871 66.5638 127.761 67.8774C128.651 69.1911 127.28 71.9243 124.7 73.9886C122.121 76.0529 119.311 76.6592 118.421 75.3455Z",
    fill: "url(#paint241_linear_402_1371)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M119.21 75.8091C118.311 74.8371 119.446 72.3204 121.746 70.1888C124.046 68.0571 126.645 67.1139 127.545 68.0859C128.444 69.058 127.309 71.5746 125.009 73.7063C122.709 75.838 120.11 76.7811 119.21 75.8091Z",
    fill: "url(#paint242_linear_402_1371)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_1371",
    x1: 49.8486,
    y1: 73.2623,
    x2: 71.5687,
    y2: 73.2623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_1371",
    x1: 61.2636,
    y1: 59.4857,
    x2: 64.6572,
    y2: 86.2116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_1371",
    x1: 48.888,
    y1: 67.151,
    x2: 73.3454,
    y2: 73.3752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_1371",
    x1: -19.4714,
    y1: 72.0005,
    x2: -19.3923,
    y2: 72.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_1371",
    x1: 61.2636,
    y1: 58.226,
    x2: 64.6572,
    y2: 84.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_1371",
    x1: 48.888,
    y1: 65.8912,
    x2: 73.3454,
    y2: 72.1155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_1371",
    x1: -19.4714,
    y1: 70.738,
    x2: -19.3923,
    y2: 70.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_402_1371",
    x1: 61.2636,
    y1: 56.9642,
    x2: 64.6572,
    y2: 83.6893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_402_1371",
    x1: 48.888,
    y1: 64.6295,
    x2: 73.3454,
    y2: 70.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_402_1371",
    x1: -19.4714,
    y1: 69.4763,
    x2: -19.3923,
    y2: 69.4763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_402_1371",
    x1: 61.2636,
    y1: 55.7045,
    x2: 64.6572,
    y2: 82.4296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_402_1371",
    x1: 48.888,
    y1: 63.3697,
    x2: 73.3454,
    y2: 69.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_402_1371",
    x1: -19.4714,
    y1: 68.2165,
    x2: -19.3923,
    y2: 68.2165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_402_1371",
    x1: 61.2636,
    y1: 54.4416,
    x2: 64.6572,
    y2: 81.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_402_1371",
    x1: 48.888,
    y1: 62.108,
    x2: 73.3454,
    y2: 68.3315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_402_1371",
    x1: -19.4714,
    y1: 66.9556,
    x2: -19.3923,
    y2: 66.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_402_1371",
    x1: 61.2636,
    y1: 53.181,
    x2: 64.6572,
    y2: 79.9069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_402_1371",
    x1: 48.888,
    y1: 60.8475,
    x2: 73.3454,
    y2: 67.0717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_402_1371",
    x1: -19.4714,
    y1: 65.6958,
    x2: -19.3923,
    y2: 65.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_402_1371",
    x1: 61.2636,
    y1: 51.9213,
    x2: 64.6572,
    y2: 78.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_402_1371",
    x1: 48.888,
    y1: 59.5865,
    x2: 73.3454,
    y2: 65.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_402_1371",
    x1: -19.4714,
    y1: 64.4361,
    x2: -19.3923,
    y2: 64.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_402_1371",
    x1: 61.2636,
    y1: 50.6615,
    x2: 64.6572,
    y2: 77.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_402_1371",
    x1: 48.888,
    y1: 58.3268,
    x2: 73.3454,
    y2: 64.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_402_1371",
    x1: -19.4714,
    y1: 63.1697,
    x2: -19.3923,
    y2: 63.1697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_402_1371",
    x1: 61.2636,
    y1: 49.3959,
    x2: 64.6572,
    y2: 76.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_402_1371",
    x1: 48.888,
    y1: 57.0611,
    x2: 73.3454,
    y2: 63.2854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_402_1371",
    x1: -19.4714,
    y1: 61.9099,
    x2: -19.3923,
    y2: 61.9099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_402_1371",
    x1: 61.2636,
    y1: 48.1361,
    x2: 64.6572,
    y2: 74.8612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_402_1371",
    x1: 48.888,
    y1: 55.8014,
    x2: 73.3454,
    y2: 62.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_402_1371",
    x1: -19.4714,
    y1: 60.6482,
    x2: -19.3923,
    y2: 60.6482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_402_1371",
    x1: 61.2636,
    y1: 46.8732,
    x2: 64.6572,
    y2: 73.5983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_402_1371",
    x1: 48.888,
    y1: 54.5397,
    x2: 73.3454,
    y2: 60.7631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_402_1371",
    x1: -19.4714,
    y1: 59.3873,
    x2: -19.3923,
    y2: 59.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_402_1371",
    x1: 61.2636,
    y1: 45.6127,
    x2: 64.6572,
    y2: 72.3385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_402_1371",
    x1: 48.888,
    y1: 53.2791,
    x2: 73.3454,
    y2: 59.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_402_1371",
    x1: -19.4714,
    y1: 58.1255,
    x2: -19.3923,
    y2: 58.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_402_1371",
    x1: 61.2636,
    y1: 44.351,
    x2: 64.6572,
    y2: 71.0768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_402_1371",
    x1: 48.888,
    y1: 52.0162,
    x2: 73.3454,
    y2: 58.2405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_402_1371",
    x1: -19.4714,
    y1: 56.8443,
    x2: -19.3923,
    y2: 56.8443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_402_1371",
    x1: 61.2636,
    y1: 43.0697,
    x2: 64.6572,
    y2: 69.7956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_402_1371",
    x1: 48.888,
    y1: 50.7361,
    x2: 73.3454,
    y2: 56.9604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_402_1371",
    x1: -19.4714,
    y1: 55.5845,
    x2: -19.3923,
    y2: 55.5845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_402_1371",
    x1: 61.2636,
    y1: 41.8099,
    x2: 64.6572,
    y2: 68.5358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_402_1371",
    x1: 48.888,
    y1: 49.4752,
    x2: 73.3454,
    y2: 55.6995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_402_1371",
    x1: -19.4714,
    y1: 54.3208,
    x2: -19.3923,
    y2: 54.3208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_402_1371",
    x1: 61.2636,
    y1: 40.5463,
    x2: 64.6572,
    y2: 67.2721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_402_1371",
    x1: 48.888,
    y1: 48.2115,
    x2: 73.3454,
    y2: 54.4358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_402_1371",
    x1: -19.4714,
    y1: 53.0603,
    x2: -19.3923,
    y2: 53.0603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_402_1371",
    x1: 61.2636,
    y1: 39.2865,
    x2: 64.6572,
    y2: 66.0116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_402_1371",
    x1: 48.888,
    y1: 46.9518,
    x2: 73.3454,
    y2: 53.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_402_1371",
    x1: -19.4714,
    y1: 51.7986,
    x2: -19.3923,
    y2: 51.7986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_402_1371",
    x1: 61.2636,
    y1: 38.0248,
    x2: 64.6572,
    y2: 64.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_402_1371",
    x1: 48.888,
    y1: 45.69,
    x2: 73.3454,
    y2: 51.9135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_402_1371",
    x1: -19.4714,
    y1: 50.5388,
    x2: -19.3923,
    y2: 50.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_402_1371",
    x1: 61.2636,
    y1: 36.7639,
    x2: 64.6572,
    y2: 63.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_402_1371",
    x1: 48.888,
    y1: 44.4295,
    x2: 73.3454,
    y2: 50.6537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_402_1371",
    x1: -19.4714,
    y1: 49.2759,
    x2: -19.3923,
    y2: 49.2759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_402_1371",
    x1: 61.2636,
    y1: 35.5013,
    x2: 64.6572,
    y2: 62.2272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_402_1371",
    x1: 48.888,
    y1: 43.1678,
    x2: 73.3454,
    y2: 49.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_402_1371",
    x1: -19.4714,
    y1: 48.0162,
    x2: -19.3923,
    y2: 48.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_402_1371",
    x1: 61.2636,
    y1: 34.2416,
    x2: 64.6572,
    y2: 60.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_402_1371",
    x1: 48.888,
    y1: 41.9068,
    x2: 73.3454,
    y2: 48.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_402_1371",
    x1: -19.4714,
    y1: 46.7544,
    x2: -19.3923,
    y2: 46.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_402_1371",
    x1: 61.2636,
    y1: 32.9779,
    x2: 64.6572,
    y2: 59.7038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_402_1371",
    x1: 48.888,
    y1: 40.6432,
    x2: 73.3454,
    y2: 46.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_402_1371",
    x1: -19.4714,
    y1: 45.4939,
    x2: -19.3923,
    y2: 45.4939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_402_1371",
    x1: 61.2636,
    y1: 31.7181,
    x2: 64.6572,
    y2: 58.4432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_402_1371",
    x1: 61.0423,
    y1: 38.2498,
    x2: 67.2902,
    y2: 56.2363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_402_1371",
    x1: 60.6977,
    y1: 38.6222,
    x2: 64.8022,
    y2: 50.4366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#754904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#855207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C27615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E98C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_402_1371",
    x1: 63.2999,
    y1: 34.3607,
    x2: 62.2736,
    y2: 45.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F9D422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F8B221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F89C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_402_1371",
    x1: 62.4224,
    y1: 39.413,
    x2: 62.556,
    y2: 49.9014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F4B41D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EE9E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EC971A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D18119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AA6019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9B5419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_402_1371",
    x1: 55.8729,
    y1: 41.9724,
    x2: 68.9294,
    y2: 41.9724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FDBB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F9A323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_402_1371",
    x1: 36.4355,
    y1: 79.5837,
    x2: 58.1556,
    y2: 79.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_402_1371",
    x1: 47.8508,
    y1: 65.8107,
    x2: 51.2444,
    y2: 92.5358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_402_1371",
    x1: 35.4749,
    y1: 73.4772,
    x2: 59.9323,
    y2: 79.7006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_402_1371",
    x1: 36.436,
    y1: 78.324,
    x2: 58.1561,
    y2: 78.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_402_1371",
    x1: 47.8508,
    y1: 64.5502,
    x2: 51.2444,
    y2: 91.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_402_1371",
    x1: 35.4749,
    y1: 72.2166,
    x2: 59.9323,
    y2: 78.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_402_1371",
    x1: 36.436,
    y1: 77.065,
    x2: 58.1561,
    y2: 77.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_402_1371",
    x1: 47.8508,
    y1: 63.2904,
    x2: 51.2444,
    y2: 90.0163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_402_1371",
    x1: 35.4749,
    y1: 70.9557,
    x2: 59.9323,
    y2: 77.1799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_402_1371",
    x1: 36.4355,
    y1: 75.8013,
    x2: 58.1556,
    y2: 75.8013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_402_1371",
    x1: 47.8508,
    y1: 62.0267,
    x2: 51.2444,
    y2: 88.7526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_402_1371",
    x1: 35.4749,
    y1: 69.692,
    x2: 59.9323,
    y2: 75.9163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_402_1371",
    x1: 36.4355,
    y1: 74.5408,
    x2: 58.1556,
    y2: 74.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_402_1371",
    x1: 47.8508,
    y1: 60.767,
    x2: 51.2444,
    y2: 87.4921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_402_1371",
    x1: 35.4749,
    y1: 68.4322,
    x2: 59.9323,
    y2: 74.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_402_1371",
    x1: 36.436,
    y1: 73.279,
    x2: 58.1561,
    y2: 73.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_402_1371",
    x1: 47.8508,
    y1: 59.5072,
    x2: 51.2444,
    y2: 86.2323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_402_1371",
    x1: 35.4749,
    y1: 67.1725,
    x2: 59.9323,
    y2: 73.3967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_402_1371",
    x1: 36.4355,
    y1: 72.0154,
    x2: 58.1556,
    y2: 72.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_402_1371",
    x1: 47.8508,
    y1: 58.2424,
    x2: 51.2444,
    y2: 84.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_402_1371",
    x1: 35.4749,
    y1: 65.9088,
    x2: 59.9323,
    y2: 72.1323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_402_1371",
    x1: 36.4355,
    y1: 70.7556,
    x2: 58.1556,
    y2: 70.7556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_402_1371",
    x1: 47.8508,
    y1: 56.9818,
    x2: 51.2444,
    y2: 83.7077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_402_1371",
    x1: 35.4749,
    y1: 64.6482,
    x2: 59.9323,
    y2: 70.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_402_1371",
    x1: 36.4355,
    y1: 69.4947,
    x2: 58.1556,
    y2: 69.4947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_402_1371",
    x1: 47.8508,
    y1: 55.722,
    x2: 51.2444,
    y2: 82.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_402_1371",
    x1: 35.4749,
    y1: 63.3873,
    x2: 59.9323,
    y2: 69.6116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_402_1371",
    x1: 36.4355,
    y1: 68.2349,
    x2: 58.1556,
    y2: 68.2349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_402_1371",
    x1: 47.8508,
    y1: 54.4584,
    x2: 51.2444,
    y2: 81.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_402_1371",
    x1: 35.4749,
    y1: 62.1236,
    x2: 59.9323,
    y2: 68.3479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_402_1371",
    x1: 36.436,
    y1: 66.9704,
    x2: 58.1561,
    y2: 66.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_402_1371",
    x1: 47.8508,
    y1: 53.1967,
    x2: 51.2444,
    y2: 79.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_402_1371",
    x1: 35.4749,
    y1: 60.8619,
    x2: 59.9323,
    y2: 67.0862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_402_1371",
    x1: 36.4355,
    y1: 65.7087,
    x2: 58.1556,
    y2: 65.7087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_402_1371",
    x1: 47.8508,
    y1: 51.9369,
    x2: 51.2444,
    y2: 78.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_402_1371",
    x1: 35.4749,
    y1: 59.6022,
    x2: 59.9323,
    y2: 65.8264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_402_1371",
    x1: 36.4355,
    y1: 64.4509,
    x2: 58.1556,
    y2: 64.4509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_402_1371",
    x1: 47.8508,
    y1: 50.6779,
    x2: 51.2444,
    y2: 77.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_402_1371",
    x1: 35.4749,
    y1: 58.3443,
    x2: 59.9323,
    y2: 64.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_402_1371",
    x1: 36.476,
    y1: 63.0564,
    x2: 58.1961,
    y2: 63.0564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_402_1371",
    x1: 47.891,
    y1: 49.2826,
    x2: 51.2846,
    y2: 76.0077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_402_1371",
    x1: 47.6697,
    y1: 55.8143,
    x2: 53.9177,
    y2: 73.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_402_1371",
    x1: 47.3247,
    y1: 56.1867,
    x2: 51.4291,
    y2: 68.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#754904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#855207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C27615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E98C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_402_1371",
    x1: 49.9276,
    y1: 51.9252,
    x2: 48.9005,
    y2: 63.0382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F9D422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F8B221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F89C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_402_1371",
    x1: 49.0493,
    y1: 56.9774,
    x2: 49.183,
    y2: 67.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F4B41D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EE9E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EC971A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D18119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AA6019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9B5419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_402_1371",
    x1: 42.5003,
    y1: 59.5376,
    x2: 55.5569,
    y2: 59.5376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FDBB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F9A323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_402_1371",
    x1: 25.3103,
    y1: 87.0603,
    x2: 47.0304,
    y2: 87.0603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_402_1371",
    x1: 36.7255,
    y1: 73.2865,
    x2: 40.1191,
    y2: 100.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_402_1371",
    x1: 24.3499,
    y1: 80.9518,
    x2: 48.8065,
    y2: 87.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_402_1371",
    x1: 25.3103,
    y1: 85.8005,
    x2: 47.0304,
    y2: 85.8005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_402_1371",
    x1: 36.7255,
    y1: 72.0275,
    x2: 40.1191,
    y2: 98.7526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_402_1371",
    x1: 24.3499,
    y1: 79.694,
    x2: 48.8065,
    y2: 85.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_402_1371",
    x1: 25.3103,
    y1: 84.5408,
    x2: 47.0304,
    y2: 84.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_402_1371",
    x1: 36.7255,
    y1: 70.767,
    x2: 40.1191,
    y2: 97.4928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_402_1371",
    x1: 24.3499,
    y1: 78.4334,
    x2: 48.8065,
    y2: 84.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_402_1371",
    x1: 25.3103,
    y1: 83.2798,
    x2: 47.0304,
    y2: 83.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_402_1371",
    x1: 36.7255,
    y1: 69.5072,
    x2: 40.1191,
    y2: 96.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_402_1371",
    x1: 24.3499,
    y1: 77.1725,
    x2: 48.8065,
    y2: 83.3967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_402_1371",
    x1: 25.3103,
    y1: 82.0181,
    x2: 47.0304,
    y2: 82.0181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_402_1371",
    x1: 36.7255,
    y1: 68.2435,
    x2: 40.1191,
    y2: 94.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_402_1371",
    x1: 24.3499,
    y1: 75.9088,
    x2: 48.8065,
    y2: 82.1331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_402_1371",
    x1: 25.3103,
    y1: 80.7556,
    x2: 47.0304,
    y2: 80.7556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_402_1371",
    x1: 36.7255,
    y1: 66.9818,
    x2: 40.1191,
    y2: 93.7069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_402_1371",
    x1: 24.3499,
    y1: 74.6471,
    x2: 48.8065,
    y2: 80.8713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_402_1371",
    x1: 25.3103,
    y1: 79.4958,
    x2: 47.0304,
    y2: 79.4958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_402_1371",
    x1: 36.7255,
    y1: 65.7221,
    x2: 40.1191,
    y2: 92.4471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_402_1371",
    x1: 24.3499,
    y1: 73.3873,
    x2: 48.8065,
    y2: 79.6116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_402_1371",
    x1: 25.3303,
    y1: 78.0728,
    x2: 47.0504,
    y2: 78.0728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_402_1371",
    x1: 36.7444,
    y1: 64.2982,
    x2: 40.1388,
    y2: 91.0241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_402_1371",
    x1: 36.5232,
    y1: 70.8299,
    x2: 42.7712,
    y2: 88.8156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_402_1371",
    x1: 36.1784,
    y1: 71.2023,
    x2: 40.2828,
    y2: 83.0175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#754904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#855207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C27615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E98C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_402_1371",
    x1: 38.7813,
    y1: 66.9427,
    x2: 37.755,
    y2: 78.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F9D422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F8B221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F89C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_402_1371",
    x1: 37.903,
    y1: 71.995,
    x2: 38.0367,
    y2: 82.4826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F4B41D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EE9E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EC971A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D18119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AA6019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9B5419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_402_1371",
    x1: 31.3534,
    y1: 74.5532,
    x2: 44.4099,
    y2: 74.5532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FDBB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F9A323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_402_1371",
    x1: 12.6834,
    y1: 93.5943,
    x2: 34.4034,
    y2: 93.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_402_1371",
    x1: 24.0986,
    y1: 79.8197,
    x2: 27.4922,
    y2: 106.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_402_1371",
    x1: 11.7222,
    y1: 87.485,
    x2: 36.1796,
    y2: 93.7092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_402_1371",
    x1: 12.6834,
    y1: 92.3337,
    x2: 34.4034,
    y2: 92.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_402_1371",
    x1: 24.0986,
    y1: 78.5599,
    x2: 27.4922,
    y2: 105.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_402_1371",
    x1: 11.7222,
    y1: 86.2252,
    x2: 36.1796,
    y2: 92.4495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_402_1371",
    x1: 12.739,
    y1: 90.9673,
    x2: 34.4591,
    y2: 90.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_402_1371",
    x1: 24.154,
    y1: 77.1928,
    x2: 27.5476,
    y2: 103.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFFABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDF695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAEE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_402_1371",
    x1: 23.9316,
    y1: 83.7236,
    x2: 30.1796,
    y2: 101.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9C922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F8A321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_402_1371",
    x1: 23.5871,
    y1: 84.0968,
    x2: 27.6915,
    y2: 95.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#754904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#855207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C27615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E98C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_402_1371",
    x1: 26.19,
    y1: 79.8373,
    x2: 25.1637,
    y2: 90.9503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F9D422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F8B221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F89C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_402_1371",
    x1: 25.3117,
    y1: 84.8895,
    x2: 25.4454,
    y2: 95.3772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F4B41D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EE9E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EC971A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D18119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AA6019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9B5419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_402_1371",
    x1: 18.7625,
    y1: 87.4478,
    x2: 31.8191,
    y2: 87.4478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FDBB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F9A323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F89521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DE7D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_402_1371",
    x1: 17.7665,
    y1: 35.532,
    x2: 61.6225,
    y2: 71.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_402_1371",
    x1: 60.3725,
    y1: 1.87212,
    x2: 64.0563,
    y2: 12.0435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_402_1371",
    x1: 68.466,
    y1: 10.9987,
    x2: 68.7467,
    y2: 15.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_402_1371",
    x1: 25.5397,
    y1: 40.5642,
    x2: 44.5042,
    y2: 52.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_402_1371",
    x1: 3.33622,
    y1: 89.0966,
    x2: 2.70245,
    y2: 88.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_402_1371",
    x1: 3.17729,
    y1: 88.5362,
    x2: 3.00012,
    y2: 89.0959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_402_1371",
    x1: 3.83885,
    y1: 90.9951,
    x2: 2.62199,
    y2: 90.8931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_402_1371",
    x1: 3.40791,
    y1: 89.5102,
    x2: 3.59486,
    y2: 89.4098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_402_1371",
    x1: 2.58679,
    y1: 101.916,
    x2: 1.23947,
    y2: 101.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_402_1371",
    x1: 3.14717,
    y1: 102.028,
    x2: 1.88761,
    y2: 102.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_402_1371",
    x1: 4.41824,
    y1: 98.393,
    x2: 0.481428,
    y2: 99.1877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#363F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_402_1371",
    x1: 2.37349,
    y1: 89.4041,
    x2: 1.91648,
    y2: 89.3116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEC07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_402_1371",
    x1: 3.06445,
    y1: 87.6001,
    x2: 2.35103,
    y2: 87.9858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_402_1371",
    x1: 4.11958,
    y1: 92.6668,
    x2: -0.510662,
    y2: 94.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_402_1371",
    x1: 5.02642,
    y1: 91.2584,
    x2: 3.73919,
    y2: 92.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_402_1371",
    x1: 4.42656,
    y1: 90.9307,
    x2: 2.02446,
    y2: 93.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_402_1371",
    x1: 138.396,
    y1: 87.6215,
    x2: 91.1426,
    y2: 87.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_402_1371",
    x1: 104.346,
    y1: 96.3872,
    x2: 127.525,
    y2: 96.3872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_402_1371",
    x1: 106.858,
    y1: 87.6617,
    x2: 125.158,
    y2: 98.2287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F8F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E7DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CCB1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_402_1371",
    x1: 116.006,
    y1: 94.6596,
    x2: 116.006,
    y2: 103.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#36BCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#288B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#1B605D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#113D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#092221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#040F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#010303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_402_1371",
    x1: 94.5153,
    y1: 77.501,
    x2: 108.277,
    y2: 79.1948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_402_1371",
    x1: 97.6286,
    y1: 86.3362,
    x2: 133.372,
    y2: 75.6778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.305 79.2723) scale(25.9122 25.9122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F4F2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D7CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A999CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8770B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_402_1371",
    x1: 103.105,
    y1: 65.5993,
    x2: 129.277,
    y2: 80.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_402_1371",
    x1: 103.259,
    y1: 65.6241,
    x2: 129.113,
    y2: 80.5507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_402_1371",
    x1: 103.413,
    y1: 65.6538,
    x2: 128.945,
    y2: 80.3927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_402_1371",
    x1: 103.562,
    y1: 65.6786,
    x2: 128.781,
    y2: 80.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_402_1371",
    x1: 103.716,
    y1: 65.7025,
    x2: 128.613,
    y2: 80.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_402_1371",
    x1: 103.87,
    y1: 65.7301,
    x2: 128.45,
    y2: 79.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_402_1371",
    x1: 104.024,
    y1: 65.7539,
    x2: 128.281,
    y2: 79.7614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_402_1371",
    x1: 104.178,
    y1: 65.7826,
    x2: 128.117,
    y2: 79.6025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_402_1371",
    x1: 104.327,
    y1: 65.8074,
    x2: 127.949,
    y2: 79.4444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_402_1371",
    x1: 104.481,
    y1: 65.8322,
    x2: 127.785,
    y2: 79.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_402_1371",
    x1: 104.635,
    y1: 65.8619,
    x2: 127.617,
    y2: 79.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_402_1371",
    x1: 106.868,
    y1: 64.1927,
    x2: 129.253,
    y2: 77.1175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_402_1371",
    x1: 107.132,
    y1: 64.3896,
    x2: 128.926,
    y2: 76.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_402_1371",
    x1: 107.392,
    y1: 64.5817,
    x2: 128.593,
    y2: 76.8232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_402_1371",
    x1: 107.657,
    y1: 64.7786,
    x2: 128.266,
    y2: 76.6785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_402_1371",
    x1: 107.921,
    y1: 64.9707,
    x2: 127.939,
    y2: 76.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_402_1371",
    x1: 108.181,
    y1: 65.1678,
    x2: 127.612,
    y2: 76.3844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_402_1371",
    x1: 108.446,
    y1: 65.3667,
    x2: 127.285,
    y2: 76.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_402_1371",
    x1: 108.711,
    y1: 65.5588,
    x2: 126.953,
    y2: 76.0969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_402_1371",
    x1: 108.971,
    y1: 65.7557,
    x2: 126.626,
    y2: 75.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_402_1371",
    x1: 109.235,
    y1: 65.9527,
    x2: 126.298,
    y2: 75.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_402_1371",
    x1: 109.5,
    y1: 66.1458,
    x2: 125.971,
    y2: 75.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.457 79.8236) scale(6.84255)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6115A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#5A1399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2B0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_402_1371",
    x1: 123.252,
    y1: 86.4312,
    x2: 136.913,
    y2: 88.1057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.667 84.7326) scale(9.64309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F4F2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D7CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A999CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8770B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-295.932 334.365) rotate(-31.14) scale(2.32166 5.27079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-302.985 277.201) rotate(-24.37) scale(2.42314 5.50118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#481437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3D112E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.2274 83.4669) rotate(-13.98) scale(3.62569 15.7639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8C276B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#671C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#471336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D0C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#180613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0A0308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#020001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.963 57.1714) scale(25.3348 25.3348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D6BDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C3A4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A07BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A27BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#AD84CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AD83CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A47DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F79C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_402_1371",
    x1: 99.8468,
    y1: 63.3973,
    x2: 117.608,
    y2: 63.3973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_402_1371",
    x1: 107.272,
    y1: 70.3215,
    x2: 110.64,
    y2: 57.4497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F8F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E7DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CCB1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_402_1371",
    x1: 111.27,
    y1: 50.1699,
    x2: 121.197,
    y2: 50.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_402_1371",
    x1: 112.276,
    y1: 46.0308,
    x2: 120.254,
    y2: 50.6358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F8F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E7DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CCB1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_402_1371",
    x1: 115.519,
    y1: 44.9185,
    x2: 117.001,
    y2: 44.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.731 41.1422) scale(2.9882)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D6BDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C3A4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A07BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A27BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#AD84CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AD83CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A47DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F79C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.454 56.9349) scale(12.2127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.89 61.3839) scale(4.72049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#34B5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#247E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#17514E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0D2D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#051413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#010505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_402_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.256 65.7323) scale(4.72049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#34B5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#247E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#17514E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0D2D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#051413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#010505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_402_1371",
    x1: 132.124,
    y1: 63.7478,
    x2: 102.7,
    y2: 66.0739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_402_1371",
    x1: 108.763,
    y1: 62.4885,
    x2: 77.6293,
    y2: 63.9116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_402_1371",
    x1: 136.121,
    y1: 65.7584,
    x2: 104.136,
    y2: 66.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_402_1371",
    x1: 141.422,
    y1: 66.3562,
    x2: 108.521,
    y2: 65.7429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_402_1371",
    x1: 124.38,
    y1: 66.8173,
    x2: 90.4725,
    y2: 65.1226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_402_1371",
    x1: 134.218,
    y1: 67.9326,
    x2: 99.9121,
    y2: 65.1515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_402_1371",
    x1: 121.783,
    y1: 68.7633,
    x2: 86.9818,
    y2: 64.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_402_1371",
    x1: 136.395,
    y1: 69.4528,
    x2: 101.732,
    y2: 64.4988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_402_1371",
    x1: 128.77,
    y1: 70.2953,
    x2: 94.1611,
    y2: 64.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_402_1371",
    x1: 123.625,
    y1: 71.1556,
    x2: 89.3407,
    y2: 64.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_402_1371",
    x1: 145.454,
    y1: 70.7948,
    x2: 112.127,
    y2: 62.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_402_1371",
    x1: 145.175,
    y1: 71.2515,
    x2: 112.716,
    y2: 62.5568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_402_1371",
    x1: 123.085,
    y1: 73.8518,
    x2: 91.4373,
    y2: 64.3554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_402_1371",
    x1: 127.705,
    y1: 73.6175,
    x2: 97.4747,
    y2: 63.5429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_402_1371",
    x1: 134.699,
    y1: 73.3634,
    x2: 106.134,
    y2: 62.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_402_1371",
    x1: 120.225,
    y1: 75.9806,
    x2: 93.2803,
    y2: 65.1605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_402_1371",
    x1: 131.697,
    y1: 74.2875,
    x2: 106.899,
    y2: 63.4296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_402_1371",
    x1: 122.034,
    y1: 76.4693,
    x2: 99.3406,
    y2: 65.6841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_402_1371",
    x1: 137.556,
    y1: 73.1506,
    x2: 117.396,
    y2: 62.7747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_402_1371",
    x1: 132.285,
    y1: 74.4622,
    x2: 114.604,
    y2: 64.6406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_402_1371",
    x1: 106.763,
    y1: 80.2724,
    x2: 91.5356,
    y2: 71.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_402_1371",
    x1: 127.97,
    y1: 75.0401,
    x2: 115.558,
    y2: 67.0402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.85119451340d377946ed3ab24004ed6e.svg";
export { ForwardRef as ReactComponent };